(() => {
    const root = document.getElementById("single-multi-builder-root");
    if (!root) return;

    // ============================================================
    // CONFIG
    // ============================================================
    const CONFIG = {

        // ---- SINGLE-ZONE BUNDLES ----
        // Each entry: { handle, voltages: ['115', '230'] }
        // Single-zone adds one bundle product (includes 15ft line set)
        // + optional line set upgrade if user wants longer run
        singleZone: {
            king: {
                label: "King Series",
                preorder: false,
                wallSizes: [9000, 12000, 18000, 24000, 30000, 36000],
                cassetteSizes: [],
                bundleHandle: {
                    9000: {
                        115: root.dataset.kingSzBundle9k115Handle || "gwin-9-000-btu-20-5-seer2-115v-king-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire",
                        230: root.dataset.kingSzBundle9k230Handle || "gwin-9-000-btu-20-5-seer2-230v-king-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    12000: {
                        115: root.dataset.kingSzBundle12k115Handle || "gwin-12-000-btu-19-seer2-115v-king-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire",
                        230: root.dataset.kingSzBundle12k230Handle || "gwin-12-000-btu-19-seer2-230v-king-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    18000: {
                        230: root.dataset.kingSzBundle18k230Handle || "gwin-18-000-btu-20-seer2-230v-king-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    24000: {
                        230: root.dataset.kingSzBundle24k230Handle || "gwin-24-000-btu-19-seer2-230v-king-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    30000: {
                        230: root.dataset.kingSzBundle30k230Handle || "gwin-30-000-btu-22-seer2-230v-king-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    36000: {
                        230: root.dataset.kingSzBundle36k230Handle || "gwin-36-000-btu-21-seer2-230v-king-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                },
                features: [{
                        icon: "❄️",
                        text: "Heats down to -13°F"
                    },
                    {
                        icon: "⚡",
                        text: "Variable & low voltage start"
                    },
                    {
                        icon: "🔵",
                        text: "Blue fin coil (indoor & outdoor)"
                    },
                ],
            },
            emperor: {
                label: "Emperor Series",
                preorder: false,
                wallSizes: [9000, 12000, 18000, 24000],
                cassetteSizes: [9000, 12000, 18000],
                bundleHandle: {
                    9000: {
                        230: root.dataset.emperorSzBundle9k230Handle || "gwin-9-000-btu-26-seer2-230v-emperor-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    12000: {
                        230: root.dataset.emperorSzBundle12k230Handle || "gwin-12-000-btu-24-5-seer2-230v-emperor-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    18000: {
                        230: root.dataset.emperorSzBundle18k230Handle || "gwin-18-000-btu-24-5-seer2-230v-emperor-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    24000: {
                        230: root.dataset.emperorSzBundle24k230Handle || "gwin-24-000-btu-26-seer2-230v-emperor-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                },
                // Cassette bundles are separate products
                cassetteBundleHandle: {
                    9000: {
                        230: root.dataset.emperorSzCassette9k230Handle || "gwin-9-000-btu-26-seer2-230v-emperor-single-zone-cassette-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    12000: {
                        230: root.dataset.emperorSzCassette12k230Handle || "gwin-12-000-btu-24-5-seer2-230v-emperor-single-zone-casssette-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    18000: {
                        230: root.dataset.emperorSzCassette18k230Handle || "gwin-18-000-btu-24-5-seer2-230v-emperor-single-zone-cassette-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                },
                features: [{
                        icon: "❄️",
                        text: "Heats down to -22°F"
                    },
                    {
                        icon: "⚡",
                        text: "Variable & low voltage start"
                    },
                    {
                        icon: "🟡",
                        text: "Gold fin coil (outdoor)"
                    },
                    {
                        icon: "🔔",
                        text: "Dirty filter alert"
                    },
                ],
            },
            coastal: {
                label: "Coastal Series",
                preorder: false,
                wallSizes: [9000, 12000, 18000, 24000, 36000],
                cassetteSizes: [],
                // Coastal uses consolidated products — variant matched by option (btu+voltage)
                bundleHandle: {
                    9000: {
                        115: root.dataset.coastalSzBundle9k115Handle || "gwin-9-000-btu-25-seer2-115v-single-zone-ductless-mini-split-complete-system",
                        230: root.dataset.coastalSzBundle9k230Handle || "gwin-9-000-btu-25-seer2-230v-single-zone-ductless-mini-split-complete-system"
                    },
                    12000: {
                        115: root.dataset.coastalSzBundle12k115Handle || "gwin-12-000-btu-25-seer2-115v-single-zone-ductless-mini-split-complete-system",
                        230: root.dataset.coastalSzBundle12k230Handle || "gwin-12-000-btu-25-seer2-230v-single-zone-ductless-mini-split-complete-system"
                    },
                    18000: {
                        230: root.dataset.coastalSzBundle18k230Handle || "gwin-18-000-btu-25-seer2-230v-single-zone-ductless-mini-split-complete-system"
                    },
                    24000: {
                        230: root.dataset.coastalSzBundle24k230Handle || "gwin-single-zone-compete-system-seer-25"
                    },
                    36000: {
                        230: root.dataset.coastalSzBundle36k230Handle || "gwin-36k-btu-230-v-seer20-single-zone-complete-system"
                    },
                },
                features: [{
                        icon: "❄️",
                        text: "Heats down to -22°F"
                    },
                    {
                        icon: "⚡",
                        text: "Variable & low voltage start"
                    },
                    {
                        icon: "🟡",
                        text: "Gold fin coil (indoor & outdoor)"
                    },
                    {
                        icon: "✨",
                        text: "Self-cleaning"
                    },
                ],
            },
            cleanair: {
                label: "Clean Air Series",
                preorder: true,
                wallSizes: [9000, 12000, 18000, 24000],
                cassetteSizes: [9000, 12000, 18000],
                // Clean Air shares Emperor handles for now
                bundleHandle: {
                    9000: {
                        230: root.dataset.cleanairSzBundle9k230Handle || "gwin-9-000-btu-26-seer2-230v-emperor-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    12000: {
                        230: root.dataset.cleanairSzBundle12k230Handle || "gwin-12-000-btu-24-5-seer2-230v-emperor-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    18000: {
                        230: root.dataset.cleanairSzBundle18k230Handle || "gwin-18-000-btu-24-5-seer2-230v-emperor-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    24000: {
                        230: root.dataset.cleanairSzBundle24k230Handle || "gwin-24-000-btu-26-seer2-230v-emperor-single-zone-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                },
                cassetteBundleHandle: {
                    9000: {
                        230: root.dataset.cleanairSzCassette9k230Handle || "gwin-9-000-btu-26-seer2-230v-emperor-single-zone-cassette-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    12000: {
                        230: root.dataset.cleanairSzCassette12k230Handle || "gwin-12-000-btu-24-5-seer2-230v-emperor-single-zone-casssette-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                    18000: {
                        230: root.dataset.cleanairSzCassette18k230Handle || "gwin-18-000-btu-24-5-seer2-230v-emperor-single-zone-cassette-ductless-mini-split-complete-system-with-15-foot-line-set-and-communication-wire"
                    },
                },
                features: [{
                        icon: "❄️",
                        text: "Heats down to -22°F"
                    },
                    {
                        icon: "⚡",
                        text: "Variable & low voltage start"
                    },
                    {
                        icon: "🟡",
                        text: "Gold fin coil (outdoor)"
                    },
                    {
                        icon: "✨",
                        text: "Self-cleaning"
                    },
                    {
                        icon: "🔔",
                        text: "Dirty filter alert"
                    },
                    {
                        icon: "🌿",
                        text: "Clean air intake"
                    },
                ],
            },
        },

        // ---- MULTI-ZONE ----
        multiZone: {
            series: {
                king: {
                    label: "King Series",
                    preorder: false,
                    wallHandleByBtu: {
                        7000: root.dataset.kingWall7kHandle || "gwin-07-000-btu-230v-king-multi-zone-ductless-wall-mount-air-handler",
                        9000: root.dataset.kingWall9kHandle || "gwin-9-000-btu-230v-king-single-and-multi-zone-ductless-wall-mount-air-handler",
                        12000: root.dataset.kingWall12kHandle || "gwin-12-000-btu-230v-king-single-and-multi-zone-ductless-wall-mount-air-handler",
                        18000: root.dataset.kingWall18kHandle || "gwin-18-000-btu-230v-king-single-and-multi-zone-ductless-wall-mount-air-handler",
                        24000: root.dataset.kingWall24kHandle || "gwin-24-000-btu-230v-king-single-and-multi-zone-ductless-wall-mount-air-handler",
                        30000: root.dataset.kingWall30kHandle || "gwin-30-000-btu-230v-king-single-and-multi-zone-ductless-wall-mount-air-handler",
                        36000: root.dataset.kingWall36kHandle || "gwin-36-000-btu-230v-king-single-and-multi-zone-ductless-wall-mount-air-handler",
                    },
                    cassetteHandleByBtu: {
                        9000: root.dataset.slimCassette9kHandle || "gwin-09-000-btu-230v-emperor-and-multi-zone-slim-cassette",
                        12000: root.dataset.slimCassette12kHandle || "gwin-12-000-btu-230v-emperor-and-multi-zone-slim-cassette",
                        20000: root.dataset.slimCassette20kHandle || "gwin-20-000-btu-230v-emperor-and-multi-zone-slim-cassette",
                    },
                    wallSizes: [7000, 9000, 12000, 18000, 24000, 30000, 36000],
                    cassetteSizes: [9000, 12000, 20000],
                    features: [{
                            icon: "❄️",
                            text: "Heats down to -22°F"
                        },
                        {
                            icon: "⚡",
                            text: "Variable & low voltage start"
                        },
                        {
                            icon: "🔵",
                            text: "Gold fin coil (indoor & outdoor)"
                        },
                    ],
                },
                emperor: {
                    label: "Emperor Series",
                    preorder: false,
                    wallHandleByBtu: {
                        9000: root.dataset.emperorWall9kHandle || "gwin-09-000-btu-230v-emperor-single-and-multi-zone-ductless-wall-mount-air-handler",
                        12000: root.dataset.emperorWall12kHandle || "gwin-12-000-btu-230v-emperor-single-and-multi-zone-ductless-wall-mount-air-handler",
                        18000: root.dataset.emperorWall18kHandle || "gwin-18-000-btu-230v-emperor-single-and-multi-zone-ductless-wall-mount-air-handler",
                        24000: root.dataset.emperorWall24kHandle || "gwin-24-000-btu-230v-emperor-single-and-multi-zone-ductless-wall-mount-air-handler",
                    },
                    cassetteHandleByBtu: {
                        9000: root.dataset.slimCassette9kHandle || "gwin-09-000-btu-230v-emperor-and-multi-zone-slim-cassette",
                        12000: root.dataset.slimCassette12kHandle || "gwin-12-000-btu-230v-emperor-and-multi-zone-slim-cassette",
                        20000: root.dataset.slimCassette20kHandle || "gwin-20-000-btu-230v-emperor-and-multi-zone-slim-cassette",
                    },
                    wallSizes: [9000, 12000, 18000, 24000],
                    cassetteSizes: [9000, 12000, 20000],
                    features: [{
                            icon: "❄️",
                            text: "Heats down to -22°F"
                        },
                        {
                            icon: "⚡",
                            text: "Variable & low voltage start"
                        },
                        {
                            icon: "🟡",
                            text: "Gold fin coil (outdoor)"
                        },
                        {
                            icon: "🔔",
                            text: "Dirty filter alert"
                        },
                    ],
                },
                coastal: {
                    label: "Coastal Series",
                    preorder: false,
                    wallHandle: root.dataset.coastalWallHandle || "gwin-air-handlers",
                    cassetteHandle: root.dataset.coastalCassetteHandle || "gwin-multi-zone-cassette",
                    wallSizes: [7000, 9000, 12000, 18000, 24000],
                    cassetteSizes: [9000, 12000, 18000, 24000],
                    features: [{
                            icon: "❄️",
                            text: "Heats down to -22°F"
                        },
                        {
                            icon: "⚡",
                            text: "Variable & low voltage start"
                        },
                        {
                            icon: "🟡",
                            text: "Gold fin coil (indoor & outdoor)"
                        },
                        {
                            icon: "✨",
                            text: "Self-cleaning"
                        },
                    ],
                },
                cleanair: {
                    label: "Clean Air Series",
                    preorder: true,
                    wallHandle: root.dataset.cleanairWallHandle || "gwin-air-handlers",
                    cassetteHandle: root.dataset.cleanairCassetteHandle || "gwin-multi-zone-cassette",
                    wallSizes: [9000, 12000, 18000, 24000],
                    cassetteSizes: [9000, 12000, 18000, 24000],
                    features: [{
                            icon: "❄️",
                            text: "Heats down to -22°F"
                        },
                        {
                            icon: "⚡",
                            text: "Variable & low voltage start"
                        },
                        {
                            icon: "🟡",
                            text: "Gold fin coil (outdoor)"
                        },
                        {
                            icon: "✨",
                            text: "Self-cleaning"
                        },
                        {
                            icon: "🔔",
                            text: "Dirty filter alert"
                        },
                        {
                            icon: "🌿",
                            text: "Clean air intake"
                        },
                    ],
                },
            },
            condensers: [{
                    btu: 18000,
                    zones: 2,
                    zonesLabel: "2-Zone",
                    handle: root.dataset.condenser18kHandle || "gwin-king-22-18k-2-zone-multi-condenser",
                    preorder: false
                },
                {
                    btu: 24000,
                    zones: 3,
                    zonesLabel: "2-3 Zone",
                    handle: root.dataset.condenser24kHandle || "gwin-king-22-24k-3-zone-multi-condenser",
                    preorder: false
                },
                {
                    btu: 30000,
                    zones: 4,
                    zonesLabel: "2-4 Zone",
                    handle: root.dataset.condenser30kHandle || "gwin-king-22-30k-4-zone-multi-condenser",
                    preorder: false
                },
                {
                    btu: 36000,
                    zones: 4,
                    zonesLabel: "2-4 Zone",
                    handle: root.dataset.condenser36kHandle || "gwin-king-22-36k-4-zone-multi-condenser",
                    preorder: false
                },
                {
                    btu: 42000,
                    zones: 5,
                    zonesLabel: "2-5 Zone",
                    handle: root.dataset.condenser42kHandle || "gwin-king-22-42k-5-zone-multi-condenser",
                    preorder: false
                },
                {
                    btu: 48000,
                    zones: 5,
                    zonesLabel: "2-5 Zone",
                    handle: root.dataset.condenser48kHandle || "gwin-king-22-48k-5-zone-multi-condenser",
                    preorder: false
                },
                {
                    btu: 60000,
                    zones: 6,
                    zonesLabel: "2-6 Zone",
                    handle: root.dataset.condenser60kHandle || "gwin-king-22-60k-6-zone-multi-condenser",
                    preorder: true
                },
            ],
        },

        // ---- LINE SETS (multi-zone — flareless) ----
        linesets: {
            small: root.dataset.linesetSmallHandle || "flareless-1-4-x-3-8-gwin-line-set-for-7k-9k-12k-btu-ductless-mini-split-air-handlers",
            medium: root.dataset.linesetMediumHandle || "flareless-1-4-x-1-2-gwin-line-set-for-18k-btu-ductless-mini-split-air-handlers",
            large: root.dataset.linesetLargeHandle || "flareless-1-4-x-5-8-gwin-line-set-for-24k-36k-btu-ductless-mini-split-air-handlers",
        },

        // ---- SINGLE-ZONE LINE SET UPGRADE (one product, length variants) ----
        szLinesetUpgradeHandle: root.dataset.szLinesetUpgradeHandle || "line-set-upgrades",

        // ---- ACCESSORIES ----
        accessories: {
            lineguard: root.dataset.lineguardHandle || "gwin-line-covers",
            condenserPad: root.dataset.condenserPadHandle || "condenser-pad",
            groundStand: root.dataset.groundStandHandle || "condenser-ground-brackets",
            wallBracket: root.dataset.wallBracketHandle || "wall-mounting-bracket-18k-36k-condensers",
            disconnect: root.dataset.disconnectHandle || "disconnect-switch-and-electrical-whip-with-10-awg-for-gwin-12k-18k-27k-condenser",
        },

        // Wall bracket only for these condenser BTUs
        wallBracketCondenserBtus: [18000, 24000, 30000, 36000],

        linesetKeyByBtu: {
            7000: "small",
            9000: "small",
            12000: "small",
            18000: "medium",
            20000: "medium",
            24000: "large",
            30000: "large",
            36000: "large",
        },

        // Single-zone: bundles include 15ft. Extra lengths available as upgrades.
        szLineLengths: [15, 25, 35, 50, 65, 75, 85, 100],
        // Multi-zone line lengths
        mzLineLengths: [15, 25, 35, 50, 65, 75, 85, 100],

        // Sizing
        singleBands: [{
                max: 225,
                btu: 9000
            },
            {
                max: 350,
                btu: 12000
            },
            {
                max: 500,
                btu: 18000
            },
            {
                max: 750,
                btu: 24000
            },
            {
                max: 1000,
                btu: 30000
            },
            {
                max: 1550,
                btu: 36000
            },
        ],
        multiBands: [{
                max: 225,
                btu: 7000
            },
            {
                max: 300,
                btu: 9000
            },
            {
                max: 450,
                btu: 12000
            },
            {
                max: 700,
                btu: 18000
            },
            {
                max: 1000,
                btu: 24000
            },
            {
                max: 1400,
                btu: 30000
            },
            {
                max: 1550,
                btu: 36000
            },
        ],
        condenserOverageAllowance: 6000,
        bias: 0.90,
        maxEffSqft: 1550,
        defaultLineLen: 15,
    };

    // ============================================================
    // STATE
    // ============================================================
    let state = {
        mode: "single", // "single" | "multi"
        series: "king",
        voltage: "230", // "115" | "230"
        // Single zone
        single: {
            len: 0,
            wid: 0,
            height: 0,
            type: null,
            size: null,
            lineLen: 15,
            lineGuard: false,
            mount: "", // "" | "wall" | "ground"
            condenserPad: false,
            disconnect: false,
        },
        // Multi zone
        cap: 4,
        savedSystems: [],
        rooms: [{
                label: "Room 1",
                len: 0,
                wid: 0,
                height: 0,
                type: null,
                size: null,
                lineLen: CONFIG.defaultLineLen,
                lineGuard: ""
            },
            {
                label: "Room 2",
                len: 0,
                wid: 0,
                height: 0,
                type: null,
                size: null,
                lineLen: CONFIG.defaultLineLen,
                lineGuard: ""
            },
        ],
        mzAccessories: {
            mount: "",
            condenserPad: false,
            disconnect: false,
        },
    };

    let editingLabel = null;
    let editingIndex = -1;

    function setEditingMode(label, index = -1) {
        editingLabel = label;
        editingIndex = index;
        document.getElementById("gwin-builder").classList.add("gb-editing-mode");
    }

    function clearEditingMode() {
        editingLabel = null;
        editingIndex = -1;
        document.getElementById("gwin-builder").classList.remove("gb-editing-mode");
    }

    let renderToken = 0;

    function debounce(fn, ms) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn(...args), ms);
        };
    }
    const debouncedRender = debounce(() => render(), 300);
    const CONFIG_KEY = "gwin_builder_config";
    const SESSION_KEY = "gwin_builder_session";

    function saveState() {
        try {
            // Config persists across reloads
            localStorage.setItem(CONFIG_KEY, JSON.stringify({
                mode: state.mode,
                series: state.series,
                voltage: state.voltage,
                single: {
                    ...state.single
                },
                cap: state.cap,
                rooms: state.rooms.map(r => ({
                    ...r
                })),
                mzAccessories: {
                    ...state.mzAccessories
                },
            }));
            // Saved systems only persist within the tab session
            sessionStorage.setItem(SESSION_KEY, JSON.stringify({
                savedSystems: state.savedSystems,
            }));
        } catch {}
    }

    function loadState() {
        try {
            const config = localStorage.getItem(CONFIG_KEY);
            if (config) {
                const saved = JSON.parse(config);
                if (saved.mode) state.mode = saved.mode;
                if (saved.series) state.series = saved.series;
                if (saved.voltage) state.voltage = saved.voltage;
                if (saved.single) state.single = {
                    ...state.single,
                    ...saved.single
                };
                if (saved.cap) state.cap = saved.cap;
                if (Array.isArray(saved.rooms) && saved.rooms.length) state.rooms = saved.rooms;
                if (saved.mzAccessories) {
                    state.mzAccessories = {
                        ...state.mzAccessories,
                        ...saved.mzAccessories
                    };
                }
            }
            if (Array.isArray(state.savedSystems)) {
                state.savedSystems.forEach(sys => {
                    if (sys.mode === "large-single" && Array.isArray(sys.units)) {
                        sys.units.forEach(unit => {
                            if ((unit.condenserPad === true || unit.condenserPad === "yes") && !unit.mount) {
                                unit.mount = "pad";
                            }
                            unit.condenserPad = false;
                        });
                    }

                    if (sys.mzAccessories?.condenserPad && !sys.mzAccessories.mount) {
                        sys.mzAccessories.mount = "pad";
                        sys.mzAccessories.condenserPad = false;
                    }

                    if (sys.single?.condenserPad && !sys.single.mount) {
                        sys.single.mount = "pad";
                        sys.single.condenserPad = false;
                    }
                });
            }
            const session = sessionStorage.getItem(SESSION_KEY);
            if (session) {
                const saved = JSON.parse(session);
                if (Array.isArray(saved.savedSystems)) state.savedSystems = saved.savedSystems;
            }
        } catch {}
    }
    // ============================================================
    // INJECT HTML + CSS
    // ============================================================
    root.innerHTML = `
<style>
  #gwin-builder {
    --c-brand:    #761d7d;
    --c-dark:     #1A0530;
    --c-mid:      #3D0F6B;
    --c-muted:    #888;
    --c-border:   #e0e0e0;
    --c-surface:  #f9f9f9;
    --c-white:    #ffffff;
    --c-preorder: #d97706;
    --radius-sm:  8px;
    --radius-md:  12px;
    --radius-lg:  16px;
    --radius-pill:999px;
    font-family: 'Barlow', 'Barlow Condensed', system-ui, -apple-system, sans-serif;
    max-width: 680px;
    margin: 0 auto;
    padding: 16px;
    box-sizing: border-box;
    color: var(--c-dark);
  }
  #gwin-builder *, #gwin-builder *::before, #gwin-builder *::after { box-sizing: border-box; }

  .gb-title { font-size: 28px; font-weight: 800; letter-spacing: -.5px; margin: 0 0 4px; }
  .gb-subtitle { font-size: 14px; color: var(--c-muted); margin: 0 0 20px; }
  .gb-section-label { font-size: 11px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; color: var(--c-muted); margin: 0 0 8px; }

  /* ---- Mode toggle ---- */
  .gb-mode-toggle {
    display: flex;
    background: var(--c-surface);
    border: 1.5px solid var(--c-border);
    border-radius: var(--radius-pill);
    padding: 4px;
    margin-bottom: 24px;
    gap: 4px;
  }
  .gb-mode-btn {
    flex: 1;
    padding: 10px 16px;
    border: none;
    border-radius: var(--radius-pill);
    background: transparent;
    font-size: 14px;
    font-weight: 700;
    font-family: inherit;
    cursor: pointer;
    color: var(--c-muted);
    transition: background .15s, color .15s;
    text-align: center;
  }
  .gb-mode-btn.active {
    background: var(--c-dark);
    color: var(--c-white);
  }

  /* ---- Series grid ---- */
  .gb-series-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 20px;
  }
  .gb-series-btn {
    border: 2px solid var(--c-border);
    border-radius: var(--radius-md);
    padding: 12px 12px 10px;
    background: var(--c-white);
    cursor: pointer;
    text-align: left;
    transition: border-color .15s, background .15s;
  }
  .gb-series-btn:hover { border-color: var(--c-dark); }
  .gb-series-btn.active { border-color: var(--c-brand); background: var(--c-brand); color: #ffffff; }
  .gb-series-btn .series-name { font-size: 16px; font-weight: 700; display: block; }
  .gb-series-btn .series-tag { font-size: 11px; color: var(--c-muted); margin-top: 2px; display: block; }
  .gb-preorder-dot { display: inline-block; width: 8px; height: 8px; background: var(--c-preorder); border-radius: 50%; margin-left: 6px; vertical-align: middle; }
  .gb-preorder-badge { display: inline-block; font-size: 10px; font-weight: 700; background: var(--c-preorder); color: white; padding: 7px 7px; border-radius: var(--radius-pill); letter-spacing: .5px; text-transform: uppercase; }

  /* ---- Voltage radio ---- */
  .gb-voltage-row {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  .gb-voltage-label {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 10px 10px 0;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: border-color .15s, background .15s;
    user-select: none;
  }
  .gb-voltage-label input[type="radio"] { width: 16px; height: 16px; accent-color: var(--c-brand); cursor: pointer; }


  /* ---- Field ---- */
  .gb-field { display: flex; flex-direction: column; gap: 5px; }
  .gb-field label { font-size: 11px; font-weight: 700; letter-spacing: .5px; text-transform: uppercase; color: var(--c-muted); }
  .gb-field input, .gb-field select, .gb-select {
    width: 100%; padding: 10px 12px;
    border: 1.5px solid var(--c-border); border-radius: var(--radius-sm);
    font-size: 14px; font-family: inherit; background: var(--c-white); color: var(--c-dark);
    appearance: none; -webkit-appearance: none; outline: none; transition: border-color .15s;
  }
  .gb-field input:focus, .gb-field select:focus { border-color: var(--c-brand); }

  /* ---- Single zone dims ---- */
  .gb-sz-dims { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px; margin-bottom: 8px; }
.gb-sz-opts { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 8px; }
  /* ---- Room card ---- */
  .gb-room-card { border: 1.5px solid var(--c-border); border-radius: var(--radius-md); padding: 14px; margin-bottom: 10px; background: var(--c-white); }
  .gb-room-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
  .gb-room-name { font-size: 14px; font-weight: 700; }
  .gb-room-dims { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px; margin-bottom: 8px; }
.gb-room-opts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.gb-room-opts + .gb-room-opts {
  margin-top: 8px;
}  .gb-room-hint { margin-top: 8px; font-size: 11px; color: var(--c-muted); }
  .gb-room-hint strong { color: var(--c-dark); }

  /* ---- Cap row ---- */
  .gb-cap-row { display: flex; align-items: center; gap: 10px; margin-bottom: 16px; }
  .gb-cap-row .gb-field { flex: 0 0 160px; }

  /* ---- Buttons ---- */
  .gb-remove-btn { font-size: 12px; height: 36px; padding: 4px 10px; border: 1.5px solid var(--c-border); border-radius: 8px; background: var(--c-white); cursor: pointer; color: var(--c-mid); transition: border-color .15s, color .15s; }
  .gb-remove-btn:hover { border-color: var(--c-brand); color: var(--c-brand); height: 36px;}
  .gb-action-row { display: flex; gap: 8px; margin: 12px 0; flex-wrap: wrap; }
  .gb-btn { padding: 8px 16px; border-radius: var(--radius-sm); border: 1.5px solid var(--c-border); background: var(--c-white); font-size: 16px; font-weight: 700; font-family: inherit; cursor: pointer; color: var(--c-dark); transition: border-color .15s, background .15s, color .15s; }
  .gb-btn:hover { border-color: var(--c-dark); }
  .gb-btn-dark { background: var(--c-dark); border-color: var(--c-dark); color: white; }
  .gb-btn-dark:hover { background: #333; border-color: #333; }
  .gb-btn:disabled { opacity: .45; cursor: not-allowed; }

  /* ---- Results ---- */
  .gb-results { margin-top: 24px; border: 2px solid var(--c-dark); border-radius: var(--radius-lg); padding: 18px; background: var(--c-white); }
  .gb-results-header { display: flex; align-items: baseline; gap: 10px; margin-bottom: 4px; }
  .gb-btu-big { font-size: 42px; font-weight: 900; letter-spacing: -1px; line-height: 1; }
  .gb-btu-unit { font-size: 15px; font-weight: 700; color: var(--c-muted); }
  .gb-kw { font-size: 13px; color: var(--c-muted); margin-bottom: 14px; }
  .gb-room-summary { margin: 0 0 14px; }
  .gb-room-summary-row { display: flex; justify-content: space-between; font-size: 13px; padding: 5px 0; border-bottom: 1px solid var(--c-border); gap: 8px; }
  .gb-room-summary-row:last-child { border-bottom: none; }
  .gb-room-summary-row .room-label { font-weight: 600; }
  .gb-room-summary-row .room-detail { color: var(--c-muted); font-size: 14px; }
  .gb-room-summary-row.error { color: var(--c-brand); }
  .gb-condenser-rec { background: var(--c-surface); border-radius: var(--radius-sm); padding: 10px 12px; font-size: 14px; font-weight: 700; margin-bottom: 14px; display: flex; align-items: center; justify-content: space-between; gap: 8px; }
  .gb-condenser-rec .cond-warning { font-size: 14px; font-weight: 400; color: var(--c-preorder); }
  .gb-features { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 16px; }
  .gb-feature-chip { display: inline-flex; align-items: center; gap: 5px; font-size: 12px; padding: 4px 10px; border-radius: var(--radius-pill); background: var(--c-surface); border: 1px solid var(--c-border); }
  .gb-parts { margin: 0 0 16px; }
  .gb-part-row { display: flex; justify-content: space-between; font-size: 14px; padding: 4px 0; color: var(--c-mid); border-bottom: 1px dotted var(--c-border); gap: 8px; }
  .gb-part-row:last-child { border-bottom: none; }
  .gb-error-block { background: #fff5f5; border: 1.5px solid #fca5a5; border-radius: var(--radius-sm); padding: 10px 12px; font-size: 13px; color: #b91c1c; margin-bottom: 12px; }
  #gbAddToCart, #gbAddBundle { width: 100%; margin-top: 4px; }
  #gbCartMsg, #gbBundleMsg { margin-top: 10px; font-size: 12px; color: var(--c-muted); min-height: 16px; }

  /* ---- Responsive ---- */
  @media (max-width: 500px) {
    .gb-sz-dims, .gb-sz-opts, .gb-room-dims, .gb-room-opts { grid-template-columns: 1fr 1fr; }
    .gb-series-grid { grid-template-columns: 1fr 1fr; }
    .gb-btu-big { font-size: 34px; }
    .gb-action-row { flex-direction: column; }
    .gb-btn { width: 100%; text-align: center; padding: 8px 16px; font-size: 16px; }
    .gb-voltage-label { justify-content: center; }
  }
  @media (max-width: 360px) {
    .gb-sz-dims, .gb-sz-opts, .gb-room-dims, .gb-room-opts { grid-template-columns: 1fr; }
  }
    .gb-part-row .part-price { font-weight: 700; color: var(--c-dark); white-space: nowrap; align-items: flex-end;
    display: flex; }
.gb-part-row.part-total { font-size: 14px; font-weight: 800; color: var(--c-dark); border-top: 2px solid var(--c-dark); border-bottom: none; margin-top: 4px; padding-top: 8px; }
.gb-part-row.part-total .part-price { color: var(--c-brand); font-size: 16px; }
.gb-condenser-rec .cond-price { font-size: 18px; font-weight: 900; color: var(--c-brand); white-space: nowrap; }
.gb-condenser-rec .cond-loading {     font-size: 16px; font-weight: 400; color: var(--c-muted); }
/* prices */
.gb-price-original { text-decoration: line-through; color: var(--c-muted); font-weight: 400; font-size: 14px; margin-right: 4px; }
.gb-price-discounted { font-weight: 700; color: var(--c-dark); }
.gb-discount-badge { display: inline-block; font-size: 10px; font-weight: 700; background: #dcfce7; color: #166534; padding: 1px 6px; border-radius: var(--radius-pill); margin-left: 4px; }

.gb-condenser-rec .cond-price .gb-price-original {
      font-size: 16px;
  vertical-align: middle;
}

.gb-condenser-rec .cond-price .gb-price-discounted {
  color: var(--c-brand);
}
  .gb-rec-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.gb-rec-img {
  width: 100px;
  height: 100px;
  border-radius: var(--radius-sm);
  object-fit: cover;
  background: var(--c-surface);
  border: 1px solid var(--c-border);
  flex: 0 0 54px;
}

.gb-rec-text {
  min-width: 0;
}

.gb-rec-price-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
  @media (max-width: 500px) {
  .gb-rec-img {
    width: 46px;
    height: 46px;
    flex-basis: 46px;
  }

  .gb-rec-price-wrap {
    flex-direction: column;
    align-items: flex-end;
    gap: 0;
  }
}
  

#gwin-builder #szType:has(option[value=""]:checked),
#gwin-builder [data-k="type"]:has(option[value=""]:checked) {
  color: var(--c-muted);}
  #gwin-builder.gb-editing-mode {
  border: 2px solid var(--c-brand);
  border-radius: var(--radius-lg);
  padding: 16px;
}
.gb-edit-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--c-brand);
  color: white;
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  margin-bottom: 20px;
  font-size: 13px;
  font-weight: 700;
}
.gb-edit-banner-label { font-size: 15px; }
.gb-edit-banner-cancel {
  font-size: 12px;
  padding: 4px 10px;
  border: 1.5px solid rgba(255,255,255,0.5);
  border-radius: var(--radius-md);
  background: transparent;
  color: white;
  cursor: pointer;
  font-weight: 700;
  transition: background .15s;
}
.gb-edit-banner-cancel:hover { background: rgba(255,255,255,0.15); }
}

#gwin-builder .gb-field select:disabled {
  color: var(--c-muted);
  opacity: 1;
}

/* ---- Accessories card ---- */
.gb-accessories-card {
  border: 1.5px solid var(--c-border); border-radius: var(--radius-md);
  padding: 14px; margin-bottom: 10px; background: var(--c-white);
}
.gb-acc-section { margin-top: 14px; }
.gb-acc-section-label {
  font-size: 11px; font-weight: 700; letter-spacing: .5px;
  text-transform: uppercase; color: var(--c-muted); margin-bottom: 8px;
}
/* Mount picker (radio cards with images) */
.gb-acc-options { display: flex; gap: 8px; flex-wrap: wrap; }
.gb-acc-option {
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  border: 2px solid var(--c-border); border-radius: var(--radius-md);
  padding: 10px 12px; background: var(--c-white); cursor: pointer;
  min-width: 100px; max-width: 140px; transition: border-color .15s, background .15s;
  text-align: center;
}
.gb-acc-option:hover { border-color: var(--c-dark); }
.gb-acc-option.active { border-color: var(--c-brand); background: #fdf4ff; }
.gb-acc-option img, .gb-acc-toggle img {
  width: 64px; height: 64px; object-fit: cover;
  border-radius: var(--radius-sm); background: var(--c-surface);
  border: 1px solid var(--c-border);
}
.gb-acc-option .acc-img-placeholder, .gb-acc-toggle .acc-img-placeholder {
  width: 64px; height: 64px; border-radius: var(--radius-sm);
  background: var(--c-surface); border: 1px solid var(--c-border);
  display: flex; align-items: center; justify-content: center; font-size: 22px;
}
.gb-acc-option .acc-name { font-size: 11px; font-weight: 700; line-height: 1.3; }
.gb-acc-option .acc-price { font-size: 11px; color: var(--c-muted); }
/* Toggle (checkbox style) for pad, lineguard, disconnect */
/* Toggle cards for pad, lineguard, disconnect */
.gb-acc-toggle {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  border: 2px solid var(--c-border);
  border-radius: var(--radius-md);
  padding: 10px 12px;
  background: var(--c-white);
  cursor: pointer;
  min-width: 100px;
  max-width: 140px;
  transition: border-color .15s, background .15s;
  text-align: center;
  user-select: none;
}

.gb-acc-toggle:hover {
  border-color: var(--c-dark);
}

.gb-acc-toggle.active {
  border-color: var(--c-brand);
  background: #fdf4ff;
}

.gb-acc-toggle img,
.gb-acc-toggle .acc-img-placeholder {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: var(--radius-sm);
  background: var(--c-surface);
  border: 1px solid var(--c-border);
  flex-shrink: 0;
}

.gb-acc-toggle .acc-img-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.gb-acc-toggle-text {
  flex: 0;
  min-width: 0;
}

.gb-acc-toggle-text strong {
  display: block;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.3;
}

.gb-acc-toggle-text span {
  display: block;
  font-size: 11px;
  color: var(--c-muted);
}

/* Checkmark badge */
.gb-acc-checkbox {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 2px solid var(--c-border);
  background: var(--c-white);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background .15s, border-color .15s;
}

.gb-acc-toggle.active .gb-acc-checkbox {
  background: var(--c-brand);
  border-color: var(--c-brand);
}

.gb-acc-toggle.active .gb-acc-checkbox::after {
  content: "✓";
  color: white;
  font-size: 11px;
  font-weight: 900;
}

/* Shared accessory price styling */
.gb-acc-option .acc-price,
.gb-acc-toggle-text span {
  font-size: 11px;
  line-height: 1.2;
}

.gb-acc-option .gb-price-original,
.gb-acc-toggle .gb-price-original {
  display: inline-block;
  font-size: 10px;
  color: var(--c-muted);
  text-decoration: line-through;
  font-weight: 400;
  margin-right: 3px;
}

.gb-acc-option .gb-price-discounted,
.gb-acc-toggle .gb-price-discounted {
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  color: var(--c-dark);
}
  /* ---- Edit Modal ---- */
.gb-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.gb-modal {
  background: var(--c-white);
  border-radius: var(--radius-lg);
  width: 100%;
  max-width: 520px;
  max-height: none;
  min-height: auto;
  margin: 0 auto 24px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  display: flex;
  flex-direction: column;
}
.gb-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 18px 0;
  position: sticky;
  top: 0;
  background: var(--c-white);
  z-index: 1;
  border-bottom: 1.5px solid var(--c-border);
  padding-bottom: 14px;
}
.gb-modal-title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -.3px;
}
.gb-modal-close {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
  border: 1.5px solid var(--c-border);
  background: var(--c-white);
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--c-mid);
  transition: border-color .15s, color .15s;
  flex-shrink: 0;
}
.gb-modal-close:hover { border-color: var(--c-dark); color: var(--c-dark); }
.gb-modal-body { padding: 18px; flex: 1; }
.gb-modal-summary {
  background: var(--c-surface);
  border: 1.5px solid var(--c-border);
  border-radius: var(--radius-sm);
  padding: 10px 12px;
  font-size: 13px;
  margin-bottom: 18px;
  line-height: 1.6;
}
.gb-modal-summary strong { color: var(--c-dark); }
.gb-modal-section { margin-bottom: 18px; }
.gb-modal-footer {
  padding: 14px 18px;
  border-top: 1.5px solid var(--c-border);
  display: flex;
  gap: 8px;
  position: sticky;
  bottom: 0;
  background: var(--c-white);
}
.gb-modal-footer .gb-btn { flex: 1; text-align: center; padding: 10px 12px; font-size: 14px; }
.gb-btn-danger {
  background: var(--c-white);
  border-color: #fca5a5;
  color: #b91c1c;
}
.gb-btn-danger:hover { background: #fff5f5; border-color: #b91c1c; }
.gb-btn-brand {
  background: var(--c-brand);
  border-color: var(--c-brand);
  color: white;
}
.gb-btn-brand:hover { background: #5f1868; border-color: #5f1868; }
.gb-modal-parts { margin-bottom: 4px; }
.gb-modal-cart-msg { font-size: 12px; color: var(--c-muted); margin-top: 6px; min-height: 16px; text-align: center; }
@media (max-width: 500px) {
  .gb-modal-overlay {
    padding: 12px;
    align-items: flex-start;
  }

  .gb-modal {
    max-width: 100%;
    margin-bottom: 12px;
  }

  .gb-modal-footer {
    flex-direction: column;
  }

  .gb-modal-footer .gb-btn {
    width: 100%;
  }
}
</style>

<div id="gwin-builder">
  <h2 class="gb-title">GWIN System Calculator</h2>
  <p class="gb-subtitle">Rule-of-thumb sizing. Includes ceiling height adjustment. Not a Manual J.</p>

  <!-- MODE TOGGLE -->
  <div class="gb-mode-toggle">
    <button class="gb-mode-btn active" id="gbModeSingle">Single-Zone</button>
    <button class="gb-mode-btn" id="gbModeMulti">Multi-Zone</button>
  </div>

  <!-- STEP 1: SERIES -->
  <div class="gb-section-label">Step 1 — Choose your series</div>
  <div class="gb-series-grid" id="gbSeriesGrid"></div>

  <!-- STEP 3a: SINGLE-ZONE ROOM -->
  <div id="gbSingleUI">
    <div class="gb-section-label" id="gbSingleStepLabel">Step 2 — Room details</div>
    <div class="gb-sz-dims">
      <div class="gb-field"><label>Length (ft)</label><input id="szLen" type="number" min="0" step="0.5" value="15" placeholder="length" required></div>
      <div class="gb-field"><label>Width (ft)</label><input id="szWid" type="number" min="0" step="0.5" value="12" placeholder="width" required></div>
      <div class="gb-field"><label>Ceiling (ft)</label><input id="szHei" type="number" min="7" max="20" step="0.5" value="8" placeholder="height" required></div>
    </div>
   <div class="gb-sz-opts">
  <div class="gb-field" id="szTypeWrap" style="display:none;">
    <label>Air handler</label>
    <select id="szType">
      <option value="wall">High Wall</option>
    </select>
  </div>
  <div id="gbVoltageSection">
    <div class="gb-section-label">Voltage</div>
    <div class="gb-voltage-row" id="gbVoltageRow"></div>
  </div>
  <div class="gb-field" style="display:none;">
    <label>Size</label>
    <select id="szSize"></select>
  </div>
  <div class="gb-field">
    <label>Line set length</label>
   <select id="szLineLen">
      ${CONFIG.szLineLengths.map(ft => {
        const needsCoupler = ft >= 65;
        const label = ft === 15 ? ft + ' ft (included)' : needsCoupler ? ft + ' ft w/ Coupler (upgrade)' : ft + ' ft (upgrade)';
        return '<option value="' + ft + '"' + (ft === 15 ? ' selected' : '') + '>' + label + '</option>';
      }).join("")}
    </select>

  </div>
  <div class="gb-field">
    <label>Line Guard</label>
    <select id="szLineGuard">
      <option value="">None</option>
      <option value="yes">Add Line Guard</option>
    </select>
  </div>
</div>

<!-- Accessories card for single zone -->
<div class="gb-accessories-card" id="gbSzAccessoriesCard" style="display:none;">
  <div class="gb-room-header">
    <span class="gb-room-name">Accessories</span>
  </div>
  <div id="gbSzMountSection" class="gb-acc-section">
    <div class="gb-acc-section-label">Add a Mount?</div>
    <div class="gb-acc-options" id="gbSzMountOptions">
      <div class="gb-acc-option" data-mount="ground" id="szMountGround">
        <div class="acc-img-placeholder" id="szGroundImg">📦</div>
        <span class="acc-name">Ground Stand</span>
        <span class="acc-price" id="szGroundPrice">—</span>
      </div>
      <div class="gb-acc-option" data-mount="wall" id="szMountWall">
        <div class="acc-img-placeholder" id="szWallImg">🔩</div>
        <span class="acc-name">Wall Bracket</span>
        <span class="acc-price" id="szWallPrice">—</span>
      </div>
      <div class="gb-acc-option" data-mount="pad" id="szMountPad">
        <div class="acc-img-placeholder" id="szMountPadImg">🟫</div>
        <span class="acc-name">Condenser Pad</span>
        <span class="acc-price" id="szMountPadPrice">—</span>
      </div>
    </div>
  </div>
  <div class="gb-acc-section">
    <div class="gb-acc-section-label">Add a Disconnect Switch?</div>
    <div class="gb-acc-toggle" id="szDisconnectToggle">
      <div class="acc-img-placeholder" id="szDisconnectImg">⚡</div>
      <div class="gb-acc-toggle-text">
        <strong>Disconnect Switch &amp; Whip</strong>
        <span id="szDisconnectPrice">—</span>
      </div>
      <div class="gb-acc-checkbox"></div>
    </div>
  </div>
</div>
  </div>

  <!-- STEP 3b: MULTI-ZONE ROOMS -->
  <div id="gbMultiUI" style="display:none;">
    <div class="gb-section-label">Step 2 — Add your rooms</div>
   <div class="gb-cap-row">
    <div style="font-size:13px;color:var(--c-muted);padding:6px 0;">
      Up to <strong style="color:var(--c-dark);">5 zones</strong>. Add rooms below, then add accessories.
    </div>
  </div>
    <div id="gbRooms"></div>
    <div class="gb-action-row">
      <button class="gb-btn" id="gbAddRoom">+ Add room</button>
      <button class="gb-btn" id="gbReset">Reset</button>
    </div>
        <div id="gbCondenserAccessoriesWrap"></div>
  </div>

  <!-- RESULTS -->
  <div class="gb-results" id="gbResults" style="display:none;">
    <div class="gb-section-label" style="margin-bottom:12px;" id="gbResultsStepLabel">Results</div>
    <div class="gb-results-header">
      <span class="gb-btu-big" id="gbTotalBtu">—</span>
      <span class="gb-btu-unit">BTU/h</span>
    </div>
    <div class="gb-kw"><span id="gbTotalKw">—</span> kW</div>
    <div id="gbRoomSummary" class="gb-room-summary"></div>
    <div id="gbCondenserRec" class="gb-condenser-rec" style="display:none;"></div>
    <div id="gbSeriesFeatures" class="gb-features"></div>
    <div id="gbPartsList" class="gb-parts"></div>
    <div id="gbErrorBlock" class="gb-error-block" style="display:none;"></div>
    <!-- Single zone CTA -->
    <button class="gb-btn gb-btn-dark" id="gbAddToCart" style="display:none;">Add to cart</button>
    <div id="gbCartMsg"></div>
    <!-- Multi zone CTA -->
    <button class="gb-btn gb-btn-dark" id="gbAddBundle" style="display:none;">Add full bundle to cart</button>
    <div id="gbBundleMsg"></div>
  </div>
</div>
`;

    // ============================================================
    // HELPERS
    // ============================================================
    const cache = new Map();

    function scrollBuilderToTop() {
        const builder = document.getElementById("gwin-builder");
        if (!builder) return;

        const y = builder.getBoundingClientRect().top + window.pageYOffset - 100;

        window.scrollTo({
            top: y,
            behavior: "smooth",
        });
    }

    async function fetchProduct(handle) {
        if (!handle) throw new Error("Missing product handle");
        if (cache.has(handle)) return cache.get(handle);
        const res = await fetch(`/products/${handle}.js`, {
            credentials: "same-origin"
        });
        if (!res.ok) throw new Error(`Product not found: ${handle}`);
        const json = await res.json();
        cache.set(handle, json);
        return json;
    }

    function getProductFeaturedImage(product) {
        const img = product?.featured_image;

        if (!img) return "";

        if (typeof img === "string") {
            return img.startsWith("//") ? `https:${img}` : img;
        }

        if (typeof img === "object" && img.src) {
            return img.src.startsWith("//") ? `https:${img.src}` : img.src;
        }

        return "";
    }

    function formatMoney(cents) {
        if (cents == null || isNaN(cents)) return null;
        return "$" + (cents / 100).toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    }

    const DISCOUNT_CODE = "GWIN15";
    const DISCOUNT = 0.15;
    const DISCOUNT_MULTIPLIER = 1 - DISCOUNT;

    function formatMoneyFromCents(cents, options = {}) {
        if (cents == null || isNaN(cents)) return null;

        const {
            minimumFractionDigits = 2,
                maximumFractionDigits = 2,
        } = options;

        return "$" + (Number(cents) / 100).toLocaleString("en-US", {
            minimumFractionDigits,
            maximumFractionDigits,
        });
    }

    function formatMoneyDiscounted(cents) {
        if (cents == null || isNaN(cents)) return null;

        const originalCents = Number(cents);
        const discountedCents = originalCents * DISCOUNT_MULTIPLIER;

        return {
            original: formatMoneyFromCents(originalCents),
            discounted: formatMoneyFromCents(discountedCents),
            discountedCents,
        };
    }

    async function getVariantPriceCents(handle, matchFn) {
        try {
            const product = await fetchProduct(handle);
            const v = (matchFn ? matchFn(product) : null) ?? product?.variants?.[0];
            if (!v?.price) return null;
            return parseInt(v.price, 10); // Shopify returns price in cents as integer string
        } catch {
            return null;
        }
    }

    async function getLinesetPriceCents(btu, lineLenFt) {
        const gaugeKey = CONFIG.linesetKeyByBtu[btu] || "small";
        const handle = CONFIG.linesets[gaugeKey];
        try {
            const product = await fetchProduct(handle);
            const wantedLen = Number(lineLenFt);
            const vars = product?.variants || [];
            const v =
                vars.find(v => {
                    const m = String(v.title || v.option1 || "").match(/(\d+)\s*(?:ft|')/i);
                    return m && Number(m[1]) === wantedLen;
                }) ||
                vars.find(v => String(v.title || v.option1 || "").includes(String(wantedLen)));
            if (!v?.price) return null;
            return parseInt(v.price, 10);
        } catch {
            return null;
        }
    }

    function getVariantImage(product, variant) {
        const img =
            variant?.featured_image?.src ||
            variant?.featured_image ||
            variant?.image?.src ||
            variant?.image;

        if (!img) return "";

        if (typeof img === "string") {
            return img.startsWith("//") ? `https:${img}` : img;
        }

        if (typeof img === "object" && img.src) {
            return img.src.startsWith("//") ? `https:${img.src}` : img.src;
        }

        return "";
    }

    function resolveVariantByLineLength(product, lineLenFt) {
        const wantedLen = Number(lineLenFt);
        const vars = product?.variants || [];

        const normalize = value =>
            String(value || "")
            .toLowerCase()
            .replace(/\s+/g, " ")
            .trim();

        const getLengthText = value => {
            // Only inspect the length label before the price separator.
            // Example: "50 feet - $362.25" -> "50 feet"
            return normalize(value).split(" - ")[0].trim();
        };

        const matchesExactLength = value => {
            const text = getLengthText(value);
            if (!text) return false;

            // Accept:
            // "50"
            // "50 ft"
            // "50ft"
            // "50 feet"
            // "50 feet (with connector)"
            return new RegExp(`^${wantedLen}\\s*(ft|feet|'|")?(\\s|\\(|$)`, "i").test(text);
        };

        const match =
            vars.find(v => matchesExactLength(v.option1)) ||
            vars.find(v => matchesExactLength(v.option2)) ||
            vars.find(v => matchesExactLength(v.option3)) ||
            vars.find(v => matchesExactLength(v.title));

        if (!match) {
            console.warn("No exact line length variant match found.", {
                wantedLen,
                variants: vars.map(v => ({
                    id: v.id,
                    title: v.title,
                    option1: v.option1,
                    option2: v.option2,
                    option3: v.option3,
                    price: v.price,
                })),
            });

            return null;
        }

        //   console.log("Resolved line length variant:", {
        //     wantedLen,
        //     id: match.id,
        //     title: match.title,
        //     option1: match.option1,
        //     option2: match.option2,
        //     option3: match.option3,
        //     price: match.price,
        //   });

        return match;
    }

    async function getLinesetProductImage(btu, lineLenFt) {
        const gaugeKey = CONFIG.linesetKeyByBtu[btu] || "small";
        const handle = CONFIG.linesets[gaugeKey];

        try {
            const product = await fetchProduct(handle);
            const variant = resolveVariantByLineLength(product, lineLenFt);

            return (
                getVariantImage(product, variant) ||
                getProductFeaturedImage(product)
            );
        } catch {
            return "";
        }
    }


    async function getSzLinesetProductImage(lineLenFt) {
        try {
            const product = await fetchProduct(CONFIG.szLinesetUpgradeHandle);
            const variant = resolveVariantByLineLength(product, lineLenFt);

            return (
                getVariantImage(product, variant) ||
                getProductFeaturedImage(product)
            );
        } catch {
            return "";
        }
    }

    function btuToKw(btu) {
        return (btu * 0.000293071).toFixed(2);
    }

    function clamp(n, min, max) {
        return Math.max(min, Math.min(max, n));
    }

    function effectiveSqft(len, wid, heightFt) {
        const sf = (Number(len) || 0) * (Number(wid) || 0);
        const h = clamp(Number(heightFt) || 8, 7, 20);
        return sf * (h / 8);
    }

    function suggestBtu(effSqft, bands, availSizes) {
        let suggested = availSizes[availSizes.length - 1];
        for (const band of bands) {
            if (effSqft <= band.max * CONFIG.bias) {
                const match = availSizes.find(s => s >= band.btu);
                if (match) {
                    suggested = match;
                    break;
                }
            }
        }
        return suggested;
    }

    function getVoltagesForBtu(seriesKey, btu, type) {
        const sz = CONFIG.singleZone[seriesKey];
        if (!sz) return ["230"];
        const map = type === "cassette" ? sz.cassetteBundleHandle : sz.bundleHandle;
        const voltObj = map?.[btu];
        if (!voltObj) return ["230"];
        return Object.keys(voltObj).map(Number).sort((a, b) => b - a); // 230 first
    }

    // ---- Cart helpers ----
    async function getCartJSON() {
        const res = await fetch("/cart.js", {
            credentials: "same-origin"
        });
        return res.json();
    }

    async function cartChangeLine(line, quantity) {
        const res = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "same-origin",
            body: JSON.stringify({
                line,
                quantity
            }),
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json?.description || "Cart change failed");
        return json;
    }

    function updateCartBubbleCount(count) {
        const cartButtons = Array.from(document.querySelectorAll(
            'a.cart-drawer-button, a[aria-controls="CartDrawer"], header a[href="/cart"], header a[href*="/cart"]'
        )).filter(el => !el.closest("cart-drawer, #CartDrawer, .drawer--cart"));

        if (!cartButtons.length) return;

        cartButtons.forEach(cartButton => {
            let countEl =
                cartButton.querySelector("cart-count.cart-count.cart-count--absolute") ||
                cartButton.querySelector("cart-count.cart-count") ||
                cartButton.querySelector(".cart-count.cart-count--absolute") ||
                cartButton.querySelector(".cart-count");

            if (!countEl && count > 0) {
                countEl = document.createElement("cart-count");
                countEl.className = "cart-count cart-count--absolute";
                cartButton.appendChild(countEl);
            }

            const sr = cartButton.querySelector(".visually-hidden");

            if (count > 0) {
                if (countEl) {
                    countEl.textContent = String(count);
                    countEl.className = "cart-count cart-count--absolute";
                    countEl.setAttribute("aria-label", `${count} item${count === 1 ? "" : "s"}`);

                    countEl.removeAttribute("hidden");
                    countEl.removeAttribute("aria-hidden");

                    countEl.style.display = "";
                    countEl.style.visibility = "";
                    countEl.style.opacity = "";
                }

                if (sr) {
                    sr.textContent = `${count} item${count === 1 ? "" : "s"}`;
                }
            } else {
                if (countEl) {
                    countEl.textContent = "0";
                    countEl.setAttribute("aria-label", "0 items");
                    countEl.setAttribute("hidden", "");
                    countEl.setAttribute("aria-hidden", "true");
                    countEl.style.display = "none";
                }

                if (sr) {
                    sr.textContent = "0 items";
                }
            }
        });
    }

    function unlockPageScroll() {
        const y = Math.abs(parseInt(document.body.style.top || "0", 10)) || window.__GWIN_CART_SCROLL_Y__ || 0;

        document.body.classList.remove(
            "overflow-hidden",
            "drawer-open",
            "js-drawer-open",
            "cart-drawer-open",
            "menu-opening",
            "modal-show"
        );

        document.documentElement.classList.remove(
            "overflow-hidden",
            "drawer-open",
            "js-drawer-open",
            "cart-drawer-open",
            "menu-opening"
        );

        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.right = "";
        document.body.style.width = "";
        document.body.style.touchAction = "";

        document.documentElement.style.overflow = "";
        document.documentElement.style.position = "";
        document.documentElement.style.touchAction = "";

        if (y) {
            window.scrollTo(0, y);
        }

        window.__GWIN_CART_SCROLL_Y__ = 0;
    }

    function persistentScrollUnlock(durationMs = 1500) {
        const start = Date.now();
        const interval = setInterval(() => {
            unlockPageScroll();
            if (Date.now() - start >= durationMs) {
                clearInterval(interval);
            }
        }, 50);
    }

    function closeCartDrawer() {
        const drawerEl = document.querySelector("cart-drawer");

        if (drawerEl) {
            if (typeof drawerEl.close === "function") {
                drawerEl.close();
            } else {
                drawerEl.removeAttribute("open");
                drawerEl.classList.remove("active", "is-open");
            }
        }

        const container =
            document.getElementById("CartDrawer") ||
            document.querySelector("#CartDrawer.drawer") ||
            document.querySelector(".drawer--cart");

        if (container) {
            container.classList.remove("active", "is-open");
            container.setAttribute("aria-hidden", "true");
        }

        unlockPageScroll();

        setTimeout(unlockPageScroll, 50);
        setTimeout(unlockPageScroll, 250);
        setTimeout(unlockPageScroll, 500);
        setTimeout(unlockPageScroll, 1000);
    }

    async function refreshCartSections() {
        const rootPath = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
        const url = `${rootPath}?sections=${encodeURIComponent("cart-drawer,cart-icon-bubble")}`;
        const res = await fetch(url, {
            credentials: "same-origin",
            headers: {
                Accept: "application/json"
            }
        });
        const text = await res.text();
        if (text.trim().startsWith("<")) return null;
        try {
            return JSON.parse(text);
        } catch {
            return null;
        }
    }

    function replaceSectionElement(html, sel) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const fresh = doc.querySelector(sel);
        const current = document.querySelector(sel);

        if (!fresh || !current) return false;

        current.replaceWith(fresh);
        return true;
    }

    function setInnerHTMLFromSection(html, sel) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const fresh = doc.querySelector(sel);
        const current = document.querySelector(sel);

        if (!fresh || !current) return false;

        current.innerHTML = fresh.innerHTML;
        return true;
    }

    async function openCartDrawer() {
        const drawerEl = document.querySelector("cart-drawer");
        if (drawerEl) {
            if (typeof drawerEl.open === "function") drawerEl.open();
            else {
                drawerEl.setAttribute("open", "");
                drawerEl.classList.add("active", "is-open");
            }
            window.__GWIN_CART_SCROLL_Y__ = window.scrollY || window.pageYOffset || 0;
            document.body.classList.add("overflow-hidden");
            return;
        }
        const btn = document.querySelector('button[aria-controls="CartDrawer"], [aria-controls="CartDrawer"]');
        if (btn) btn.click();
    }

    async function openAndRefreshCartDrawer() {
        const sections = await refreshCartSections();
        if (sections?.["cart-icon-bubble"]) {
            replaceSectionElement(sections["cart-icon-bubble"], "#cart-icon-bubble") ||
                replaceSectionElement(sections["cart-icon-bubble"], ".header__icon--cart") ||
                setInnerHTMLFromSection(sections["cart-icon-bubble"], "#cart-icon-bubble") ||
                setInnerHTMLFromSection(sections["cart-icon-bubble"], ".header__icon--cart");
        }
        if (sections?.["cart-drawer"]) {
            setInnerHTMLFromSection(sections["cart-drawer"], "cart-drawer") ||
                setInnerHTMLFromSection(sections["cart-drawer"], "#CartDrawer") ||
                setInnerHTMLFromSection(sections["cart-drawer"], ".drawer--cart");
        }
        await openCartDrawer();

        const cart = await getCartJSON();
        updateCartBubbleCount(cart.item_count || 0);

        if ((cart.item_count || 0) === 0) {
            setTimeout(unlockPageScroll, 50);
            setTimeout(unlockPageScroll, 250);
            setTimeout(unlockPageScroll, 500);
        }

        requestAnimationFrame(() => {
            updateCartBubbleCount(cart.item_count || 0);
        });

        setTimeout(() => {
            updateCartBubbleCount(cart.item_count || 0);
        }, 150);
        setTimeout(() => {
            updateCartBubbleCount(cart.item_count || 0);
        }, 500);


    }
    async function refreshCartDrawerAfterChange() {
        const sections = await refreshCartSections();

        if (sections?.["cart-icon-bubble"]) {
            replaceSectionElement?.(sections["cart-icon-bubble"], "#cart-icon-bubble") ||
                replaceSectionElement?.(sections["cart-icon-bubble"], ".header__icon--cart") ||
                setInnerHTMLFromSection(sections["cart-icon-bubble"], "#cart-icon-bubble") ||
                setInnerHTMLFromSection(sections["cart-icon-bubble"], ".header__icon--cart");
        }

        if (sections?.["cart-drawer"]) {
            setInnerHTMLFromSection(sections["cart-drawer"], "cart-drawer") ||
                setInnerHTMLFromSection(sections["cart-drawer"], "#CartDrawer") ||
                setInnerHTMLFromSection(sections["cart-drawer"], ".drawer--cart");
        }

        const cart = await getCartJSON();
        updateCartBubbleCount(cart.item_count || 0);

        if ((cart.item_count || 0) === 0) {
            persistentScrollUnlock(1500);
        }

        requestAnimationFrame(() => {
            updateCartBubbleCount(cart.item_count || 0);
        });

        setTimeout(() => {
            updateCartBubbleCount(cart.item_count || 0);
        }, 150);

        setTimeout(() => {
            updateCartBubbleCount(cart.item_count || 0);
        }, 500);
    }

    function normalizeCartProperties(properties = {}) {
        // Shopify only merges line items when variant ID AND properties are identical.
        // Keep these stable so duplicate products become quantity 2, 3, etc.
        const clean = {};

        if (properties._source) clean._source = properties._source;
        if (properties._series) clean._series = properties._series;

        return clean;
    }

    function mergeCartItems(items = []) {
        const map = new Map();

        items.forEach(item => {
            if (!item?.id) return;

            const id = Number(item.id);
            const quantity = Number(item.quantity) || 1;
            const properties = normalizeCartProperties(item.properties || {});
            const key = `${id}::${JSON.stringify(properties)}`;

            if (!map.has(key)) {
                map.set(key, {
                    id,
                    quantity,
                    properties,
                });
            } else {
                map.get(key).quantity += quantity;
            }
        });

        return Array.from(map.values());
    }

    async function addToCart(items) {
        const mergedItems = mergeCartItems(items);

        if (!mergedItems.length) {
            throw new Error("No items to add.");
        }

        const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "same-origin",
            body: JSON.stringify({
                items: mergedItems,
            }),
        });

        const json = await res.json();

        if (!res.ok) {
            throw new Error(json?.description || "Cart add failed");
        }

        await openAndRefreshCartDrawer();
        return json;
    }

    function installCartDrawerDelegates() {
        if (window.__GWIN_BUILDER_CART_DELEGATES__) return;
        window.__GWIN_BUILDER_CART_DELEGATES__ = true;

        document.addEventListener("click", async (e) => {
            const t = e.target;

            // CLOSE button
            const closeBtn =
                t.closest('button[aria-label="Close"]') ||
                t.closest('button[aria-label="close"]') ||
                t.closest('button[aria-label*="Close"]') ||
                t.closest(".drawer__close") ||
                t.closest(".cart-drawer__close") ||
                t.closest("[data-drawer-close]") ||
                t.closest("[data-cart-drawer-close]") ||
                t.closest('button[id*="CartDrawer-Overlay"]') ||
                t.closest("#CartDrawer-Overlay") ||
                t.closest(".cart-drawer__overlay") ||
                t.closest(".drawer__overlay") ||
                t.closest(".fixed-overlay");

            if (closeBtn) {
                e.preventDefault();
                e.stopPropagation();
                if (e.stopImmediatePropagation) e.stopImmediatePropagation();

                closeCartDrawer();

                unlockPageScroll();
                persistentScrollUnlock(1500);

                return;
            }

            // REMOVE line item
            const removeHost =
                t.closest("cart-remove-button") ||
                t.closest(".cart-item__remove") ||
                t.closest("[data-cart-remove]") ||
                t.closest('a[href*="cart/change"]') ||
                t.closest('button[name="remove"]');

            if (removeHost && removeHost.closest("cart-drawer, #CartDrawer, .drawer--cart")) {
                e.preventDefault();
                e.stopPropagation();
                if (e.stopImmediatePropagation) e.stopImmediatePropagation();
                const lineAttr = removeHost.getAttribute("data-index") || removeHost.dataset.index ||
                    removeHost.getAttribute("data-line") || removeHost.dataset.line;
                const line = Number(lineAttr);
                if (!Number.isFinite(line) || line <= 0) return;
                try {
                    await cartChangeLine(line, 0);
                    await refreshCartDrawerAfterChange();
                } catch (err) {
                    console.error(err);
                }
                return;
            }

            // QTY +/-
            const qtyBtn = t.closest('button[name="plus"], button[name="minus"], button[data-quantity-button]');
            if (qtyBtn && qtyBtn.closest("cart-drawer, #CartDrawer, .drawer--cart")) {
                e.preventDefault();
                e.stopPropagation();
                if (e.stopImmediatePropagation) e.stopImmediatePropagation();
                const lineItem = qtyBtn.closest("[data-index], .cart-item, tr, li");
                if (!lineItem) return;
                const input = lineItem.querySelector('input[name="updates[]"], input[type="number"]');
                if (!input) return;
                const lineAttr = input.getAttribute("data-index") || lineItem.getAttribute("data-index") || lineItem.dataset?.index;
                const line = Number(lineAttr);
                const currentQty = Number(input.value);
                if (!Number.isFinite(line) || !Number.isFinite(currentQty)) return;
                const isMinus = qtyBtn.name === "minus" || qtyBtn.getAttribute("data-quantity-button") === "minus";
                const nextQty = isMinus ? Math.max(0, currentQty - 1) : currentQty + 1;
                try {
                    await cartChangeLine(line, nextQty);
                    await refreshCartDrawerAfterChange();
                } catch (err) {
                    console.error(err);
                }
                return;
            }
        }, true);
    }

    // ---- Variant resolution ----
    function resolveVariantByBtu(product, btu) {
        const label = `${Math.round(btu / 1000)}k`;
        const vars = product?.variants || [];
        return (
            vars.find(v => (v.option1 || "").toLowerCase().includes(label)) ||
            vars.find(v => (v.title || "").toLowerCase().includes(label))
        );
    }

    function resolveVariantByBtuAndSeries(product, btu, seriesLabel) {
        const btuNum = Number(btu);
        const label = `${Math.round(btuNum / 1000)}k`;
        const altLabel = btuNum === 20000 ? "20k" : label;
        const seriesWord = String(seriesLabel || "").toLowerCase().split(" ")[0];

        const vars = product?.variants || [];

        const exact = vars.find(v => {
            const text = `${v.title || ""} ${v.option1 || ""} ${v.option2 || ""} ${v.option3 || ""}`.toLowerCase();

            const btuMatch =
                text.includes(label) ||
                text.includes(altLabel) ||
                text.includes(String(btuNum));

            const seriesMatch = !seriesWord ||
                text.includes(seriesWord);

            return btuMatch && seriesMatch;
        });

        if (exact) return exact;

        return resolveVariantByBtu(product, btu);
    }

    function resolveVariantByBtuVoltage(product, btu, voltage) {
        const label = `${Math.round(btu / 1000)}k`;
        const vStr = String(voltage);
        const vars = product?.variants || [];
        // Try matching both btu and voltage in option1
        const exact = vars.find(v => {
            const o = (v.option1 || "").toLowerCase();
            return o.includes(label) && o.includes(vStr);
        });
        if (exact) return exact;
        // Fallback: just btu
        return resolveVariantByBtu(product, btu);
    }

    async function resolveLinesetVariant(btu, lineLenFt) {
        const gaugeKey = CONFIG.linesetKeyByBtu[btu] || "small";
        const handle = CONFIG.linesets[gaugeKey];
        const product = await fetchProduct(handle);
        const wantedLen = Number(lineLenFt);
        const vars = product?.variants || [];
        const exact = vars.find(v => {
            const m = String(v.title || v.option1 || "").match(/(\d+)\s*(?:ft|')/i);
            return m && Number(m[1]) === wantedLen;
        });
        if (exact) return exact;
        const fuzzy = vars.find(v => {
            const text = `${v.title || ""} ${v.option1 || ""} ${v.option2 || ""} ${v.option3 || ""}`.toLowerCase();
            return new RegExp(`(^|\\D)${wantedLen}(\\D|$)`).test(text);
        });
        if (fuzzy) return fuzzy;
        throw new Error(`No line set variant found for ${wantedLen}ft`);
    }

    // ---- Single-zone line set upgrade variant resolver ----

    async function resolveSzLinesetVariant(lineLenFt) {
        const wantedLen = Number(lineLenFt);

        // 15ft is included in the bundle.
        if (wantedLen === 15) return null;

        const product = await fetchProduct(CONFIG.szLinesetUpgradeHandle);
        const variant = resolveVariantByLineLength(product, wantedLen);

        if (!variant) {
            throw new Error(`No single-zone line set upgrade variant found for ${wantedLen}ft`);
        }

        return variant;
    }


    async function getSzLinesetPriceCents(lineLenFt) {
        if (Number(lineLenFt) === 15) return 0;
        try {
            const variant = await resolveSzLinesetVariant(lineLenFt);
            if (!variant?.price) return null;
            return parseInt(variant.price, 10);
        } catch {
            return null;
        }
    }

    // ---- Fetch accessory product image and first-variant price ----
    async function fetchAccessoryMeta(handle) {
        try {
            const product = await fetchProduct(handle);
            const img = getProductFeaturedImage(product);
            const price = product?.variants?.[0]?.price ? parseInt(product.variants[0].price, 10) : null;
            return {
                img,
                price,
                product
            };
        } catch {
            return {
                img: "",
                price: null,
                product: null
            };
        }
    }

    // ============================================================
    // COMPUTE
    // ============================================================
    function computeSingle() {
        const seriesKey = state.series;
        const sz = CONFIG.singleZone[seriesKey];
        if (!sz) return null;

        const eff = effectiveSqft(state.single.len, state.single.wid, state.single.height);
        if (!state.single.len || !state.single.wid || !state.single.height || !state.single.type) return null;
        const overLimit = eff > CONFIG.maxEffSqft;
        if (overLimit) return {
            overLimit: true,
            eff: Math.round(eff)
        };

        const type = state.single.type || "wall";
        const availSizes = type === "cassette" ? sz.cassetteSizes : sz.wallSizes;
        if (!availSizes.length) return null;

        const suggested = suggestBtu(eff, CONFIG.singleBands, availSizes);
        const chosen = availSizes.includes(Number(state.single.size)) ? Number(state.single.size) : suggested;

        const sf = (Number(state.single.len) || 0) * (Number(state.single.wid) || 0);

        // Determine active voltage
        const availVoltages = getVoltagesForBtu(seriesKey, chosen, type);
        const voltage = availVoltages.includes(Number(state.voltage)) ? Number(state.voltage) : availVoltages[0];

        // Get bundle handle
        const handleMap = type === "cassette" ? sz.cassetteBundleHandle : sz.bundleHandle;
        const handle = handleMap?.[chosen]?.[voltage];

        return {
            overLimit: false,
            eff: Math.round(eff),
            suggested,
            chosen,
            type,
            voltage,
            handle,
            lineLen: Number(state.single.lineLen) || 15,
        };
    }

    function computeMulti() {
        const seriesKey = state.series;
        const mz = CONFIG.multiZone.series[seriesKey];
        const summaries = [];
        let sumHeads = 0;
        let hasError = false;

        state.rooms.forEach((r, idx) => {
            const lineGuard = r.lineGuard === "yes" || r.lineGuard === true;

            // Empty / incomplete room
            if (!r.len || !r.wid || !r.height || !r.type) {
                summaries.push({
                    idx,
                    label: r.label,
                    sf: 0,
                    eff: 0,
                    overLimit: false,
                    suggested: null,
                    chosen: null,
                    type: r.type || "wall",
                    lineLen: Number(r.lineLen) || CONFIG.defaultLineLen,
                    lineGuard,
                    empty: true,
                });

                return;
            }

            const eff = effectiveSqft(r.len, r.wid, r.height);
            const sf = (Number(r.len) || 0) * (Number(r.wid) || 0);
            const overLimit = eff > CONFIG.maxEffSqft;

            if (overLimit) hasError = true;

            const type = r.type === "cassette" && mz.cassetteSizes.length > 0 ?
                "cassette" :
                "wall";

            const availSizes = type === "cassette" ?
                mz.cassetteSizes :
                mz.wallSizes;

            const suggested = overLimit ?
                null :
                suggestBtu(eff, CONFIG.multiBands, availSizes);

            const chosen = overLimit ?
                null :
                availSizes.includes(Number(r.size)) ?
                Number(r.size) :
                suggested;

            if (chosen) sumHeads += chosen;

            summaries.push({
                idx,
                label: r.label,
                sf: Math.round(sf),
                eff: Math.round(eff),
                overLimit,
                suggested,
                chosen,
                type,
                lineLen: Number(r.lineLen) || CONFIG.defaultLineLen,
                lineGuard,
            });
        });

        const effective = sumHeads - CONFIG.condenserOverageAllowance;

        let condenser = CONFIG.multiZone.condensers[CONFIG.multiZone.condensers.length - 1];

        for (const c of CONFIG.multiZone.condensers) {
            if (effective <= c.btu) {
                condenser = c;
                break;
            }
        }

        const largest = CONFIG.multiZone.condensers[CONFIG.multiZone.condensers.length - 1];
        const overCapacity = effective > largest.btu;

        return {
            summaries,
            sumHeads,
            condenser,
            hasError,
            overCapacity,
        };
    }

    // ============================================================
    // RENDER
    // ============================================================
    function renderModeToggle() {
        document.getElementById("gbModeSingle").classList.toggle("active", state.mode === "single");
        document.getElementById("gbModeMulti").classList.toggle("active", state.mode === "multi");
        document.getElementById("gbSingleUI").style.display = state.mode === "single" ? "block" : "none";
        document.getElementById("gbMultiUI").style.display = state.mode === "multi" ? "block" : "none";
        document.getElementById("gbSingleStepLabel").textContent = "Step 2 — Room details";
        document.getElementById("gbResultsStepLabel").textContent = "Step 3 — Your system";
        if (state.mode === "multi") document.getElementById("gbConfigAnother")?.remove();
        if (state.mode === "single") document.getElementById("gbMzConfigAnother")?.remove();

        // Edit banner
        document.getElementById("gbEditBanner")?.remove();
        if (editingLabel) {
            const banner = document.createElement("div");
            banner.id = "gbEditBanner";
            banner.className = "gb-edit-banner";
            banner.innerHTML = `
      <span class="gb-edit-banner-label">✏️ Editing ${editingLabel}</span>
      <button class="gb-edit-banner-cancel" id="gbCancelEdit">Cancel edit</button>
    `;
            document.getElementById("gbModeSingle").closest(".gb-mode-toggle").after(banner);
            document.getElementById("gbCancelEdit").addEventListener("click", () => {
                const modeAtCancel = state.mode;

                // Push the in-progress config back as a saved system before clearing
                if (modeAtCancel === "single") {
                    const sz = computeSingle();
                    if (sz && !sz.overLimit && sz.handle) {
                        state.savedSystems.push({
                            label: `System ${state.savedSystems.length + 1}`,
                            mode: "single",
                            series: state.series,
                            seriesLabel: CONFIG.singleZone[state.series]?.label || state.series,
                            voltage: sz.voltage,
                            chosen: sz.chosen,
                            type: sz.type,
                            lineLen: state.single.lineLen,
                            handle: sz.handle,
                            len: state.single.len,
                            wid: state.single.wid,
                            height: state.single.height,
                            lineGuard: state.single.lineGuard,
                            mount: state.single.mount,
                            condenserPad: state.single.condenserPad,
                            disconnect: state.single.disconnect,
                        });
                    }
                } else {
                    const mc = computeMulti();
                    if (mc && !mc.hasError && mc.summaries.length > 0 && !mc.summaries.some(s => s.empty)) {
                        state.savedSystems.push({
                            label: `System ${state.savedSystems.length + 1}`,
                            mode: "multi",
                            series: state.series,
                            seriesLabel: CONFIG.multiZone.series[state.series]?.label || state.series,
                            roomCount: mc.summaries.length,
                            condenser: mc.condenser,
                            mzAccessories: {
                                ...state.mzAccessories
                            },
                            summaries: mc.summaries.map(s => ({
                                ...s,
                                len: state.rooms[s.idx]?.len || 0,
                                wid: state.rooms[s.idx]?.wid || 0,
                                height: state.rooms[s.idx]?.height || 0,
                            })),
                        });
                    }
                }

                // Now safe to clear
                clearEditingMode();

                state.single = getFreshSingleState();
                state.rooms = getFreshRoomsState();

                document.getElementById("szLen").value = "";
                document.getElementById("szWid").value = "";
                document.getElementById("szHei").value = "";

                saveState();
                render();
            });
        }
    }

    function renderSeriesGrid() {
        const seriesObj = state.mode === "single" ? CONFIG.singleZone : CONFIG.multiZone.series;
        const grid = document.getElementById("gbSeriesGrid");
        grid.innerHTML = Object.entries(seriesObj).map(([key, s]) => `
      <button class="gb-series-btn${state.series === key ? " active" : ""}" data-series="${key}">
        <span class="series-name">${s.label}${s.preorder ? `<span class="gb-preorder-dot"></span>` : ""}</span>
        
      </button>
    `).join("");
        grid.querySelectorAll(".gb-series-btn").forEach(btn => {
            btn.addEventListener("click", () => {
                state.series = btn.dataset.series;
                state.single.size = null;
                state.rooms.forEach(r => r.size = null);
                render();
            });
        });
    }

    function renderVoltage() {
        if (state.mode !== "single") return;

        const sz = CONFIG.singleZone[state.series];
        if (!sz) return;

        const type = state.single.type || "wall";
        const availSizes = type === "cassette" ? sz.cassetteSizes : sz.wallSizes;

        if (!availSizes.length) return;

        // Use the same sizing logic as the hidden size selector.
        // This prevents King from checking 7k, which has no single-zone bundle handle.
        const eff = effectiveSqft(
            state.single.len,
            state.single.wid,
            state.single.height
        );

        const suggested = suggestBtu(eff, CONFIG.singleBands, availSizes);

        const chosen = availSizes.includes(Number(state.single.size)) ?
            Number(state.single.size) :
            suggested;

        const availV = getVoltagesForBtu(state.series, chosen, type);
        const row = document.getElementById("gbVoltageRow");

        row.innerHTML = availV.map(v => `
    <label class="gb-voltage-label${Number(state.voltage) === v ? " checked" : ""}">
      <input type="radio" name="gbVoltage" value="${v}" ${Number(state.voltage) === v ? "checked" : ""}> ${v}V
    </label>
  `).join("");

        // If current voltage is not available for this chosen BTU, default to first available.
        if (!availV.includes(Number(state.voltage))) {
            state.voltage = String(availV[0]);
        }

        row.querySelectorAll('input[type="radio"]').forEach(inp => {
            inp.checked = inp.value === state.voltage;
            inp.closest(".gb-voltage-label").classList.toggle("checked", inp.value === state.voltage);

            inp.addEventListener("change", () => {
                state.voltage = inp.value;

                document.querySelectorAll(".gb-voltage-label").forEach(l => {
                    l.classList.remove("checked");
                });

                inp.closest(".gb-voltage-label").classList.add("checked");
                renderResults();
            });
        });
    }

    function renderSingleSizeSelect() {
        const sz = CONFIG.singleZone[state.series];
        if (!sz) return;
        const type = state.single.type;
        const availSizes = type === "cassette" ? sz.cassetteSizes : sz.wallSizes;
        const eff = effectiveSqft(state.single.len, state.single.wid, state.single.height);
        const suggested = suggestBtu(eff, CONFIG.singleBands, availSizes);
        const filteredSizes = availSizes.filter(btu => btu >= suggested);
        const currentSize = filteredSizes.includes(Number(state.single.size)) ? Number(state.single.size) : suggested;
        const sel = document.getElementById("szSize");
        sel.innerHTML = filteredSizes.map(btu => `
  <option value="${btu}" ${currentSize === btu ? "selected" : ""}>${Math.round(btu / 1000)}k</option>
`).join("");
        state.single.size = currentSize;
        sel.value = String(currentSize);

        // Air handler type dropdown
        const hasCassette = sz.cassetteSizes.length > 0;
        const typeWrap = document.getElementById("szTypeWrap");
        const typeSel = document.getElementById("szType");
        typeWrap.style.display = "flex";
        if (!hasCassette && state.single.type === "cassette") state.single.type = null;
        const noTypeChosen = !state.single.type;
        typeSel.innerHTML = `
  ${noTypeChosen ? `<option value="" disabled selected hidden>Select type</option>` : ""}
  <option value="wall" ${state.single.type === "wall" ? "selected" : ""}>High Wall</option>
  <option value="cassette" ${state.single.type === "cassette" ? "selected" : ""} ${!hasCassette ? "disabled" : ""}>Cassette${!hasCassette ? " (not available)" : ""}</option>`;
    }

    function renderRooms() {
        const mz = CONFIG.multiZone.series[state.series];
        document.getElementById("gbRooms").innerHTML = state.rooms.map((r, i) => {
            const hasCassette = mz.cassetteSizes.length > 0;
            const type = r.type === "cassette" && hasCassette ? "cassette" : "wall"; // used for sizing
            const displayType = r.type; // null if unset — used for selected state
            const availSizes = type === "cassette" ? mz.cassetteSizes : mz.wallSizes;
            const eff = effectiveSqft(r.len, r.wid, r.height);
            const suggested = eff > CONFIG.maxEffSqft ? null : suggestBtu(eff, CONFIG.multiBands, availSizes);
            const currentSize = availSizes.includes(Number(r.size)) ? Number(r.size) : (suggested || null);
            const sf = (Number(r.len) || 0) * (Number(r.wid) || 0);
            return `
            <div class="gb-room-card">
            <div class="gb-room-header">
                <span class="gb-room-name">${r.label}</span>
                <button class="gb-remove-btn" data-remove="${i}">Remove</button>
            </div>
            <div class="gb-room-dims">
                <div class="gb-field"><label>Length (ft)</label><input type="number" min="0" step="0.5" value="${r.len || ""}" data-room="${i}" data-k="len" placeholder="length" required></div>
            <div class="gb-field"><label>Width (ft)</label><input type="number" min="0" step="0.5" value="${r.wid || ""}" data-room="${i}" data-k="wid" placeholder="width" required></div>
            <div class="gb-field"><label>Ceiling (ft)</label><input type="number" min="7" max="20" step="0.5" value="${r.height || ""}" data-room="${i}" data-k="height" placeholder="height" required></div>
            </div>


            <div class="gb-room-opts">
            <div class="gb-field">
            <label>Air handler</label>
            <select data-room="${i}" data-k="type">
                ${!r.type ? `<option value="" disabled selected hidden>Select type</option>` : ""}
                <option value="wall" ${displayType === "wall" ? "selected" : ""}>High Wall</option>
                ${hasCassette ? `<option value="cassette" ${displayType === "cassette" ? "selected" : ""}>Cassette</option>` : ""}
                <option value="ducted" disabled>Hidden ducted (coming soon)</option>
            </select>
            </div>

            <div class="gb-field">
            <label>Size</label>
            <select data-room="${i}" data-k="size">
                ${(!r.len || !r.wid || !r.height || !r.type)
                ? `<option value="" disabled selected hidden>—</option>${availSizes.map(btu => `<option value="${btu}">${Math.round(btu / 1000)}k</option>`).join("")}`
                : availSizes.map(btu => `<option value="${btu}" ${currentSize === btu ? "selected" : ""}>${Math.round(btu / 1000)}k</option>`).join("")
                }
            </select>
            </div>
        </div>

        <div class="gb-room-opts">
            <div class="gb-field">
            <label>Line set</label>
            <select data-room="${i}" data-k="lineLen">
                ${CONFIG.mzLineLengths.map(ft => {
                const needsCoupler = ft >= 65;
                const label = ft === 15 ? ft + ' ft (included)' : needsCoupler ? ft + ' ft w/ Coupler' : ft + ' ft (upgrade)';
                return '<option value="' + ft + '"' + (Number(r.lineLen) === ft ? ' selected' : '') + '>' + label + '</option>';
                }).join("")}
            </select>
            </div>

            <div class="gb-field">
            <label>Line Guard</label>
            <select data-room="${i}" data-k="lineGuard">
                <option value="" ${!r.lineGuard ? "selected" : ""}>None</option>
                <option value="yes" ${r.lineGuard === "yes" || r.lineGuard === true ? "selected" : ""}>Add Line Guard</option>
            </select>
            </div>
        </div>
        ${(!r.len || !r.wid || !r.height || !r.type) ? `` : suggested ? `<div class="gb-room-hint">~${Math.round(sf)} sq ft, ${r.height}ft → <strong>${Math.round(eff)} eq sq ft</strong> → suggested <strong>${Math.round(suggested / 1000)}k</strong></div>` : `<div class="gb-room-hint" style="color:#b91c1c;">Exceeds max coverage</div>`}
        </div>`;
        }).join("");
    }

    function isSelectedYes(value) {
        return value === true || value === "yes";
    }

    function largeSingleUnitSummary(unit) {
        const parts = [];

        parts.push(`${Number(unit.lineLen) || 15}ft line set`);

        if (Number(unit.lineLen) >= 65) {
            parts[parts.length - 1] += " w/ coupler";
        }

        if (isSelectedYes(unit.lineGuard)) parts.push("Line Guard");
        if (unit.mount === "ground") parts.push("Ground Stand");
        if (unit.mount === "wall") parts.push("Wall Bracket");
        if (isSelectedYes(unit.condenserPad)) parts.push("Condenser Pad");
        if (isSelectedYes(unit.disconnect)) parts.push("Disconnect");

        return `${unit.label || "Unit"}: ${parts.join(" + ")}`;
    }

    function getSavedSystemAccessoryLabels(s) {
        const labels = [];

        if (s.mode === "single") {
            if (s.lineGuard === "yes" || s.lineGuard === true) labels.push("Line Guard");
            if (s.mount === "ground") labels.push("Ground Stand");
            if (s.mount === "wall") labels.push("Wall Bracket");
            if (s.condenserPad) labels.push("Condenser Pad");
            if (s.disconnect) labels.push("Disconnect Switch & Whip");
        }

        if (s.mode === "multi") {
            const roomLineGuards = (s.summaries || []).filter(r => r.lineGuard).length;
            if (roomLineGuards) labels.push(`${roomLineGuards} Line Guard${roomLineGuards > 1 ? "s" : ""}`);
            const acc = s.mzAccessories || {};
            if (acc.mount === "ground") labels.push("Ground Stand");
            if (acc.mount === "wall") labels.push("Wall Bracket");
            if (acc.condenserPad) labels.push("Condenser Pad");
            if (acc.disconnect) labels.push("Disconnect Switch & Whip");
        }
        if (s.mode === "large-single") {
            const units = s.units || [];

            const lineGuardCount = units.filter(u => isSelectedYes(u.lineGuard)).length;
            if (lineGuardCount) {
                labels.push(`${lineGuardCount} Line Guard${lineGuardCount > 1 ? "s" : ""}`);
            }

            const upgradedLines = units.filter(u => Number(u.lineLen) > 15).length;
            if (upgradedLines) {
                labels.push(`${upgradedLines} upgraded line set${upgradedLines > 1 ? "s" : ""}`);
            }

            const groundCount = units.filter(u => u.mount === "ground").length;
            if (groundCount) {
                labels.push(`${groundCount} Ground Stand${groundCount > 1 ? "s" : ""}`);
            }

            const wallCount = units.filter(u => u.mount === "wall").length;
            if (wallCount) {
                labels.push(`${wallCount} Wall Bracket${wallCount > 1 ? "s" : ""}`);
            }

            const padCount = units.filter(u => isSelectedYes(u.condenserPad)).length;
            if (padCount) {
                labels.push(`${padCount} Condenser Pad${padCount > 1 ? "s" : ""}`);
            }

            const disconnectCount = units.filter(u => isSelectedYes(u.disconnect)).length;
            if (disconnectCount) {
                labels.push(`${disconnectCount} Disconnect${disconnectCount > 1 ? "s" : ""}`);
            }
        }
        return labels;
    }

    async function getFirstVariantForHandle(handle) {
        const product = await fetchProduct(handle);
        return product?.variants?.[0] || null;
    }

    async function addAccessoryPrice(total, handle) {
        const price = await getVariantPriceCents(handle);
        return total + (price || 0);
    }

    async function fetchSavedSystemPriceCents(s) {
        let total = 0;

        if (s.mode === "single") {
            const bundlePrice = await getVariantPriceCents(s.handle);
            if (bundlePrice) total += bundlePrice;

            if (Number(s.lineLen) > 15) {
                const linePrice = await getSzLinesetPriceCents(s.lineLen);
                if (linePrice) total += linePrice;
            }

            if (s.lineGuard === "yes" || s.lineGuard === true) {
                total = await addAccessoryPrice(total, CONFIG.accessories.lineguard);
            }

            if (s.mount === "ground") total = await addAccessoryPrice(total, CONFIG.accessories.groundStand);
            if (s.mount === "wall") total = await addAccessoryPrice(total, CONFIG.accessories.wallBracket);
            if (s.condenserPad) total = await addAccessoryPrice(total, CONFIG.accessories.condenserPad);
            if (s.disconnect) total = await addAccessoryPrice(total, CONFIG.accessories.disconnect);
        }
        if (s.mode === "large-single") {
            const units = s.units || [];

            for (const unit of units) {
                const bundlePrice = await getVariantPriceCents(s.handle);
                if (bundlePrice) total += bundlePrice;

                if (Number(unit.lineLen) > 15) {
                    const linePrice = await getSzLinesetPriceCents(unit.lineLen);
                    if (linePrice) total += linePrice;
                }

                if (unit.lineGuard === "yes" || unit.lineGuard === true) {
                    total = await addAccessoryPrice(total, CONFIG.accessories.lineguard);
                }

                if (unit.mount === "ground") {
                    total = await addAccessoryPrice(total, CONFIG.accessories.groundStand);
                }

                if (unit.mount === "wall") {
                    total = await addAccessoryPrice(total, CONFIG.accessories.wallBracket);
                }

                if (unit.condenserPad === "yes" || unit.condenserPad === true) {
                    total = await addAccessoryPrice(total, CONFIG.accessories.condenserPad);
                }

                if (unit.disconnect === "yes" || unit.disconnect === true) {
                    total = await addAccessoryPrice(total, CONFIG.accessories.disconnect);
                }
            }
        }
        if (s.mode === "multi") {
            const condPrice = await getVariantPriceCents(s.condenser?.handle);

            if (condPrice) {
                total += condPrice;
            }

            const mzSeries = CONFIG.multiZone.series[s.series];

            for (const room of (s.summaries || [])) {
                if (room.empty || room.overLimit || !room.chosen) continue;

                const ahuHandle = getMultiZoneAhuHandle(mzSeries, room);
                if (!ahuHandle) continue;

                const ahuProduct = await fetchProduct(ahuHandle);

                const usesIndividualAhuProduct =
                    (room.type === "cassette" && mzSeries.cassetteHandleByBtu) ||
                    (room.type !== "cassette" && mzSeries.wallHandleByBtu);

                const ahuVariant = usesIndividualAhuProduct ?
                    ahuProduct?.variants?.[0] :
                    resolveVariantByBtuAndSeries(
                        ahuProduct,
                        room.chosen,
                        s.seriesLabel || s.series
                    );

                const ahuPrice = ahuVariant?.price ? parseInt(ahuVariant.price, 10) : null;

                if (ahuPrice) {
                    total += ahuPrice;
                }

                const roomLineLen = Number(room.lineLen || CONFIG.defaultLineLen);
                const linePrice = await getLinesetPriceCents(room.chosen, roomLineLen);

                if (linePrice) {
                    total += linePrice;
                }

                if (room.lineGuard === "yes" || room.lineGuard === true) {
                    total = await addAccessoryPrice(total, CONFIG.accessories.lineguard);
                }
            }

            const acc = s.mzAccessories || {};

            if (acc.mount === "ground") {
                total = await addAccessoryPrice(total, CONFIG.accessories.groundStand);
            }

            if (acc.mount === "wall") {
                total = await addAccessoryPrice(total, CONFIG.accessories.wallBracket);
            }

            if (acc.mount === "pad" || acc.condenserPad === true || acc.condenserPad === "yes") {
                total = await addAccessoryPrice(total, CONFIG.accessories.condenserPad);
            }

            if (acc.disconnect) {
                total = await addAccessoryPrice(total, CONFIG.accessories.disconnect);
            }
        }

        return {
            originalCents: total,
            discountedCents: Math.round(total * DISCOUNT_MULTIPLIER),
        };
    }

    function renderSavedSystems() {
        const existing = document.getElementById("gbSavedSystems");
        if (existing) existing.remove();
        if (!state.savedSystems.length) return;

        const el = document.createElement("div");
        el.id = "gbSavedSystems";
        el.style.cssText = "margin:16px 0;border:1.5px solid var(--c-border);border-radius:var(--radius-md);padding:14px;background:var(--c-surface);";

        el.innerHTML = `
    <style>
      .gb-saved-system-row { border-bottom: 1px solid var(--c-border); padding: 10px 0; }
      .gb-saved-system-row:last-of-type { border-bottom: none; }
      .gb-saved-system-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 8px; }
      .gb-saved-system-desc { flex: 1; font-size: 13px; line-height: 1.5; min-width: 0; }
      .gb-saved-system-actions { display: flex; gap: 6px; flex-shrink: 0; align-items: center; }
      .gb-edit-btn { font-size: 12px; padding: 4px 10px;  cursor: pointer; color: var(--c-brand); font-weight: 700; border: none; }
      .gb-edit-btn:hover { color: black }
      .gb-saved-price-row { display: flex; justify-content: space-between; align-items: center; margin-top: 6px; font-size: 13px; }
      .gb-saved-price-row .saved-price-label { color: var(--c-muted); font-size: 12px; }
      .gb-saved-price-row .saved-price-val { font-weight: 700; color: var(--c-dark); display: flex; align-items: center; gap: 4px; }
      .gb-saved-subtotal { display: flex; justify-content: space-between; align-items: center; margin-top: 12px; padding-top: 10px; border-top: 2px solid var(--c-dark); font-size: 14px; font-weight: 800; }
      .gb-saved-subtotal .subtotal-val { color: var(--c-brand); font-size: 16px; }
      .gb-saved-loading { color: var(--c-muted); font-style: italic; font-size: 12px; font-weight: 400; }
    </style>

    <div class="gb-section-label" style="margin-bottom:8px;">Saved systems (${state.savedSystems.length})</div>

    ${state.savedSystems.map((s, i) => `
      <div class="gb-saved-system-row">
        <div class="gb-saved-system-header">
          <span class="gb-saved-system-desc">
            <strong>${s.label}</strong> — ${s.seriesLabel}
    ${s.mode === "multi"
  ? ` · ${s.roomCount}-Zone · w/ ${s.summaries.map(r =>
      `${Math.round(r.chosen / 1000)}k ${r.type === "cassette" ? "Cassette" : "High Wall"} (${r.lineLen}ft${r.lineLen >= 65 ? " w/ coupler" : ""})`
    ).join(", ")}`
  : s.mode === "large-single"
  ? ` · Large Space · ${s.systemsNeeded} × ${Math.round(s.recommendedBtu / 1000)}k ${s.voltage}V systems<br>
     <span style="color:var(--c-muted);font-size:12px;">
       ${(s.units || []).map(largeSingleUnitSummary).join(" · ")}
     </span>`
    : ` · ${Math.round(s.chosen / 1000)}k ${s.type === "cassette" ? "Cassette" : "High Wall"} · ${s.voltage}V · ${s.lineLen}ft line set${s.lineLen >= 65 ? " w/ coupler" : ""}`
}
${getSavedSystemAccessoryLabels(s).length
  ? `<br><span style="color:var(--c-muted);font-size:12px;">Accessories: ${getSavedSystemAccessoryLabels(s).join(", ")}</span>`
  : ""
}
          </span>
          <span class="gb-saved-system-actions">
            <button class="gb-edit-btn" data-edit-saved="${i}">Edit</button>
            <button class="gb-remove-btn" data-remove-saved="${i}">Remove</button>
          </span>
        </div>
        <div class="gb-saved-price-row">
          <span class="saved-price-label">System price (w/ discount)</span>
          <span class="saved-price-val" id="gb-saved-price-${i}">
            <span class="gb-saved-loading">—</span>
          </span>
        </div>
      </div>
    `).join("")}

    <div class="gb-saved-subtotal">
      <span>Subtotal (${state.savedSystems.length} system${state.savedSystems.length > 1 ? "s" : ""})</span>
      <span class="subtotal-val" id="gb-saved-subtotal">
        <span class="gb-saved-loading">—</span>
      </span>
    </div>

    <button class="gb-btn gb-btn-dark" id="gbAddAllSaved" style="width:100%;margin-top:12px;">
      Add ${state.savedSystems.length} system${state.savedSystems.length > 1 ? "s" : ""} to cart
    </button>
  `;

        document.getElementById("gbResults").after(el);

        // ---- Edit ----
        // ---- Edit ----
        el.querySelectorAll("[data-edit-saved]").forEach(btn => {
            btn.addEventListener("click", () => {
                const idx = Number(btn.dataset.editSaved);
                renderEditModal(idx);
            });
        });

        // ---- Remove ----
        el.querySelectorAll("[data-remove-saved]").forEach(btn => {
            btn.addEventListener("click", () => {
                state.savedSystems.splice(Number(btn.dataset.removeSaved), 1);
                state.savedSystems.forEach((s, i) => s.label = `System ${i + 1}`);
                saveState();
                renderSavedSystems();
            });
        });

        // ---- Add all to cart ----
        document.getElementById("gbAddAllSaved")?.addEventListener("click", async () => {
            const btn = document.getElementById("gbAddAllSaved");
            btn.disabled = true;
            btn.textContent = "Adding…";

            try {
                const items = [];

                for (const s of state.savedSystems) {
                    if (s.mode === "multi") {
                        const condProduct = await fetchProduct(s.condenser.handle);
                        items.push({
                            id: condProduct.variants[0].id,
                            quantity: 1,
                            properties: {
                                "_source": "GWIN Builder",
                                "_series": s.seriesLabel,
                                "_system": s.label
                            }
                        });

                        const mzSeries = CONFIG.multiZone.series[s.series];
                        for (const room of s.summaries) {
                            const ahuHandle = getMultiZoneAhuHandle(mzSeries, room);
                            if (!ahuHandle) continue;
                            const ahuProduct = await fetchProduct(ahuHandle);
                            const usesIndividualAhuProduct = (room.type === "cassette" && mzSeries.cassetteHandleByBtu) || (room.type !== "cassette" && mzSeries.wallHandleByBtu);
                            const ahuVariant = usesIndividualAhuProduct ? ahuProduct.variants?.[0] : resolveVariantByBtuAndSeries(ahuProduct, room.chosen, s.seriesLabel || s.series);
                            if (!ahuVariant) continue;
                            items.push({
                                id: ahuVariant.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label,
                                    "_room": room.label || ""
                                }
                            });
                            // ADD THIS: multi-zone line set for this room
                            const roomLineLen = Number(room.lineLen || CONFIG.defaultLineLen);
                            const lineVariant = await resolveLinesetVariant(room.chosen, roomLineLen);

                            if (!lineVariant) {
                                throw new Error(`No multi-zone line set variant found for ${room.chosen} BTU / ${roomLineLen}ft`);
                            }

                            items.push({
                                id: lineVariant.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label,
                                    "_room": room.label || "",
                                },
                            });
                            if (room.lineGuard) {
                                const v = await getFirstVariantForHandle(CONFIG.accessories.lineguard);
                                if (v) items.push({
                                    id: v.id,
                                    quantity: 1,
                                    properties: {
                                        "_source": "GWIN Builder",
                                        "_series": s.seriesLabel,
                                        "_system": s.label,
                                        "_room": room.label || ""
                                    }
                                });
                            }
                        }

                        const acc = s.mzAccessories || {};
                        if (acc.mount === "ground") {
                            const v = await getFirstVariantForHandle(CONFIG.accessories.groundStand);
                            if (v) items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                        }
                        if (acc.mount === "wall") {
                            const v = await getFirstVariantForHandle(CONFIG.accessories.wallBracket);
                            if (v) items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                        }
                        if (acc.mount === "pad") {
                            const v = await getFirstVariantForHandle(CONFIG.accessories.condenserPad);
                            if (v) items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                        }
                        if (acc.disconnect) {
                            const v = await getFirstVariantForHandle(CONFIG.accessories.disconnect);
                            if (v) items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                        }

                    } else if (s.mode === "large-single") {
                        const product = await fetchProduct(s.handle);
                        for (const unit of (s.units || [])) {
                            const variant = resolveVariantByBtuVoltage(product, unit.chosen || s.recommendedBtu, s.voltage) || product.variants?.[0];
                            if (variant) items.push({
                                id: variant.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                            const unitLineLen = Number(unit.lineLen || 15);

                            if (unitLineLen > 15) {
                                const lineVariant = await resolveSzLinesetVariant(unitLineLen);

                                // console.log("Adding saved large-single line upgrade:", {
                                //     wantedLen: unitLineLen,
                                //     variantId: lineVariant?.id,
                                //     title: lineVariant?.title,
                                //     option1: lineVariant?.option1,
                                //     option2: lineVariant?.option2,
                                //     option3: lineVariant?.option3,
                                //   });


                                if (lineVariant) {
                                    items.push({
                                        id: lineVariant.id,
                                        quantity: 1,
                                        properties: {
                                            "_source": "GWIN Builder",
                                            "_series": s.seriesLabel,
                                            "_system": s.label,
                                            "_debug_item": `${s.label} ${unit.label || "Unit"} ${unitLineLen}ft SZ line upgrade`,
                                        },
                                    });
                                }
                            }
                            if (unit.lineGuard === "yes" || unit.lineGuard === true) {
                                const v = await getFirstVariantForHandle(CONFIG.accessories.lineguard);
                                if (v) items.push({
                                    id: v.id,
                                    quantity: 1,
                                    properties: {
                                        "_source": "GWIN Builder",
                                        "_series": s.seriesLabel,
                                        "_system": s.label
                                    }
                                });
                            }
                            if (unit.mount === "ground") {
                                const v = await getFirstVariantForHandle(CONFIG.accessories.groundStand);
                                if (v) items.push({
                                    id: v.id,
                                    quantity: 1,
                                    properties: {
                                        "_source": "GWIN Builder",
                                        "_series": s.seriesLabel,
                                        "_system": s.label
                                    }
                                });
                            }
                            if (unit.mount === "wall") {
                                const v = await getFirstVariantForHandle(CONFIG.accessories.wallBracket);
                                if (v) items.push({
                                    id: v.id,
                                    quantity: 1,
                                    properties: {
                                        "_source": "GWIN Builder",
                                        "_series": s.seriesLabel,
                                        "_system": s.label
                                    }
                                });
                            }
                            if (unit.mount === "pad") {
                                const v = await getFirstVariantForHandle(CONFIG.accessories.condenserPad);
                                if (v) items.push({
                                    id: v.id,
                                    quantity: 1,
                                    properties: {
                                        "_source": "GWIN Builder",
                                        "_series": s.seriesLabel,
                                        "_system": s.label
                                    }
                                });
                            }
                            if (unit.disconnect === "yes" || unit.disconnect === true) {
                                const v = await getFirstVariantForHandle(CONFIG.accessories.disconnect);
                                if (v) items.push({
                                    id: v.id,
                                    quantity: 1,
                                    properties: {
                                        "_source": "GWIN Builder",
                                        "_series": s.seriesLabel,
                                        "_system": s.label
                                    }
                                });
                            }
                        }

                    } else {
                        // single-zone
                        const product = await fetchProduct(s.handle);
                        const variant = resolveVariantByBtuVoltage(product, s.chosen, s.voltage) || product.variants?.[0];
                        if (!variant) continue;
                        items.push({
                            id: variant.id,
                            quantity: 1,
                            properties: {
                                "_source": "GWIN Builder",
                                "_series": s.seriesLabel,
                                "_system": s.label
                            }
                        });

                        if (Number(s.lineLen) > 15) {
                            const lineVariant = await resolveSzLinesetVariant(s.lineLen);
                            if (lineVariant) items.push({
                                id: lineVariant.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                        }
                        if (s.lineGuard === "yes" || s.lineGuard === true) {
                            const v = await getFirstVariantForHandle(CONFIG.accessories.lineguard);
                            if (v) items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                        }
                        if (s.mount === "ground") {
                            const v = await getFirstVariantForHandle(CONFIG.accessories.groundStand);
                            if (v) items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                        }
                        if (s.mount === "wall") {
                            const v = await getFirstVariantForHandle(CONFIG.accessories.wallBracket);
                            if (v) items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                        }
                        if (s.mount === "pad") {
                            const v = await getFirstVariantForHandle(CONFIG.accessories.condenserPad);
                            if (v) items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                        }
                        if (s.disconnect) {
                            const v = await getFirstVariantForHandle(CONFIG.accessories.disconnect);
                            if (v) items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label
                                }
                            });
                        }
                    }
                }
                // console.table(items.map(item => ({
                //   id: item.id,
                //   qty: item.quantity,
                //   debug: item.properties?._debug_item || "",
                //   props: JSON.stringify(item.properties || {}),
                // })));
                await addToCart(items);
                btn.textContent = "Added to cart!";
                state.savedSystems = [];
                saveState();
                setTimeout(() => renderSavedSystems(), 800);
            } catch (e) {
                console.error(e);
                btn.disabled = false;
                btn.textContent = "Failed — try again";
            }
        });

        // ---- Async prices + subtotal ----
        (async () => {
            let grandOriginal = 0;
            let grandDiscounted = 0;

            for (let i = 0; i < state.savedSystems.length; i++) {
                const priceEl = document.getElementById(`gb-saved-price-${i}`);
                try {
                    const {
                        originalCents,
                        discountedCents
                    } = await fetchSavedSystemPriceCents(state.savedSystems[i]);
                    grandOriginal += originalCents;
                    grandDiscounted += discountedCents;
                    if (priceEl) {
                        priceEl.innerHTML = `
            <span class="gb-price-original">${formatMoneyFromCents(originalCents)}</span>
            <span class="gb-price-discounted">${formatMoneyFromCents(discountedCents)}</span>
          `;
                    }
                } catch {
                    if (priceEl) priceEl.innerHTML = `<span style="color:var(--c-muted);">—</span>`;
                }
            }

            const subtotalEl = document.getElementById("gb-saved-subtotal");
            if (subtotalEl) {
                subtotalEl.innerHTML = grandDiscounted > 0 ?
                    `<span class="gb-price-original" style="font-size:13px;">${formatMoneyFromCents(grandOriginal)}</span> ${formatMoneyFromCents(grandDiscounted)}` :
                    `<span style="color:var(--c-muted);">—</span>`;
            }
        })();
    }

    function renderResults() {
        const myToken = ++renderToken;
        saveState();
        const resultsEl = document.getElementById("gbResults");
        const errBlock = document.getElementById("gbErrorBlock");
        const addToCartBtn = document.getElementById("gbAddToCart");
        const addBundleBtn = document.getElementById("gbAddBundle");
        const condRecEl = document.getElementById("gbCondenserRec");
        const partsEl = document.getElementById("gbPartsList");
        const seriesFeatEl = document.getElementById("gbSeriesFeatures");

        const seriesCfg = state.mode === "single" ?
            CONFIG.singleZone[state.series] :
            CONFIG.multiZone.series[state.series];

        // Always show results
        resultsEl.style.display = "block";
        addToCartBtn.style.display = "none";
        addBundleBtn.style.display = "none";
        condRecEl.style.display = "none";
        errBlock.style.display = "none";

        // Only show features after type is selected
        const typeSelected = state.mode === "single" ? !!state.single.type : state.rooms.some(r => !!r.type);
        seriesFeatEl.innerHTML = typeSelected ?
            (seriesCfg?.features || []).map(f => `<span class="gb-feature-chip">${f.text}</span>`).join("") +
            (seriesCfg?.preorder ? ` <span class="gb-preorder-badge">Pre-Order Only</span>` : "") :
            "";

        if (state.mode === "single") {
            const sz = computeSingle();
            setSingleLineGuardDisabled(!!sz?.overLimit);
            if (!sz) {
                setSingleLineGuardDisabled(false);

                document.getElementById("gbTotalBtu").textContent = "—";
                document.getElementById("gbTotalKw").textContent = "—";

                // Clear stale single-zone result content
                document.getElementById("gbRoomSummary").innerHTML = "";
                partsEl.innerHTML = "";
                seriesFeatEl.innerHTML = "";
                errBlock.style.display = "none";
                errBlock.textContent = "";

                condRecEl.innerHTML = "";
                condRecEl.style.display = "none";

                // Remove stale save/config buttons
                document.getElementById("gbConfigAnother")?.remove();
                document.getElementById("gbMzConfigAnother")?.remove();
                document.getElementById("gbConfigureLargeSpace")?.remove();
                document.getElementById("gbSaveLargeSpace")?.remove();

                addToCartBtn.style.display = "block";
                addToCartBtn.disabled = true;
                addToCartBtn.style.opacity = "0.45";
                addToCartBtn.style.cursor = "not-allowed";

                addBundleBtn.style.display = "none";

                return;
            }

            if (sz.overLimit) {
                const systemsNeeded = Math.ceil(sz.eff / CONFIG.maxEffSqft);
                const sz2 = CONFIG.singleZone[state.series];
                const recommendedBtu = sz2.wallSizes[sz2.wallSizes.length - 1];

                const handleMap = sz2.bundleHandle?.[recommendedBtu] || {};
                const selectedVoltage =
                    handleMap[state.voltage] ? state.voltage :
                    handleMap[String(state.voltage)] ? String(state.voltage) :
                    handleMap[230] ? 230 :
                    handleMap["230"] ? "230" :
                    handleMap[115] ? 115 :
                    handleMap["115"] ? "115" :
                    Object.keys(handleMap)[0];

                const handle = handleMap[selectedVoltage];

                // Large-space recommendations are multiple complete systems.
                // Do not allow single aggregate line-set/accessory selection here.
                state.single.mount = "";
                state.single.condenserPad = false;
                state.single.disconnect = false;
                state.single.lineGuard = false;

                const szAccCard = document.getElementById("gbSzAccessoriesCard");
                if (szAccCard) szAccCard.style.display = "none";

                document.getElementById("gbConfigAnother")?.remove();
                document.getElementById("gbMzConfigAnother")?.remove();

                document.getElementById("gbTotalBtu").textContent = `${systemsNeeded} ×`;
                document.getElementById("gbTotalKw").textContent = `${Math.round(recommendedBtu / 1000)}k recommended`;
                document.getElementById("gbRoomSummary").innerHTML = "";

                condRecEl.style.display = "flex";
                condRecEl.innerHTML = `
    <span class="gb-rec-main">
      <span class="gb-rec-text">
        Large space (~${Math.round(sz.eff)} eq sq ft) — we recommend
        <strong>${systemsNeeded} × ${Math.round(recommendedBtu / 1000)}k</strong> single-zone systems
      </span>
    </span>
    <span class="cond-price gb-rec-price-wrap">—</span>
  `;

                partsEl.innerHTML = `
  <div class="gb-part-row">
    <span>Recommended configuration</span>
    <span class="part-price">${systemsNeeded} systems</span>
  </div>

  <div class="gb-part-row">
    <span>Each system</span>
    <span class="part-price">${Math.round(recommendedBtu / 1000)}k · ${selectedVoltage}V</span>
  </div>

  <div style="margin-top:12px;display:flex;flex-direction:column;gap:8px;">
  <button class="gb-btn gb-btn-dark" id="gbConfigureLargeSpace">
    Configure ${systemsNeeded} Recommended Systems →
  </button>

</div>
`;

                function clearLargeSpaceRecommendationUI() {
                    document.getElementById("gbConfigureLargeSpace")?.remove();
                    document.getElementById("gbSaveLargeSpace")?.remove();

                    partsEl.innerHTML = "";
                    condRecEl.innerHTML = "";
                    condRecEl.style.display = "none";

                    document.getElementById("gbTotalBtu").textContent = "—";
                    document.getElementById("gbTotalKw").textContent = "—";
                    document.getElementById("gbRoomSummary").innerHTML = "";
                }

                function saveLargeSingleRecommendation() {
                    state.savedSystems.push({
                        label: `System ${state.savedSystems.length + 1}`,
                        mode: "large-single",
                        series: state.series,
                        seriesLabel: sz2.label || state.series,
                        voltage: selectedVoltage,
                        recommendedBtu,
                        systemsNeeded,
                        handle,
                        type: "wall",
                        units: Array.from({
                            length: systemsNeeded
                        }, (_, i) => ({
                            label: `Unit ${i + 1}`,
                            chosen: recommendedBtu,
                            type: "wall",
                            lineLen: 15,
                            lineGuard: false,
                            mount: "",
                            condenserPad: false,
                            disconnect: false,
                        })),
                    });

                    const newIndex = state.savedSystems.length - 1;

                    state.single = getFreshSingleState();
                    clearSingleFormDomValues();
                    clearLargeSpaceRecommendationUI();

                    saveState();

                    return newIndex;;
                }

                document.getElementById("gbConfigureLargeSpace")?.addEventListener("click", () => {
                    if (!handle) {
                        console.warn("No large-space handle found.");
                        return;
                    }

                    clearEditingMode();

                    const newIndex = saveLargeSingleRecommendation();

                    render();

                    requestAnimationFrame(() => {
                        renderLargeSingleEditModal(newIndex);
                    });
                });

                errBlock.style.display = "none";

                seriesFeatEl.innerHTML = (sz2.features || []).map(f => `
  <span class="gb-feature-chip">
    <span>${f.icon}</span>
    <span>${f.text}</span>
  </span>
`).join("");

                // Fetch image + starting price for the exact recommended product.
                if (handle) {
                    (async () => {
                        const asyncToken = myToken;

                        try {
                            const product = await fetchProduct(handle);
                            const img = getProductFeaturedImage(product);
                            const variant =
                                resolveVariantByBtuVoltage(product, recommendedBtu, selectedVoltage) ||
                                product?.variants?.[0];

                            const price = variant?.price ? parseInt(variant.price, 10) : 0;
                            const d = price ? formatMoneyDiscounted(price * systemsNeeded) : null;

                            if (renderToken !== asyncToken) return;

                            condRecEl.innerHTML = `
        <span class="gb-rec-main">
          ${img ? `<img class="gb-rec-img" src="${img}" alt="${sz2.label} ${Math.round(recommendedBtu / 1000)}k single-zone system">` : ""}
          <span class="gb-rec-text">
            Large space (~${Math.round(sz.eff)} eq sq ft) — we recommend
            <strong>${systemsNeeded} × ${Math.round(recommendedBtu / 1000)}k</strong> single-zone systems
          </span>
        </span>

        <span class="cond-price gb-rec-price-wrap">
          ${d
            ? `<span class="gb-price-original">${d.original}</span><span class="gb-price-discounted">${d.discounted}</span>`
            : "—"
          }
        </span>
      `;
                        } catch (err) {
                            console.warn("Large-space recommendation image/price failed:", err);
                        }
                    })();
                }
                return;
            }

            setSingleLineGuardDisabled(false);

            document.getElementById("gbTotalBtu").textContent = Math.round(sz.chosen / 1000) + "k";
            document.getElementById("gbTotalKw").textContent = btuToKw(sz.chosen);
            document.getElementById("gbRoomSummary").innerHTML = `
  <div class="gb-room-summary-row">
    <span class="room-label">Room</span>
    <span class="room-detail">
      ${Math.round((Number(state.single.len) || 0) * (Number(state.single.wid) || 0))} sq ft
      · ${state.single.height}ft ceiling
      → <strong>${sz.eff} eq sq ft</strong>
      → <strong>${Math.round(sz.chosen / 1000)}k</strong> ${sz.type === "cassette" ? "Slim Cassette" : "High Wall"} · ${sz.voltage}V
    </span>
  </div>`;

            const lineLabel = sz.lineLen > 15 ? `${sz.lineLen}ft line set (upgrade from 15ft included)` : "15ft line set (included)";
            condRecEl.style.display = "flex";
            const szSeriesLabel = CONFIG.singleZone[state.series]?.label || state.series;
            condRecEl.innerHTML = `
  <span>${szSeriesLabel} — <strong>${Math.round(sz.chosen / 1000)}k</strong> ${sz.type === "cassette" ? "Cassette" : "High Wall"} · ${sz.voltage}V</span>
  ${CONFIG.singleZone[state.series]?.preorder ? `<span class="cond-warning"></span>` : ""}`;

            function buildSyncAccRows() {
                let rows = "";
                if (state.single.lineGuard) {
                    rows += `<div class="gb-part-row"><span>Line Guard</span><span class="part-price" id="gb-acc-lineguard-price">—</span></div>`;
                }
                if (state.single.mount === "wall") {
                    rows += `<div class="gb-part-row"><span>Condenser Wall Mount Bracket</span><span class="part-price" id="gb-acc-mount-price">—</span></div>`;
                } else if (state.single.mount === "ground") {
                    rows += `<div class="gb-part-row"><span>Condenser Ground Stand Brackets</span><span class="part-price" id="gb-acc-mount-price">—</span></div>`;
                }
                if (state.single.mount === "pad") {
                    rows += `<div class="gb-part-row"><span>Condenser Pad</span><span class="part-price" id="gb-acc-pad-price">—</span></div>`;
                }
                if (state.single.disconnect) {
                    rows += `<div class="gb-part-row"><span>Disconnect Switch &amp; Whip</span><span class="part-price" id="gb-acc-disconnect-price">—</span></div>`;
                }
                return rows;
            }

            partsEl.innerHTML = `
  <div class="gb-part-row"><span><strong>${Math.round(sz.chosen / 1000)}k</strong> ${sz.type === "cassette" ? "Cassette" : "High Wall"} Complete System</span><span class="part-price" id="gb-bundle-price">—</span></div>
  <div class="gb-part-row"><span>${lineLabel}</span><span class="part-price" id="gb-lineset-price">${sz.lineLen > 15 ? "—" : "Included"}</span></div>
  ${buildSyncAccRows()}
`;

            addToCartBtn.style.display = "block";
            // Remove any existing configure button to avoid duplication
            document.getElementById("gbConfigAnother")?.remove();
            const configBtn = document.createElement("button");
            configBtn.id = "gbConfigAnother";
            configBtn.className = "gb-btn";
            configBtn.style.cssText = "width:100%;margin-top:8px;";
            configBtn.textContent = "Save & Configure another space →";
            configBtn.addEventListener("click", () => {
                const sz = computeSingle();
                if (!sz || sz.overLimit || !sz.handle) return;

                const wasEditing = editingIndex >= 0;
                const savedLabel = wasEditing ?
                    state.savedSystems[editingIndex]?.label :
                    `System ${state.savedSystems.length + 1}`;

                clearEditingMode();

                const system = {
                    label: savedLabel || `System ${state.savedSystems.length + 1}`,
                    mode: "single",
                    series: state.series,
                    seriesLabel: CONFIG.singleZone[state.series]?.label || state.series,
                    voltage: sz.voltage,
                    type: sz.type,
                    chosen: sz.chosen,
                    handle: sz.handle,
                    lineLen: sz.lineLen,
                    len: state.single.len,
                    wid: state.single.wid,
                    height: state.single.height,
                    lineGuard: state.single.lineGuard,
                    mount: state.single.mount,
                    condenserPad: state.single.condenserPad,
                    disconnect: state.single.disconnect,
                };

                if (wasEditing) {
                    state.savedSystems[editingIndex] = system;
                } else {
                    state.savedSystems.push(system);
                }

                renderToken++;
                state.single = getFreshSingleState();
                clearSingleFormDomValues();

                const partsEl = document.getElementById("gbPartsList");
                const condRecEl = document.getElementById("gbCondenserRec");
                const totalBtuEl = document.getElementById("gbTotalBtu");
                const totalKwEl = document.getElementById("gbTotalKw");
                const roomSummaryEl = document.getElementById("gbRoomSummary");

                if (partsEl) partsEl.innerHTML = "";
                if (condRecEl) {
                    condRecEl.innerHTML = "";
                    condRecEl.style.display = "none";
                }
                if (totalBtuEl) totalBtuEl.textContent = "—";
                if (totalKwEl) totalKwEl.textContent = "—";
                if (roomSummaryEl) roomSummaryEl.innerHTML = "";

                saveState();
                render();
                requestAnimationFrame(() => scrollBuilderToTop());

            });

            document.getElementById("gbCartMsg").after(configBtn);
            if (!sz || sz.overLimit || !sz.handle) {
                configBtn.disabled = true;
                configBtn.style.opacity = "0.45";
                configBtn.style.cursor = "not-allowed";
            }
            if (!sz.handle) {
                addToCartBtn.disabled = true;
                addToCartBtn.style.opacity = "0.45";
                addToCartBtn.style.cursor = "not-allowed";
            } else {
                addToCartBtn.disabled = false;
                addToCartBtn.style.opacity = "";
                addToCartBtn.style.cursor = "";
            }
            // Async price fetch — updates parts list after render
            (async () => {
                try {
                    if (renderToken !== myToken) return;

                    function imgTag(src, alt = "") {
                        if (!src) return `<div style="width:36px;height:36px;border-radius:6px;background:#f0f0f0;flex-shrink:0;"></div>`;
                        return `<img src="${src}" alt="${alt}" style="width:36px;height:36px;object-fit:cover;border-radius:6px;border:1px solid #e0e0e0;flex-shrink:0;">`;
                    }

                    function partRow(imgSrc, label, priceHTML, alt = "") {
                        return `
        <div class="gb-part-row" style="align-items:center;gap:10px;">
          ${imgTag(imgSrc, alt)}
          <span style="flex:1;min-width:0;">${label}</span>
          <span class="part-price" style="flex-shrink:0;">${priceHTML}</span>
        </div>
      `;
                    }

                    function priceDisc(d) {
                        if (!d) return "—";
                        return `<span class="gb-price-original">${d.original}</span><span class="gb-price-discounted">${d.discounted}</span>`;
                    }

                    // Fetch all needed products in parallel
                    const [bundleProduct, lineguardProduct, groundProduct, wallProduct, padProduct, disconnectProduct] = await Promise.all([
                        fetchProduct(sz.handle).catch(() => null),
                        state.single.lineGuard ? fetchProduct(CONFIG.accessories.lineguard).catch(() => null) : null,
                        state.single.mount === "ground" ? fetchProduct(CONFIG.accessories.groundStand).catch(() => null) : null,
                        state.single.mount === "wall" ? fetchProduct(CONFIG.accessories.wallBracket).catch(() => null) : null,
                        state.single.mount === "pad" ? fetchProduct(CONFIG.accessories.condenserPad).catch(() => null) : null,
                        state.single.disconnect ? fetchProduct(CONFIG.accessories.disconnect).catch(() => null) : null,
                    ]);

                    if (renderToken !== myToken) return;

                    const bundleImg = getProductFeaturedImage(bundleProduct);
                    const variant = resolveVariantByBtuVoltage(bundleProduct, sz.chosen, sz.voltage) ?? bundleProduct?.variants?.[0];
                    const bundlePrice = variant?.price ? parseInt(variant.price, 10) : null;

                    let linePrice = null;
                    const lineImg = await getSzLinesetProductImage(sz.lineLen);

                    if (sz.lineLen > 15) {
                        linePrice = await getSzLinesetPriceCents(sz.lineLen);
                    }

                    const bp = formatMoneyDiscounted(bundlePrice);
                    const lp = linePrice ? formatMoneyDiscounted(linePrice) : null;

                    let accTotal = 0;
                    let rows = "";

                    const lineLabel = sz.lineLen > 15 ? `${sz.lineLen}ft line set (upgrade)` : "15ft line set (included)";

                    rows += partRow(bundleImg, `<strong>${Math.round(sz.chosen / 1000)}k</strong> ${sz.type === "cassette" ? "Cassette" : "High Wall"} Complete System`, priceDisc(bp), `${sz.chosen / 1000}k system`);
                    rows += partRow(lineImg, lineLabel, sz.lineLen > 15 ? priceDisc(lp) : "Included");

                    const totalDiscounted =
                        (bundlePrice ? bundlePrice * DISCOUNT_MULTIPLIER : 0) +
                        (linePrice ? linePrice * DISCOUNT_MULTIPLIER : 0);

                    if (state.single.lineGuard && lineguardProduct) {
                        const p = lineguardProduct.variants?.[0]?.price ? parseInt(lineguardProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) accTotal += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(lineguardProduct), "Line Guard", priceDisc(d));
                    }

                    if (state.single.mount === "ground" && groundProduct) {
                        const p = groundProduct.variants?.[0]?.price ? parseInt(groundProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) accTotal += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(groundProduct), "Condenser Ground Stand Brackets", priceDisc(d));
                    }

                    if (state.single.mount === "wall" && wallProduct) {
                        const p = wallProduct.variants?.[0]?.price ? parseInt(wallProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) accTotal += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(wallProduct), "Condenser Wall Mount Bracket", priceDisc(d));
                    }

                    if (state.single.mount === "pad" && padProduct) {
                        const p = padProduct.variants?.[0]?.price ? parseInt(padProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) accTotal += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(padProduct), "Condenser Pad", priceDisc(d));
                    }

                    if (state.single.disconnect && disconnectProduct) {
                        const p = disconnectProduct.variants?.[0]?.price ? parseInt(disconnectProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) accTotal += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(disconnectProduct), "Disconnect Switch &amp; Whip", priceDisc(d));
                    }

                    const grandTotal = totalDiscounted + accTotal;

                    if (renderToken !== myToken) return;

                    partsEl.innerHTML = rows + (grandTotal > 0 ? `
      <div class="gb-part-row part-total">
        <span>Estimated total (with discount)</span>
        <span class="part-price" style="color:var(--c-brand);">${formatMoneyFromCents(grandTotal)}</span>
      </div>` : "");

                    // Update condenser rec with image and price
                    const szSeriesLabel = CONFIG.singleZone[state.series]?.label || state.series;

                    if (renderToken !== myToken) return;

                    document.getElementById("gbCondenserRec").innerHTML = `
      <span class="gb-rec-main">
        ${bundleImg ? `<img class="gb-rec-img" src="${bundleImg}" alt="${szSeriesLabel} ${Math.round(sz.chosen / 1000)}k system">` : ""}
        <span class="gb-rec-text">
          ${szSeriesLabel} — <strong>${Math.round(sz.chosen / 1000)}k</strong>
          ${sz.type === "cassette" ? "Cassette" : "high wall"} · ${sz.voltage}V
        </span>
      </span>
      <span class="cond-price gb-rec-price-wrap">
        ${bp ? `<span class="gb-price-original">${bp.original}</span><span class="gb-price-discounted">${bp.discounted}</span>` : ""}
      </span>
      ${CONFIG.singleZone[state.series]?.preorder ? `<span class="cond-warning"></span>` : ""}
    `;
                } catch (e) {
                    console.warn("Price fetch failed:", e);
                }
            })();

            // Render accessories card + bind its events
            renderSzAccessoriesCard(sz);

            document.querySelectorAll("#gbSzMountOptions .gb-acc-option").forEach(el => {
                el.onclick = (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if (el.classList.contains("disabled")) return;

                    const clickedMount = el.dataset.mount || "";
                    const currentMount = state.single.mount || "";

                    state.single.mount = currentMount === clickedMount ? "" : clickedMount;
                    state.single.condenserPad = false;

                    saveState();
                    renderResults();
                };
            });


            document.getElementById("szDisconnectToggle").onclick = () => {
                state.single.disconnect = !state.single.disconnect;
                document.getElementById("szDisconnectToggle").classList.toggle("active", state.single.disconnect);
                saveState();
                renderResults();
            };
            // Always offer to configure another space
        } else {
            // Multi-zone
            const m = computeMulti();
            if (state.rooms.length === 0) {
                resultsEl.style.display = "none";
                return;
            }

            const mzSeries = CONFIG.multiZone.series[state.series];
            const mzSeriesLabel = mzSeries?.label || state.series;

            document.getElementById("gbTotalBtu").textContent = m.sumHeads ?
                Math.round(m.sumHeads / 1000) + "k" :
                "—";
            document.getElementById("gbTotalKw").textContent = m.sumHeads ?
                btuToKw(m.sumHeads) :
                "—";

            document.getElementById("gbRoomSummary").innerHTML = m.summaries.map(s => `
        <div class="gb-room-summary-row${s.overLimit ? " error" : ""}">
          <span class="room-label">${s.label}</span>
          <span class="room-detail">
            ${s.empty
              ? `<span style="color:var(--c-muted);">Enter dimensions</span>`
              : s.overLimit
                ? "⚠ Over max coverage" : `${s.sf} sq ft → ${s.eff} eq sq ft → <strong>${Math.round(s.chosen / 1000)}k</strong> ${getAhuTypeLabel(state.series, s.type, s.chosen)}`            }
          </span>
        </div>
      `).join("");

            if (m.hasError) {
                errBlock.style.display = "block";
                errBlock.textContent = `One or more rooms exceed max coverage (${CONFIG.maxEffSqft} effective sq ft).`;
                partsEl.innerHTML = "";
                condRecEl.style.display = "none";
                return;
            }

            const anyEmpty = m.summaries.some(s => s.empty);
            const completedRooms = m.summaries.filter(s => !s.empty && !s.overLimit && s.chosen);
            const hasCompletedRooms = completedRooms.length > 0;

            // Always render accessories in multi-zone.
            // The wall bracket option can still hide itself based on condenser size inside renderMzAccessoriesCard().
            renderMzAccessoriesCard(m.condenser);

            // Step 3 should populate progressively as rooms are filled out.
            condRecEl.style.display = hasCompletedRooms ? "flex" : "none";

            if (hasCompletedRooms) {
                condRecEl.innerHTML = `
    <span class="gb-rec-main">
      <span class="gb-rec-text">
        ${mzSeriesLabel} — <strong>${Math.round(m.condenser.btu / 1000)}k</strong> / ${m.condenser.zonesLabel} condenser
      </span>
    </span>
    <span class="cond-price gb-rec-price-wrap">—</span>
  `;
            }

            partsEl.innerHTML = m.summaries.map(room => {
                if (room.empty) {
                    return `
      <div class="gb-part-row">
        <span>${room.label}</span>
        <span class="part-price">Complete room details</span>
      </div>
    `;
                }

                if (room.overLimit) {
                    return `
      <div class="gb-part-row">
        <span>${room.label}</span>
        <span class="part-price">Over max coverage</span>
      </div>
    `;
                }

                return `
    <div class="gb-part-row">
      <span><strong>${room.label}</strong> — ${Math.round(room.chosen / 1000)}k ${getAhuTypeLabel(state.series, room.type, room.chosen)}</span>
      <span class="part-price">—</span>
    </div>
    <div class="gb-part-row">
      <span>${room.label}: ${room.lineLen}ft line set${room.lineLen >= 65 ? " w/ coupler" : ""}</span>
      <span class="part-price">—</span>
    </div>
    ${room.lineGuard ? `
      <div class="gb-part-row">
        <span>${room.label}: Line Guard</span>
        <span class="part-price">—</span>
      </div>
    ` : ""}
  `;
            }).join("");

            if (hasCompletedRooms) {
                (async () => {
                    const asyncToken = myToken;

                    function imgTag(src, alt = "") {
                        if (!src) return `<div style="width:36px;height:36px;border-radius:6px;background:#f0f0f0;flex-shrink:0;"></div>`;
                        return `<img src="${src}" alt="${alt}" style="width:36px;height:36px;object-fit:cover;border-radius:6px;border:1px solid #e0e0e0;flex-shrink:0;">`;
                    }

                    function partRow(imgSrc, label, priceHTML, alt = "") {
                        return `
      <div class="gb-part-row" style="align-items:center;gap:10px;">
        ${imgTag(imgSrc, alt)}
        <span style="flex:1;min-width:0;">${label}</span>
        <span class="part-price" style="flex-shrink:0;">${priceHTML}</span>
      </div>
    `;
                    }

                    function priceDisc(d) {
                        if (!d) return "—";
                        return `<span class="gb-price-original">${d.original}</span><span class="gb-price-discounted">${d.discounted}</span>`;
                    }

                    try {
                        let discountedTotal = 0;
                        let partRows = "";

                        // Fetch condenser + shared accessories in parallel
                        const mountHandle = state.mzAccessories.mount === "wall" ? CONFIG.accessories.wallBracket :
                            state.mzAccessories.mount === "ground" ? CONFIG.accessories.groundStand : null;

                        const [condProduct, lineguardProduct, mountProduct, padProduct, disconnectProduct] = await Promise.all([
                            fetchProduct(m.condenser.handle).catch(() => null),
                            fetchProduct(CONFIG.accessories.lineguard).catch(() => null),
                            mountHandle ? fetchProduct(mountHandle).catch(() => null) : null,
                            state.mzAccessories.condenserPad ? fetchProduct(CONFIG.accessories.condenserPad).catch(() => null) : null,
                            state.mzAccessories.disconnect ? fetchProduct(CONFIG.accessories.disconnect).catch(() => null) : null,
                        ]);

                        const condImg = getProductFeaturedImage(condProduct);
                        const condVariant = condProduct?.variants?.[0];
                        const condPrice = condVariant?.price ? parseInt(condVariant.price, 10) : 0;
                        const condD = condPrice ? formatMoneyDiscounted(condPrice) : null;
                        if (condD) discountedTotal += condD.discountedCents;

                        // Room AHUs + line sets
                        for (const room of m.summaries) {
                            if (room.empty || room.overLimit || !room.chosen) continue;

                            const ahuHandle = getMultiZoneAhuHandle(mzSeries, room);
                            let ahuPrice = 0;
                            let ahuImg = "";

                            if (ahuHandle) {
                                const ahuProduct = await fetchProduct(ahuHandle).catch(() => null);
                                ahuImg = getProductFeaturedImage(ahuProduct);

                                const usesIndividualAhuProduct =
                                    (room.type === "cassette" && mzSeries.cassetteHandleByBtu) ||
                                    (room.type !== "cassette" && mzSeries.wallHandleByBtu);

                                const ahuVariant = usesIndividualAhuProduct ?
                                    ahuProduct?.variants?.[0] :
                                    resolveVariantByBtuAndSeries(ahuProduct, room.chosen, mzSeriesLabel);

                                ahuPrice = ahuVariant?.price ? parseInt(ahuVariant.price, 10) : 0;
                            }

                            const linePrice = await getLinesetPriceCents(room.chosen, room.lineLen) || 0;
                            const lineImg = await getLinesetProductImage(room.chosen, room.lineLen);

                            const lineGuardPrice = room.lineGuard ?
                                (lineguardProduct?.variants?.[0]?.price ? parseInt(lineguardProduct.variants[0].price, 10) : 0) :
                                0;

                            const ahuD = ahuPrice ? formatMoneyDiscounted(ahuPrice) : null;
                            const lineD = linePrice ? formatMoneyDiscounted(linePrice) : null;
                            const guardD = lineGuardPrice ? formatMoneyDiscounted(lineGuardPrice) : null;

                            if (ahuD) discountedTotal += ahuD.discountedCents;
                            if (lineD) discountedTotal += lineD.discountedCents;
                            if (guardD) discountedTotal += guardD.discountedCents;

                            partRows += partRow(ahuImg, `<strong>${room.label}</strong> — ${Math.round(room.chosen / 1000)}k ${getAhuTypeLabel(state.series, room.type, room.chosen)}`, priceDisc(ahuD));
                            partRows += partRow(lineImg, `${room.label}: ${room.lineLen}ft line set${room.lineLen >= 65 ? " w/ coupler" : ""}`, priceDisc(lineD));

                            if (room.lineGuard) {
                                partRows += partRow(getProductFeaturedImage(lineguardProduct), `${room.label}: Line Guard`, priceDisc(guardD));
                            }
                        }

                        // Accessories
                        if (mountHandle && mountProduct) {
                            const p = mountProduct.variants?.[0]?.price ? parseInt(mountProduct.variants[0].price, 10) : 0;
                            const d = p ? formatMoneyDiscounted(p) : null;
                            if (d) discountedTotal += d.discountedCents;
                            partRows += partRow(getProductFeaturedImage(mountProduct), state.mzAccessories.mount === "wall" ? "Condenser Wall Bracket" : "Condenser Ground Stand Brackets", priceDisc(d));
                        }

                        if (state.mzAccessories.condenserPad && padProduct) {
                            const p = padProduct.variants?.[0]?.price ? parseInt(padProduct.variants[0].price, 10) : 0;
                            const d = p ? formatMoneyDiscounted(p) : null;
                            if (d) discountedTotal += d.discountedCents;
                            partRows += partRow(getProductFeaturedImage(padProduct), "Condenser Pad", priceDisc(d));
                        }

                        if (state.mzAccessories.disconnect && disconnectProduct) {
                            const p = disconnectProduct.variants?.[0]?.price ? parseInt(disconnectProduct.variants[0].price, 10) : 0;
                            const d = p ? formatMoneyDiscounted(p) : null;
                            if (d) discountedTotal += d.discountedCents;
                            partRows += partRow(getProductFeaturedImage(disconnectProduct), "Disconnect Switch &amp; Whip", priceDisc(d));
                        }

                        if (renderToken !== asyncToken) return;

                        condRecEl.innerHTML = `
      <span class="gb-rec-main">
        ${condImg ? `<img class="gb-rec-img" src="${condImg}" alt="${mzSeriesLabel} ${Math.round(m.condenser.btu / 1000)}k condenser">` : ""}
        <span class="gb-rec-text">
          ${mzSeriesLabel} — <strong>${Math.round(m.condenser.btu / 1000)}k</strong> / ${m.condenser.zonesLabel} condenser
        </span>
      </span>
      <span class="cond-price gb-rec-price-wrap">
        ${condD ? `<span class="gb-price-original">${condD.original}</span><span class="gb-price-discounted">${condD.discounted}</span>` : "—"}
      </span>
      ${m.overCapacity ? `<span class="cond-warning">⚠ Over capacity</span>` : ""}
    `;

                        partsEl.innerHTML = `
      ${partRows}
      <div class="gb-part-row" style="font-weight:700;color:var(--c-dark);align-items:center;gap:10px;">
        ${imgTag(condImg, `${Math.round(m.condenser.btu / 1000)}k condenser`)}
        <span style="flex:1;">Condenser ${Math.round(m.condenser.btu / 1000)}k</span>
        <span class="part-price" style="flex-shrink:0;">
          ${condD ? `<span class="gb-price-original">${condD.original}</span><span class="gb-price-discounted">${condD.discounted}</span>` : "—"}
        </span>
      </div>
      <div class="gb-part-row part-total">
        <span>Estimated Total (with discount)</span>
        <span class="part-price" style="color:var(--c-brand);">
          ${discountedTotal ? formatMoneyFromCents(discountedTotal) : "—"}
        </span>
      </div>
    `;

                    } catch (err) {
                        console.error("Multi-zone Step 3 render failed:", err);
                        partsEl.innerHTML = `
      <div class="gb-error-block" style="display:block;">
        Multi-zone pricing could not load. Check the console for the failed product or variant.
      </div>
    `;
                    }
                })();
            }

            // Bundle button stays after the pricing render setup
            addBundleBtn.style.display = "block";
            if (anyEmpty || m.hasError) {
                addBundleBtn.disabled = true;
                addBundleBtn.style.opacity = "0.45";
                addBundleBtn.style.cursor = "not-allowed";
            } else {
                addBundleBtn.disabled = false;
                addBundleBtn.style.opacity = "";
                addBundleBtn.style.cursor = "";
            }

            document.getElementById("gbMzConfigAnother")?.remove();
            const mzConfigBtn = document.createElement("button");
            mzConfigBtn.id = "gbMzConfigAnother";
            mzConfigBtn.className = "gb-btn";
            mzConfigBtn.style.cssText = "width:100%;margin-top:8px;";
            mzConfigBtn.textContent = "Save & Configure another space →";

            mzConfigBtn.addEventListener("click", () => {
                const mc = computeMulti();
                if (!mc || mc.hasError || mc.summaries.some(s => s.empty)) return;

                clearEditingMode();

                if (mc && !mc.hasError && mc.summaries.length > 0) {
                    state.savedSystems.push({
                        label: `System ${state.savedSystems.length + 1}`,
                        mode: "multi",
                        series: state.series,
                        seriesLabel: CONFIG.multiZone.series[state.series]?.label || state.series,
                        roomCount: mc.summaries.length,
                        condenser: mc.condenser,
                        mzAccessories: {
                            ...state.mzAccessories
                        },
                        summaries: mc.summaries.map(s => ({
                            ...s,
                            len: state.rooms[s.idx]?.len || 0,
                            wid: state.rooms[s.idx]?.wid || 0,
                            height: state.rooms[s.idx]?.height || 0,
                        })),
                    });
                }

                state.rooms = getFreshRoomsState();
                state.mzAccessories = getFreshMzAccessoriesState();

                saveState();
                render();

                requestAnimationFrame(() => {
                    scrollBuilderToTop();
                });
            });

            document.getElementById("gbBundleMsg").after(mzConfigBtn);

            if (anyEmpty || m.hasError) {
                mzConfigBtn.disabled = true;
                mzConfigBtn.style.opacity = "0.45";
                mzConfigBtn.style.cursor = "not-allowed";
            }

            if (m.overCapacity) {
                addBundleBtn.textContent = "Proceed Anyway";
                addBundleBtn.style.background = "#b91c1c";
                addBundleBtn.style.borderColor = "#b91c1c";
            } else {
                addBundleBtn.textContent = "Add full bundle to cart";
                addBundleBtn.style.background = "";
                addBundleBtn.style.borderColor = "";
            }
        }
    }
    // ---- Populate accessory image + price into a toggle ----
    function applyAccToggleMeta(toggleId, imgContainerId, priceId, meta, discounted = true) {
        const toggle = document.getElementById(toggleId);
        if (!toggle) return;

        // Only replace image if not already loaded
        const imgEl = document.getElementById(imgContainerId);
        if (imgEl && meta.img && imgEl.tagName !== "IMG") {
            imgEl.outerHTML = `<img id="${imgContainerId}" src="${meta.img}" style="width:48px;height:48px;object-fit:cover;border-radius:var(--radius-sm);flex-shrink:0;">`;
        }

        const priceEl = document.getElementById(priceId);
        if (priceEl && meta.price != null) {
            const d = formatMoneyDiscounted(meta.price);
            priceEl.innerHTML = discounted ?
                `<span class="gb-price-original">${d.original}</span> <strong>${d.discounted}</strong>` :
                d.original;
        } else if (priceEl) {
            priceEl.textContent = "—";
        }
    }

    function applyAccOptionMeta(optionId, imgContainerId, priceId, meta) {
        const imgEl = document.getElementById(imgContainerId);
        // Only replace placeholder — if it's already an img tag, just update src if needed
        if (imgEl && meta.img && imgEl.tagName !== "IMG") {
            imgEl.outerHTML = `<img id="${imgContainerId}" src="${meta.img}" style="width:64px;height:64px;object-fit:cover;border-radius:var(--radius-sm);">`;
        }

        const priceEl = document.getElementById(priceId);
        if (priceEl && meta.price != null) {
            const d = formatMoneyDiscounted(meta.price);
            priceEl.innerHTML = `<span class="gb-price-original">${d.original}</span> <strong>${d.discounted}</strong>`;
        }
    }

    // ---- Single-zone accessories card ----
    function renderSzAccessoriesCard(sz) {
        const card = document.getElementById("gbSzAccessoriesCard");
        if (!card || !sz || sz.overLimit) {
            if (card) card.style.display = "none";
            return;
        }
        card.style.display = "block";

        // Wall bracket only for 18k+
        const wallEl = document.getElementById("szMountWall");
        const wallAvailable = CONFIG.wallBracketCondenserBtus.includes(sz.chosen);
        if (wallEl) wallEl.style.display = wallAvailable ? "" : "none";
        // If current mount is wall but not available, clear it
        if (!wallAvailable && state.single.mount === "wall") state.single.mount = "";

        // Sync mount selection UI
        document.querySelectorAll("#gbSzMountOptions .gb-acc-option").forEach(el => {
            el.classList.toggle("active", el.dataset.mount === state.single.mount);
        });

        // Sync pad + disconnect
        document.getElementById("szPadToggle")?.classList.toggle("active", state.single.condenserPad);
        document.getElementById("szDisconnectToggle")?.classList.toggle("active", state.single.disconnect);

        // Async: fetch images + prices
        (async () => {
            const [groundMeta, wallMeta, padMeta, disconnectMeta] = await Promise.all([
                fetchAccessoryMeta(CONFIG.accessories.groundStand),
                fetchAccessoryMeta(CONFIG.accessories.wallBracket),
                fetchAccessoryMeta(CONFIG.accessories.condenserPad),
                fetchAccessoryMeta(CONFIG.accessories.disconnect),
            ]);
            applyAccOptionMeta("szMountGround", "szGroundImg", "szGroundPrice", groundMeta);
            applyAccOptionMeta("szMountWall", "szWallImg", "szWallPrice", wallMeta);
            applyAccToggleMeta("szPadToggle", "szPadImg", "szPadPrice", padMeta);
            applyAccToggleMeta("szDisconnectToggle", "szDisconnectImg", "szDisconnectPrice", disconnectMeta);
        })();
    }

    // ---- Multi-zone accessories card ----
    function renderMzAccessoriesCard(condenser) {
        const wrap = document.getElementById("gbCondenserAccessoriesWrap");
        if (!wrap) return;

        const wallAvailable = condenser && CONFIG.wallBracketCondenserBtus.includes(condenser.btu);
        if (!wallAvailable && state.mzAccessories.mount === "wall") state.mzAccessories.mount = "";

        wrap.innerHTML = `
    <div class="gb-accessories-card">
      <div class="gb-room-header">
        <span class="gb-room-name">Accessories</span>
      </div>

      <div class="gb-acc-section">
        <div class="gb-acc-section-label">Add a mount?</div>
        <div class="gb-acc-options" id="gbMzMountOptions">
          <div class="gb-acc-option${state.mzAccessories.mount === "ground" ? " active" : ""}" data-mz-mount="ground" id="mzMountGround">
            <div class="acc-img-placeholder" id="mzGroundImg">📦</div>
            <span class="acc-name">Ground Stand</span>
            <span class="acc-price" id="mzGroundPrice">—</span>
          </div>
         ${wallAvailable ? `
        <div class="gb-acc-option${state.mzAccessories.mount === "wall" ? " active" : ""}" data-mz-mount="wall" id="mzMountWall">
          <div class="acc-img-placeholder" id="mzWallImg">🔩</div>
          <span class="acc-name">Wall Bracket</span>
          <span class="acc-price" id="mzWallPrice">—</span>
        </div>
        <div class="gb-acc-option${state.mzAccessories.mount === "pad" ? " active" : ""}" data-mz-mount="pad" id="mzMountPad">
  <div class="acc-img-placeholder" id="mzMountPadImg">🟫</div>
  <span class="acc-name">Condenser Pad</span>
  <span class="acc-price" id="mzMountPadPrice">—</span>
</div>
` : ""}
        </div>
      </div>
      <div class="gb-acc-section">
        <div class="gb-acc-section-label">Add a Disconnect Switch?</div>
        <div class="gb-acc-toggle${state.mzAccessories.disconnect ? " active" : ""}" id="mzDisconnectToggle">
          <div class="acc-img-placeholder" id="mzDisconnectImg">⚡</div>
          <div class="gb-acc-toggle-text">
            <strong>Disconnect Switch &amp; Whip</strong>
            <span id="mzDisconnectPrice">—</span>
          </div>
          <div class="gb-acc-checkbox"></div>
        </div>
      </div>
    </div>
  `;

        // Bind mount options
        wrap.querySelectorAll("[data-mz-mount]").forEach(el => {
            el.onclick = (e) => {
                e.preventDefault();
                e.stopPropagation();

                if (el.classList.contains("disabled")) return;

                const clickedMount = el.dataset.mzMount || "";
                const currentMount = state.mzAccessories.mount || "";

                state.mzAccessories.mount = currentMount === clickedMount ? "" : clickedMount;

                // Condenser Pad is now a mount choice, not a separate accessory.
                state.mzAccessories.condenserPad = false;

                saveState();
                renderResults();
            };
        });

        // Bind disconnect toggle
        document.getElementById("mzDisconnectToggle")?.addEventListener("click", () => {
            state.mzAccessories.disconnect = !state.mzAccessories.disconnect;
            document.getElementById("mzDisconnectToggle").classList.toggle("active", state.mzAccessories.disconnect);
            saveState();
            renderResults();
        });

        // Async images + prices
        (async () => {
            const [groundMeta, wallMeta, padMeta, disconnectMeta] = await Promise.all([
                fetchAccessoryMeta(CONFIG.accessories.groundStand),
                fetchAccessoryMeta(CONFIG.accessories.wallBracket),
                fetchAccessoryMeta(CONFIG.accessories.condenserPad),
                fetchAccessoryMeta(CONFIG.accessories.disconnect),
            ]);

            applyAccOptionMeta("mzMountGround", "mzGroundImg", "mzGroundPrice", groundMeta);

            if (wallAvailable) {
                applyAccOptionMeta("mzMountWall", "mzWallImg", "mzWallPrice", wallMeta);
            }

            applyAccOptionMeta("mzMountPad", "mzMountPadImg", "mzMountPadPrice", padMeta);
            applyAccToggleMeta("mzDisconnectToggle", "mzDisconnectImg", "mzDisconnectPrice", disconnectMeta);
        })();
    }

    function renderLargeSingleEditModal(idx) {
        const s = state.savedSystems[idx];
        if (!s) return;

        document.querySelector(".gb-modal-overlay")?.remove();

        const previousBodyOverflow = document.body.style.overflow;

        const overlay = document.createElement("div");
        overlay.className = "gb-modal-overlay";

        overlay.style.cssText = `
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.55);
    z-index: 2147483647;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 24px 16px 40px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
  `;

        const units = Array.isArray(s.units) ? s.units : [];

        overlay.innerHTML = `
    <div class="gb-modal" id="gbLargeSingleModalInner">
      <div class="gb-modal-header">
        <div class="gb-modal-title">Edit ${s.label}</div>
        <button class="gb-modal-close" id="gbLargeSingleClose" type="button">×</button>
      </div>

      <div class="gb-modal-body">
        <div class="gb-modal-summary">
          <strong>${s.seriesLabel}</strong><br>
          Large Space · ${s.systemsNeeded} × ${Math.round(s.recommendedBtu / 1000)}k · ${s.voltage}V<br>
          <span style="color:var(--c-muted);font-size:12px;">
            Configure each system independently.
          </span>
        </div>

        ${units.map((unit, i) => `
          <div class="gb-room-card" style="margin-bottom:14px;">
            <div class="gb-room-header">
              <span class="gb-room-name">${unit.label || `Unit ${i + 1}`}</span>
            </div>

            <div class="gb-sz-opts">
              <div class="gb-field">
                <label>Line set length</label>
                <select data-large-unit="${i}" data-large-k="lineLen">
                  ${CONFIG.szLineLengths.map(ft => {
                    const needsCoupler = ft >= 65;
                    const label = ft === 15
                      ? `${ft} ft (included)`
                      : needsCoupler
                        ? `${ft} ft w/ Coupler (upgrade)`
                        : `${ft} ft (upgrade)`;

                    return `<option value="${ft}" ${Number(unit.lineLen) === ft ? "selected" : ""}>${label}</option>`;
                  }).join("")}
                  
                </select>
              </div>

              <div class="gb-field">
                <label>Line Guard</label>
                <select data-large-unit="${i}" data-large-k="lineGuard">
                  <option value="" ${!unit.lineGuard ? "selected" : ""}>None</option>
                  <option value="yes" ${unit.lineGuard === "yes" || unit.lineGuard === true ? "selected" : ""}>Add Line Guard</option>
                </select>
              </div>
            </div>

            <div class="gb-sz-opts" style="margin-top:8px;">
              <div class="gb-field">
                <label>Add A Mount?</label>
                <select data-large-unit="${i}" data-large-k="mount">
  <option value="" ${!unit.mount ? "selected" : ""}>None</option>
  <option value="ground" ${unit.mount === "ground" ? "selected" : ""}>Ground Stand</option>
  <option value="wall" ${unit.mount === "wall" ? "selected" : ""}>Wall Bracket</option>
  <option value="pad" ${unit.mount === "pad" ? "selected" : ""}>Condenser Pad</option>
</select>
              </div>
            </div>

            <div class="gb-sz-opts" style="margin-top:8px;">
              <div class="gb-field">
                <label>Add A Whip & Disconnect Switch?</label>
                <select data-large-unit="${i}" data-large-k="disconnect">
                  <option value="" ${!unit.disconnect ? "selected" : ""}>None</option>
                  <option value="yes" ${unit.disconnect === "yes" || unit.disconnect === true ? "selected" : ""}>Add Disconnect</option>
                </select>
              </div>
            </div>
          </div>
        `).join("")}
        <div class="gb-modal-section">
  <div class="gb-section-label">Parts &amp; Pricing</div>
  <div class="gb-parts gb-modal-parts" id="gbLargeSinglePartsList">
    <div class="gb-part-row">
      <span>Loading…</span>
      <span class="part-price">—</span>
    </div>
  </div>
</div>
      </div>
<div class="gb-modal-cart-msg"></div>
     <div class="gb-modal-footer">
  <button class="gb-btn gb-btn-danger" id="gbLargeSingleDelete" type="button">Delete</button>
  <button class="gb-btn gb-btn-brand" id="gbLargeSingleSave" type="button">Save Changes</button>
  <button class="gb-btn gb-btn-dark" id="gbLargeSingleAddToCart" type="button">Add to Cart</button>
</div>
    </div>
  `;

        const inner = overlay.querySelector("#gbLargeSingleModalInner");
        if (inner) {
            inner.style.cssText = `
      --c-brand: #761d7d;
      --c-dark: #1A0530;
      --c-mid: #3D0F6B;
      --c-muted: #888;
      --c-border: #e0e0e0;
      --c-surface: #f9f9f9;
      --c-white: #ffffff;
      --radius-sm: 8px;
      --radius-md: 12px;
      --radius-lg: 16px;
      --radius-pill: 999px;
      font-family: 'Barlow', 'Barlow Condensed', system-ui, -apple-system, sans-serif;
      background: #ffffff;
      border-radius: 16px;
      width: 100%;
      max-width: 560px;
      margin: 0 auto 40px;
      box-shadow: 0 20px 60px rgba(0,0,0,0.3);
      display: flex;
      flex-direction: column;
      position: relative;
    `;
        }

        function closeModal() {
            document.body.style.overflow = previousBodyOverflow;
            overlay.remove();
        }
        async function refreshLargeSingleParts() {
            const partsEl = overlay.querySelector("#gbLargeSinglePartsList");
            if (!partsEl) return;

            partsEl.innerHTML = `
    <div class="gb-part-row">
      <span>Loading…</span>
      <span class="part-price">—</span>
    </div>
  `;

            function imgTag(src, alt = "") {
                if (!src) {
                    return `<div style="width:36px;height:36px;border-radius:6px;background:#f0f0f0;flex-shrink:0;"></div>`;
                }

                return `<img src="${src}" alt="${alt}" style="width:36px;height:36px;object-fit:cover;border-radius:6px;border:1px solid #e0e0e0;flex-shrink:0;">`;
            }

            function partRow(imgSrc, label, priceHTML, alt = "") {
                return `
      <div class="gb-part-row" style="align-items:center;gap:10px;">
        ${imgTag(imgSrc, alt)}
        <span style="flex:1;min-width:0;">${label}</span>
        <span class="part-price" style="flex-shrink:0;">${priceHTML}</span>
      </div>
    `;
            }

            function priceHTML(d) {
                if (!d) return "—";
                return `<span class="gb-price-original">${d.original}</span><span class="gb-price-discounted">${d.discounted}</span>`;
            }

            try {
                let total = 0;
                let rows = "";

                const [
                    bundleProduct,
                    lineguardProduct,
                    groundProduct,
                    wallProduct,
                    padProduct,
                    disconnectProduct,
                ] = await Promise.all([
                    s.handle ? fetchProduct(s.handle).catch(() => null) : null,
                    fetchProduct(CONFIG.accessories.lineguard).catch(() => null),
                    fetchProduct(CONFIG.accessories.groundStand).catch(() => null),
                    fetchProduct(CONFIG.accessories.wallBracket).catch(() => null),
                    fetchProduct(CONFIG.accessories.condenserPad).catch(() => null),
                    fetchProduct(CONFIG.accessories.disconnect).catch(() => null),
                ]);

                const bundleImg = getProductFeaturedImage(bundleProduct);
                const guardImg = getProductFeaturedImage(lineguardProduct);
                const groundImg = getProductFeaturedImage(groundProduct);
                const wallImg = getProductFeaturedImage(wallProduct);
                const padImg = getProductFeaturedImage(padProduct);
                const disconnectImg = getProductFeaturedImage(disconnectProduct);

                const bundleVariant =
                    resolveVariantByBtuVoltage(bundleProduct, s.recommendedBtu, s.voltage) ||
                    bundleProduct?.variants?.[0];

                const bundlePrice = bundleVariant?.price ? parseInt(bundleVariant.price, 10) : null;
                const bundleD = bundlePrice ? formatMoneyDiscounted(bundlePrice) : null;

                const guardPrice = lineguardProduct?.variants?.[0]?.price ? parseInt(lineguardProduct.variants[0].price, 10) : null;
                const groundPrice = groundProduct?.variants?.[0]?.price ? parseInt(groundProduct.variants[0].price, 10) : null;
                const wallPrice = wallProduct?.variants?.[0]?.price ? parseInt(wallProduct.variants[0].price, 10) : null;
                const padPrice = padProduct?.variants?.[0]?.price ? parseInt(padProduct.variants[0].price, 10) : null;
                const disconnectPrice = disconnectProduct?.variants?.[0]?.price ? parseInt(disconnectProduct.variants[0].price, 10) : null;

                const guardD = guardPrice ? formatMoneyDiscounted(guardPrice) : null;
                const groundD = groundPrice ? formatMoneyDiscounted(groundPrice) : null;
                const wallD = wallPrice ? formatMoneyDiscounted(wallPrice) : null;
                const padD = padPrice ? formatMoneyDiscounted(padPrice) : null;
                const disconnectD = disconnectPrice ? formatMoneyDiscounted(disconnectPrice) : null;

                for (const unit of (s.units || [])) {
                    const unitLabel = unit.label || "Unit";
                    const lineLen = Number(unit.lineLen) || 15;

                    if (bundleD) total += bundleD.discountedCents;

                    rows += partRow(
                        bundleImg,
                        `<strong>${unitLabel}</strong> — ${Math.round((unit.chosen || s.recommendedBtu) / 1000)}k Complete System`,
                        priceHTML(bundleD),
                        `${unitLabel} complete system`
                    );

                    const lineImg = await getSzLinesetProductImage(lineLen);

                    if (lineLen > 15) {
                        const linePrice = await getSzLinesetPriceCents(lineLen);
                        const lineD = linePrice ? formatMoneyDiscounted(linePrice) : null;

                        if (lineD) total += lineD.discountedCents;

                        rows += partRow(
                            lineImg,
                            `${unitLabel}: ${lineLen}ft line set${lineLen >= 65 ? " w/ coupler" : ""}`,
                            priceHTML(lineD),
                            "Line set"
                        );
                    } else {
                        rows += partRow(
                            lineImg,
                            `${unitLabel}: 15ft line set (included)`,
                            "Included",
                            "Line set"
                        );
                    }

                    if (unit.lineGuard === "yes" || unit.lineGuard === true) {
                        if (guardD) total += guardD.discountedCents;

                        rows += partRow(
                            guardImg,
                            `${unitLabel}: Line Guard`,
                            priceHTML(guardD),
                            "Line Guard"
                        );
                    }

                    if (unit.mount === "ground") {
                        if (groundD) total += groundD.discountedCents;

                        rows += partRow(
                            groundImg,
                            `${unitLabel}: Ground Stand`,
                            priceHTML(groundD),
                            "Ground Stand"
                        );
                    }

                    if (unit.mount === "wall") {
                        if (wallD) total += wallD.discountedCents;

                        rows += partRow(
                            wallImg,
                            `${unitLabel}: Wall Bracket`,
                            priceHTML(wallD),
                            "Wall Bracket"
                        );
                    }

                    if (unit.mount === "pad") {
                        if (padD) total += padD.discountedCents;

                        rows += partRow(
                            padImg,
                            `${unitLabel}: Condenser Pad`,
                            priceHTML(padD),
                            "Condenser Pad"
                        );
                    }

                    if (unit.disconnect === "yes" || unit.disconnect === true) {
                        if (disconnectD) total += disconnectD.discountedCents;

                        rows += partRow(
                            disconnectImg,
                            `${unitLabel}: Disconnect Switch & Whip`,
                            priceHTML(disconnectD),
                            "Disconnect Switch"
                        );
                    }
                }

                partsEl.innerHTML = rows + `
  <div class="gb-part-row part-total">
    <span>Estimated total (with discount)</span>
    <span class="part-price" style="color:var(--c-brand);">${formatMoneyFromCents(total)}</span>
  </div>
`;
            } catch (err) {
                console.error("Large-space parts refresh failed:", err);
                partsEl.innerHTML = `<div style="color:#b91c1c;font-size:13px;">Could not load pricing.</div>`;
            }
        }

        document.body.style.overflow = "hidden";
        document.body.appendChild(overlay);
        refreshLargeSingleParts();

        overlay.querySelector("#gbLargeSingleClose")?.addEventListener("click", e => {
            e.preventDefault();
            e.stopPropagation();
            closeModal();
        });

        overlay.addEventListener("click", e => {
            if (e.target === overlay) {
                closeModal();
            }
        });

        overlay.querySelectorAll("[data-large-unit][data-large-k]").forEach(inp => {
            inp.addEventListener("input", () => {
                const unitIdx = Number(inp.dataset.largeUnit);
                const key = inp.dataset.largeK;

                if (!s.units[unitIdx]) return;

                if (["len", "wid", "height"].includes(key)) {
                    s.units[unitIdx][key] = Number(inp.value);
                    return;
                }
                if (key === "lineLen") {
                    const nextLineLen = Number(inp.value) || 15;

                    s.units[unitIdx].lineLen = nextLineLen;

                    // Make sure the saved-system object is updated immediately.
                    state.savedSystems[idx] = s;

                    refreshLargeSingleParts();
                    renderSavedSystems();
                    saveState();

                    //   console.log("Large-single line length saved:", {
                    //     systemIndex: idx,
                    //     system: s.label,
                    //     unitIndex: unitIdx,
                    //     unit: s.units[unitIdx]?.label,
                    //     lineLen: nextLineLen,
                    //   });

                    return;
                }
                if (key === "lineGuard") {
                    s.units[unitIdx].lineGuard = inp.value === "yes" ? "yes" : "";
                    refreshLargeSingleParts();
                    return;
                }

                if (key === "mount") {
                    s.units[unitIdx].mount = inp.value;
                    refreshLargeSingleParts();
                    return;
                }

                if (key === "disconnect") {
                    s.units[unitIdx].disconnect = inp.value === "yes";
                    refreshLargeSingleParts();
                    return;
                }
            });

            inp.addEventListener("change", () => {
                inp.dispatchEvent(new Event("input"));
            });
        });
        overlay.querySelector("#gbLargeSingleDelete")?.addEventListener("click", () => {
            state.savedSystems.splice(idx, 1);
            state.savedSystems.forEach((sys, i) => {
                sys.label = `System ${i + 1}`;
            });

            saveState();
            closeModal();
            render();
        });
        overlay.querySelector("#gbLargeSingleAddToCart")?.addEventListener("click", async () => {
            const btn = overlay.querySelector("#gbLargeSingleAddToCart");
            const msg = overlay.querySelector(".gb-modal-cart-msg");

            if (btn) {
                btn.disabled = true;
                btn.textContent = "Adding…";
            }

            try {
                // Save current modal edits before adding.
                saveState();

                const items = [];
                const product = await fetchProduct(s.handle);

                for (const unit of (s.units || [])) {
                    const variant =
                        resolveVariantByBtuVoltage(product, unit.chosen || s.recommendedBtu, s.voltage) ||
                        product.variants?.[0];

                    if (variant) {
                        items.push({
                            id: variant.id,
                            quantity: 1,
                            properties: {
                                "_source": "GWIN Builder",
                                "_series": s.seriesLabel,
                                "_system": s.label,
                            },
                        });
                    }

                    const unitLineLen = Number(unit.lineLen || 15);

                    if (unitLineLen > 15) {
                        const lineVariant = await resolveSzLinesetVariant(unitLineLen);

                        if (lineVariant) {
                            items.push({
                                id: lineVariant.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_unit": unit.label || "",
                                    "_debug_item": `${s.label} ${unit.label || "Unit"} ${unitLineLen}ft SZ line upgrade`,
                                },
                            });
                        }
                    }

                    if (unit.lineGuard === "yes" || unit.lineGuard === true) {
                        const v = await getFirstVariantForHandle(CONFIG.accessories.lineguard);
                        if (v) {
                            items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label,
                                },
                            });
                        }
                    }

                    if (unit.mount === "ground") {
                        const v = await getFirstVariantForHandle(CONFIG.accessories.groundStand);
                        if (v) {
                            items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label,
                                },
                            });
                        }
                    }

                    if (unit.mount === "wall") {
                        const v = await getFirstVariantForHandle(CONFIG.accessories.wallBracket);
                        if (v) {
                            items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label,
                                },
                            });
                        }
                    }

                    if (unit.condenserPad === "yes" || unit.condenserPad === true) {
                        const v = await getFirstVariantForHandle(CONFIG.accessories.condenserPad);
                        if (v) {
                            items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label,
                                },
                            });
                        }
                    }

                    if (unit.disconnect === "yes" || unit.disconnect === true) {
                        const v = await getFirstVariantForHandle(CONFIG.accessories.disconnect);
                        if (v) {
                            items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    "_source": "GWIN Builder",
                                    "_series": s.seriesLabel,
                                    "_system": s.label,
                                },
                            });
                        }
                    }
                }

                if (!items.length) throw new Error("No items to add.");

                await addToCart(items);

                // Remove this grouped large-space system after successful cart add.
                state.savedSystems.splice(idx, 1);
                state.savedSystems.forEach((sys, i) => {
                    sys.label = `System ${i + 1}`;
                });

                saveState();

                if (btn) btn.textContent = "Added!";
                if (msg) msg.textContent = "Added to cart.";

                closeModal();
                render();
                return;
            } catch (err) {
                console.error(err);

                if (btn) {
                    btn.disabled = false;
                    btn.textContent = "Add to Cart";
                }

                if (msg) msg.textContent = "Could not add to cart. Please try again.";
            }
        });
        overlay.querySelector("#gbLargeSingleSave")?.addEventListener("click", () => {
            saveState();
            closeModal();
            render();
        });
    }

    function renderEditModal(idx) {
        const s = state.savedSystems[idx];
        if (!s) return;

        if (s.mode === "large-single") {
            renderLargeSingleEditModal(idx);
            return;
        }
        // Close any existing modal
        document.getElementById("gbEditModal")?.remove();

        // Work on a deep copy so cancel is truly non-destructive
        const draft = JSON.parse(JSON.stringify(s));

        const overlay = document.createElement("div");
        overlay.className = "gb-modal-overlay";
        overlay.id = "gbEditModal";
        const previousBodyOverflow = document.body.style.overflow || "";

        function getAccLabel() {
            const labels = [];
            if (draft.mode === "single") {
                if (draft.lineGuard) labels.push("Line Guard");
                if (draft.mount === "ground") labels.push("Ground Stand");
                if (draft.mount === "wall") labels.push("Wall Bracket");
                if (draft.condenserPad) labels.push("Condenser Pad");
                if (draft.disconnect) labels.push("Disconnect Switch & Whip");
            }
            return labels.length ? labels.join(", ") : "None";

        }

        function getSummaryHTML() {
            if (draft.mode === "single") {
                return `
        <div style="display:flex;align-items:center;gap:12px;">
          <img id="gbModalProductImg" src="" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:8px;border:1px solid #e0e0e0;flex-shrink:0;display:none;">
          <div>
            <strong>${draft.seriesLabel}</strong> ·
            ${Math.round(draft.chosen / 1000)}k ${draft.type === "cassette" ? "Cassette" : "High Wall"} ·
            ${draft.voltage}V ·
            ${Math.round((draft.len || 0) * (draft.wid || 0))} sq ft
          </div>
        </div>
      `;
            }
            return `
      <div style="display:flex;align-items:center;gap:12px;">
        <img id="gbModalProductImg" src="" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:8px;border:1px solid #e0e0e0;flex-shrink:0;display:none;">
        <div>
          <strong>${draft.seriesLabel}</strong> ·
          ${draft.roomCount}-Zone ·
          ${Math.round(draft.condenser.btu / 1000)}k condenser
        </div>
      </div>
    `;
        }

        function getLineLengthOptions() {
            return CONFIG.szLineLengths.map(ft => {
                const needsCoupler = ft >= 65;
                const label = ft === 15 ?
                    `${ft} ft (included)` :
                    needsCoupler ?
                    `${ft} ft w/ Coupler (upgrade)` :
                    `${ft} ft (upgrade)`;
                return `<option value="${ft}" ${draft.lineLen === ft ? "selected" : ""}>${label}</option>`;
            }).join("");
        }

        function getMzLineLengthOptions(roomIdx) {
            const room = draft.summaries[roomIdx];
            return CONFIG.mzLineLengths.map(ft => {
                const needsCoupler = ft >= 65;
                const label = ft === 15 ?
                    `${ft} ft (included)` :
                    needsCoupler ?
                    `${ft} ft w/ Coupler` :
                    `${ft} ft (upgrade)`;
                return `<option value="${ft}" ${Number(room.lineLen) === ft ? "selected" : ""}>${label}</option>`;
            }).join("");
        }

        function getRoomSizeOptions(roomIdx) {
            const room = draft.summaries[roomIdx];
            const mzSeries = CONFIG.multiZone.series[draft.series];
            const type = room.type === "cassette" && mzSeries.cassetteSizes.length > 0 ? "cassette" : "wall";
            const availSizes = type === "cassette" ? mzSeries.cassetteSizes : mzSeries.wallSizes;
            return availSizes.map(btu =>
                `<option value="${btu}" ${room.chosen === btu ? "selected" : ""}>${Math.round(btu / 1000)}k</option>`
            ).join("");
        }

        function buildModalHTML() {
            const wallAvailable = draft.mode === "single" ?
                CONFIG.wallBracketCondenserBtus.includes(draft.chosen) :
                draft.condenser && CONFIG.wallBracketCondenserBtus.includes(draft.condenser.btu);

            const isSingle = draft.mode === "single";

            // Line set + line guard section
            const lineSetSection = isSingle ? `
      <div class="gb-modal-section">
        <div class="gb-section-label">Room Dimensions</div>
        <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:8px;">
          <div class="gb-field">
            <label>Length (ft)</label>
            <input id="gbModalLen" type="number" min="1" step="0.5" value="${draft.len || ""}" placeholder="length">
          </div>
          <div class="gb-field">
            <label>Width (ft)</label>
            <input id="gbModalWid" type="number" min="1" step="0.5" value="${draft.wid || ""}" placeholder="width">
          </div>
          <div class="gb-field">
            <label>Ceiling (ft)</label>
            <input id="gbModalHei" type="number" min="7" max="20" step="0.5" value="${draft.height || ""}" placeholder="height">
          </div>
        </div>
        ${draft.len && draft.wid && draft.height ? `<div style="font-size:11px;color:#888;margin-bottom:8px;">~${Math.round(draft.len * draft.wid)} sq ft → <strong style="color:#1A0530;">${Math.round(effectiveSqft(draft.len, draft.wid, draft.height))} eq sq ft</strong></div>` : ""}

        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
          <div class="gb-field">
            <label>LINE SET Length</label>
            <select id="gbModalLineLen">${getLineLengthOptions()}</select>
          </div>
          <div class="gb-field">
            <label>Line Guard</label>
            <select id="gbModalLineGuard">
              <option value="">None</option>
              <option value="yes" ${draft.lineGuard ? "selected" : ""}>Add Line Guard</option>
            </select>
          </div>
        </div>
      </div>
    ` : draft.summaries.map((room, i) => `
      <div class="gb-modal-section">
        <div class="gb-section-label">${room.label}</div>
        <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:8px;">
          <div class="gb-field">
            <label>Length (ft)</label>
            <input type="number" min="1" step="0.5" value="${room.len || ""}" data-modal-room="${i}" data-modal-k="len" placeholder="length">
          </div>
          <div class="gb-field">
            <label>Width (ft)</label>
            <input type="number" min="1" step="0.5" value="${room.wid || ""}" data-modal-room="${i}" data-modal-k="wid" placeholder="width">
          </div>
          <div class="gb-field">
            <label>Ceiling (ft)</label>
            <input type="number" min="7" max="20" step="0.5" value="${room.height || ""}" data-modal-room="${i}" data-modal-k="height" placeholder="height">
          </div>
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:8px;">
          <div class="gb-field">
            <label>Size</label>
            <select data-modal-room="${i}" data-modal-k="size">${getRoomSizeOptions(i)}</select>
          </div>
          <div class="gb-field">
            <label>Line Set</label>
            <select data-modal-room="${i}" data-modal-k="lineLen">${getMzLineLengthOptions(i)}</select>
          </div>
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
          <div class="gb-field">
            <label>Line Guard</label>
            <select data-modal-room="${i}" data-modal-k="lineGuard">
              <option value="">None</option>
              <option value="yes" ${room.lineGuard ? "selected" : ""}>Add Line Guard</option>
            </select>
          </div>
        </div>
        ${room.len && room.wid && room.height ? `<div data-room-hint style="font-size:11px;color:#888;margin-top:6px;">~${Math.round(room.len * room.wid)} sq ft, ${room.height}ft ceiling → <strong style="color:#1A0530;">${Math.round(effectiveSqft(room.len, room.wid, room.height))} eq sq ft — ${Math.round(room.chosen / 1000)}k ${getAhuTypeLabel(draft.series, room.type, room.chosen)}</strong></div>` : `<div data-room-hint style="font-size:11px;color:#888;margin-top:6px;"></div>`}
      </div>
    `).join("");

            // Accessories section
            const accSection = `
  <div class="gb-modal-section">
    <div class="gb-section-label">Accessories</div>

    <div class="gb-acc-section-label" style="margin-top:10px;">Add A Mount?</div>
    <div class="gb-acc-options" id="gbModalMountOptions" style="margin-bottom:12px;">
      <div class="gb-acc-option${(draft.mode === "multi" ? draft.mzAccessories : draft).mount === "ground" ? " active" : ""}" data-modal-mount="ground" id="gbModalMountGround">
        <div class="acc-img-placeholder" id="gbModalGroundImg">📦</div>
        <span class="acc-name">Ground Stand</span>
        <span class="acc-price" id="gbModalGroundPrice">—</span>
      </div>
      ${wallAvailable ? `
      <div class="gb-acc-option${(draft.mode === "multi" ? draft.mzAccessories : draft).mount === "wall" ? " active" : ""}" data-modal-mount="wall" id="gbModalMountWall">
        <div class="acc-img-placeholder" id="gbModalWallImg">🔩</div>
        <span class="acc-name">Wall Bracket</span>
        <span class="acc-price" id="gbModalWallPrice">—</span>
      </div>` : ""}
      <div class="gb-acc-option${(draft.mode === "multi" ? draft.mzAccessories : draft).mount === "pad" ? " active" : ""}" data-modal-mount="pad" id="gbModalMountPad">
        <div class="acc-img-placeholder" id="gbModalPadImg">🟫</div>
        <span class="acc-name">Condenser Pad</span>
        <span class="acc-price" id="gbModalPadPrice">—</span>
      </div>
    </div>

    <div class="gb-acc-section-label">Add A Disconnect Switch?</div>
    <div class="gb-acc-options">
      <div class="gb-acc-toggle${(draft.mode === "multi" ? draft.mzAccessories : draft).disconnect ? " active" : ""}" id="gbModalDisconnectToggle">
        <div class="acc-img-placeholder" id="gbModalDisconnectImg">⚡</div>
        <div class="gb-acc-toggle-text">
          <strong>Disconnect Switch &amp; Whip</strong>
          <span id="gbModalDisconnectPrice">—</span>
        </div>
        <div class="gb-acc-checkbox"></div>
      </div>
    </div>
  </div>
`;

            return `
      <div class="gb-modal" id="gbEditModalInner">
        <div class="gb-modal-header">
          <span class="gb-modal-title">Edit ${draft.label}</span>
          <button class="gb-modal-close" id="gbModalClose">✕</button>
        </div>
        <div class="gb-modal-body">
          <div class="gb-modal-summary">${getSummaryHTML()}</div>
                    <div id="gbModalWarning" style="display:none;background:#fff7ed;border:1.5px solid #fed7aa;border-radius:8px;padding:10px 12px;font-size:13px;color:#c2410c;margin-bottom:18px;"></div>
          ${lineSetSection}
          ${accSection}
          <div class="gb-modal-section">
            <div class="gb-section-label">Parts &amp; Pricing</div>
            <div class="gb-parts gb-modal-parts" id="gbModalPartsList">
              <div class="gb-part-row"><span>—</span><span class="part-price">—</span></div>
            </div>
          </div>
          <div class="gb-modal-cart-msg" id="gbModalCartMsg"></div>
        </div>
        <div class="gb-modal-footer">
          <button class="gb-btn gb-btn-danger" id="gbModalDelete">Delete</button>
        
          <button class="gb-btn gb-btn-brand" id="gbModalSave">Save Changes</button>
            <button class="gb-btn gb-btn-dark" id="gbModalAddToCart">Add to Cart</button>
        </div>
      </div>
    `;
        }

        overlay.innerHTML = buildModalHTML();

        const inner =
            overlay.querySelector("#gbEditModalInner") ||
            overlay.querySelector(".gb-modal");

        if (inner) {
            inner.style.cssText = `
    --c-brand: #761d7d;
    --c-dark: #1A0530;
    --c-mid: #3D0F6B;
    --c-muted: #888;
    --c-border: #e0e0e0;
    --c-surface: #f9f9f9;
    --c-white: #ffffff;
    --c-preorder: #d97706;
    --radius-sm: 8px;
    --radius-md: 12px;
    --radius-lg: 16px;
    --radius-pill: 999px;
    font-family: 'Barlow', 'Barlow Condensed', system-ui, -apple-system, sans-serif;
    background: #ffffff;
    border-radius: 16px;
    width: 100%;
    max-width: 520px;
    margin: 0 auto 40px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.3);
    display: flex;
    flex-direction: column;
    position: relative;
  `;
        }

        overlay.style.cssText = `
  position: fixed;
  inset: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.55);
  z-index: 2147483647;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 16px 40px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
`;
        document.body.style.overflow = "hidden";
        document.body.appendChild(overlay);
        // ---- Bind close ----
        function closeModal() {
            document.body.style.overflow = previousBodyOverflow;
            overlay.remove();
        }

        overlay.querySelector("#gbModalClose")?.addEventListener("click", e => {
            e.preventDefault();
            e.stopPropagation();
            closeModal();
        });
        overlay.addEventListener("click", e => {
            if (e.target === overlay) closeModal();
        });

        // ---- Bind line set / line guard (single) ----
        overlay.querySelector("#gbModalLineLen")?.addEventListener("change", e => {
            draft.lineLen = Number(e.target.value);
            refreshModalParts();
        });

        overlay.querySelector("#gbModalLineGuard")?.addEventListener("change", e => {
            draft.lineGuard = e.target.value === "yes";
            refreshModalParts();
        });

        // ---- Bind mount options ----
        overlay.querySelectorAll("[data-modal-mount]").forEach(el => {
            el.addEventListener("click", () => {
                const clicked = el.dataset.modalMount;
                const acc = draft.mode === "multi" ? draft.mzAccessories : draft;
                acc.mount = acc.mount === clicked ? "" : clicked;
                overlay.querySelectorAll("[data-modal-mount]").forEach(o => {
                    o.classList.toggle("active", o.dataset.modalMount === acc.mount);
                });
                refreshModalParts();
            });
        });

        overlay.querySelector("#gbModalDisconnectToggle")?.addEventListener("click", () => {
            const acc = draft.mode === "multi" ? draft.mzAccessories : draft;
            acc.disconnect = !acc.disconnect;
            overlay.querySelector("#gbModalDisconnectToggle").classList.toggle("active", acc.disconnect);
            refreshModalParts();
        });


        // ---- Bind room inputs (multi) ----
        overlay.querySelectorAll("[data-modal-room][data-modal-k]").forEach(el => {
            const handler = () => {
                const i = Number(el.dataset.modalRoom);
                const k = el.dataset.modalK;
                const val = el.value;

                if (k === "lineLen") {
                    draft.summaries[i].lineLen = Number(val);
                    refreshModalParts();
                    return;
                }
                if (k === "lineGuard") {
                    draft.summaries[i].lineGuard = val === "yes";
                    refreshModalParts();
                    return;
                }
                if (k === "size") {
                    draft.summaries[i].chosen = Number(val);
                    recalcDraftCondenser();

                    const section = el.closest(".gb-modal-section");
                    const hint = section?.querySelector("[data-room-hint]");
                    if (hint && draft.summaries[i].len && draft.summaries[i].wid && draft.summaries[i].height) {
                        const eff = effectiveSqft(draft.summaries[i].len, draft.summaries[i].wid, draft.summaries[i].height);
                        hint.innerHTML = `~${Math.round(draft.summaries[i].len * draft.summaries[i].wid)} sq ft, ${draft.summaries[i].height}ft ceiling → <strong style="color:#1A0530;">${Math.round(eff)} eq sq ft — ${Math.round(draft.summaries[i].chosen / 1000)}k ${getAhuTypeLabel(draft.series, draft.summaries[i].type, draft.summaries[i].chosen)}</strong>`;
                    }

                    rebuildModalSummary();
                    refreshModalParts();
                    return;
                }

                if (["len", "wid", "height"].includes(k)) {
                    draft.summaries[i][k] = Number(val);
                    if (draft.summaries[i].len && draft.summaries[i].wid && draft.summaries[i].height) {
                        const mzSeries = CONFIG.multiZone.series[draft.series];
                        const type = draft.summaries[i].type === "cassette" && mzSeries.cassetteSizes.length > 0 ? "cassette" : "wall";
                        const availSizes = type === "cassette" ? mzSeries.cassetteSizes : mzSeries.wallSizes;
                        const eff = effectiveSqft(draft.summaries[i].len, draft.summaries[i].wid, draft.summaries[i].height);
                        const suggested = eff > CONFIG.maxEffSqft ? availSizes[availSizes.length - 1] : suggestBtu(eff, CONFIG.multiBands, availSizes);
                        draft.summaries[i].chosen = suggested;
                        recalcDraftCondenser();


                        const sizeSelect = el.closest(".gb-modal-section")?.querySelector(`[data-modal-k="size"]`);
                        if (sizeSelect) sizeSelect.value = String(draft.summaries[i].chosen);

                        const hint = el.closest(".gb-modal-section")?.querySelector("[data-room-hint]");
                        if (hint) {
                            const eff = effectiveSqft(draft.summaries[i].len, draft.summaries[i].wid, draft.summaries[i].height);
                            hint.innerHTML = `~${Math.round(draft.summaries[i].len * draft.summaries[i].wid)} sq ft, ${draft.summaries[i].height}ft ceiling → <strong style="color:#1A0530;">${Math.round(eff)} eq sq ft — ${Math.round(draft.summaries[i].chosen / 1000)}k ${getAhuTypeLabel(draft.series, draft.summaries[i].type, draft.summaries[i].chosen)}</strong>`;
                        }
                        rebuildModalSummary();
                        refreshModalParts();
                    }
                }
            };
            el.addEventListener("input", handler);
            el.addEventListener("change", handler);
        });

        // ---- Bind room dimensions (single) ----
        ["gbModalLen", "gbModalWid", "gbModalHei"].forEach(id => {
            const el = document.getElementById(id);
            if (!el) return;
            el.addEventListener("input", () => {
                if (id === "gbModalLen") draft.len = Number(el.value);
                if (id === "gbModalWid") draft.wid = Number(el.value);
                if (id === "gbModalHei") draft.height = Number(el.value);
                if (draft.len && draft.wid && draft.height) {
                    recalcDraftSingle();
                    rebuildModalSummary();
                    updateModalWarning();

                    const cartBtn = overlay.querySelector("#gbModalAddToCart");
                    const eff = effectiveSqft(draft.len, draft.wid, draft.height);
                    const isOversize = eff > CONFIG.maxEffSqft;
                    if (cartBtn) {
                        cartBtn.disabled = isOversize;
                        cartBtn.style.opacity = isOversize ? "0.45" : "";
                        cartBtn.style.cursor = isOversize ? "not-allowed" : "";
                    }

                    if (!isOversize) refreshModalParts();
                }
            });
        });

        // ---- Bind Delete ----
        overlay.querySelector("#gbModalDelete")?.addEventListener("click", () => {
            state.savedSystems.splice(idx, 1);
            state.savedSystems.forEach((s, i) => {
                s.label = `System ${i + 1}`;
            });

            saveState();
            closeModal();
            render();
        });

        // ---- Bind Save ----
        overlay.querySelector("#gbModalSave")?.addEventListener("click", () => {
            state.savedSystems[idx] = {
                ...draft
            };
            saveState();
            closeModal();
            render();
        });

        // ---- Bind Add to Cart ----
        overlay.querySelector("#gbModalAddToCart")?.addEventListener("click", async () => {
            const btn = overlay.querySelector("#gbModalAddToCart");
            const msgEl = overlay.querySelector("#gbModalCartMsg");
            btn.disabled = true;
            btn.textContent = "Adding…";
            msgEl.textContent = "";

            try {
                const items = [];
                const props = {
                    "_source": "GWIN Builder",
                    "_series": draft.seriesLabel,
                    "_system": draft.label
                };

                if (draft.mode === "single") {
                    const product = await fetchProduct(draft.handle);
                    const variant = resolveVariantByBtuVoltage(product, draft.chosen, draft.voltage) || product.variants?.[0];
                    if (!variant) throw new Error("Variant not found");
                    items.push({
                        id: variant.id,
                        quantity: 1,
                        properties: props
                    });

                    if (Number(draft.lineLen) > 15) {
                        const lv = await resolveSzLinesetVariant(draft.lineLen);
                        if (lv) items.push({
                            id: lv.id,
                            quantity: 1,
                            properties: props
                        });
                    }

                    if (draft.lineGuard) {
                        const v = await getFirstVariantForHandle(CONFIG.accessories.lineguard);
                        if (v) items.push({
                            id: v.id,
                            quantity: 1,
                            properties: props
                        });
                    }

                    const mountHandle = draft.mount === "wall" ? CONFIG.accessories.wallBracket :
                        draft.mount === "ground" ? CONFIG.accessories.groundStand : null;
                    if (mountHandle) {
                        const v = await getFirstVariantForHandle(mountHandle);
                        if (v) items.push({
                            id: v.id,
                            quantity: 1,
                            properties: props
                        });
                    }

                    if (draft.condenserPad) {
                        const v = await getFirstVariantForHandle(CONFIG.accessories.condenserPad);
                        if (v) items.push({
                            id: v.id,
                            quantity: 1,
                            properties: props
                        });
                    }

                    if (draft.disconnect) {
                        const v = await getFirstVariantForHandle(CONFIG.accessories.disconnect);
                        if (v) items.push({
                            id: v.id,
                            quantity: 1,
                            properties: props
                        });
                    }

                } else {
                    // Multi-zone
                    const condProduct = await fetchProduct(draft.condenser.handle);
                    items.push({
                        id: condProduct.variants[0].id,
                        quantity: 1,
                        properties: props
                    });

                    const mzSeries = CONFIG.multiZone.series[draft.series];
                    for (const room of draft.summaries) {
                        const ahuHandle = getMultiZoneAhuHandle(mzSeries, room);
                        if (!ahuHandle) continue;
                        const ahuProduct = await fetchProduct(ahuHandle);
                        const usesIndividual = (room.type === "cassette" && mzSeries.cassetteHandleByBtu) ||
                            (room.type !== "cassette" && mzSeries.wallHandleByBtu);
                        const ahuVariant = usesIndividual ?
                            ahuProduct.variants?.[0] :
                            resolveVariantByBtuAndSeries(ahuProduct, room.chosen, draft.seriesLabel);
                        if (!ahuVariant) continue;
                        items.push({
                            id: ahuVariant.id,
                            quantity: 1,
                            properties: {
                                ...props,
                                "_room": room.label
                            }
                        });

                        const lineVariant = await resolveLinesetVariant(room.chosen, room.lineLen);
                        if (lineVariant) items.push({
                            id: lineVariant.id,
                            quantity: 1,
                            properties: {
                                ...props,
                                "_room": room.label
                            }
                        });

                        if (room.lineGuard) {
                            const v = await getFirstVariantForHandle(CONFIG.accessories.lineguard);
                            if (v) items.push({
                                id: v.id,
                                quantity: 1,
                                properties: {
                                    ...props,
                                    "_room": room.label
                                }
                            });
                        }
                    }

                    const mzMountHandle = draft.mzAccessories?.mount === "wall" ? CONFIG.accessories.wallBracket :
                        draft.mzAccessories?.mount === "ground" ? CONFIG.accessories.groundStand : null;
                    if (mzMountHandle) {
                        const v = await getFirstVariantForHandle(mzMountHandle);
                        if (v) items.push({
                            id: v.id,
                            quantity: 1,
                            properties: props
                        });
                    }
                    if (draft.mzAccessories?.condenserPad) {
                        const v = await getFirstVariantForHandle(CONFIG.accessories.condenserPad);
                        if (v) items.push({
                            id: v.id,
                            quantity: 1,
                            properties: props
                        });
                    }
                    if (draft.mzAccessories?.disconnect) {
                        const v = await getFirstVariantForHandle(CONFIG.accessories.disconnect);
                        if (v) items.push({
                            id: v.id,
                            quantity: 1,
                            properties: props
                        });
                    }
                }

                await addToCart(items);

                // Remove from saved systems after successful cart add
                state.savedSystems.splice(idx, 1);
                state.savedSystems.forEach((s, i) => s.label = `System ${i + 1}`);
                saveState();

                // Brief confirmation then close
                btn.textContent = "Added!";
                setTimeout(() => {
                    closeModal();
                    renderSavedSystems();
                }, 800);

            } catch (e) {
                console.error(e);
                btn.disabled = false;
                btn.textContent = "Add to Cart";
                msgEl.textContent = e.message || "Failed to add. Try again.";
            }
        });

        // ---- Async: load accessory images + prices ----
        (async () => {
            // Load product image into summary
            try {
                const handle = draft.mode === "single" ?
                    draft.handle :
                    draft.condenser?.handle;
                if (handle) {
                    const product = await fetchProduct(handle);
                    const img = getProductFeaturedImage(product);
                    const imgEl = overlay.querySelector("#gbModalProductImg");
                    if (imgEl && img) {
                        imgEl.src = img;
                        imgEl.style.display = "block";
                    }
                }
            } catch {}
            const [groundMeta, wallMeta, padMeta, disconnectMeta] = await Promise.all([
                fetchAccessoryMeta(CONFIG.accessories.groundStand),
                fetchAccessoryMeta(CONFIG.accessories.wallBracket),
                fetchAccessoryMeta(CONFIG.accessories.condenserPad),
                fetchAccessoryMeta(CONFIG.accessories.disconnect),
            ]);
            applyAccOptionMeta("gbModalMountGround", "gbModalGroundImg", "gbModalGroundPrice", groundMeta);
            applyAccOptionMeta("gbModalMountWall", "gbModalWallImg", "gbModalWallPrice", wallMeta);
            applyAccOptionMeta("gbModalMountPad", "gbModalPadImg", "gbModalPadPrice", padMeta);
            applyAccToggleMeta("gbModalDisconnectToggle", "gbModalDisconnectImg", "gbModalDisconnectPrice", disconnectMeta);
        })();

        function rebuildModalSummary() {
            const summaryEl = overlay.querySelector(".gb-modal-summary");
            if (!summaryEl) return;
            summaryEl.innerHTML = getSummaryHTML();
            updateModalWarning();
            const imgEl = overlay.querySelector("#gbModalProductImg");
            if (imgEl) {
                const handle = draft.mode === "single" ? draft.handle : draft.condenser?.handle;
                if (handle) {
                    fetchProduct(handle).then(product => {
                        const img = getProductFeaturedImage(product);
                        if (img) {
                            imgEl.src = img;
                            imgEl.style.display = "block";
                        }
                    }).catch(() => {});
                }
            }
        }

        function updateModalWarning() {
            const warningEl = overlay.querySelector("#gbModalWarning");
            if (!warningEl) return;

            if (draft.mode === "single") {
                if (!draft.len || !draft.wid || !draft.height) {
                    warningEl.style.display = "none";
                    return;
                }
                const eff = effectiveSqft(draft.len, draft.wid, draft.height);
                if (eff > CONFIG.maxEffSqft) {
                    const systemsNeeded = Math.ceil(eff / CONFIG.maxEffSqft);
                    const recBtu = CONFIG.singleZone[draft.series].wallSizes[CONFIG.singleZone[draft.series].wallSizes.length - 1];
                    warningEl.style.display = "block";
                    warningEl.innerHTML = `⚠️ <strong>Space is oversized</strong> for a single system (~${Math.round(eff)} eq sq ft). We recommend <strong>${systemsNeeded} × ${Math.round(recBtu / 1000)}k</strong> single-zone systems instead. Purchase this system and an additional system.`;
                    return;
                }
            }

            if (draft.mode === "multi") {
                const oversizedRooms = draft.summaries.filter(r =>
                    r.len && r.wid && r.height && effectiveSqft(r.len, r.wid, r.height) > CONFIG.maxEffSqft
                );
                if (oversizedRooms.length) {
                    warningEl.style.display = "block";
                    warningEl.innerHTML = `⚠️ <strong>${oversizedRooms.map(r => r.label).join(", ")}</strong> exceed${oversizedRooms.length === 1 ? "s" : ""} max single-zone coverage (~${CONFIG.maxEffSqft} eq sq ft). Consider splitting into separate systems.`;
                    return;
                }
                let sumHeads = 0;
                for (const r of draft.summaries) {
                    if (r.chosen) sumHeads += r.chosen;
                }
                const effective = sumHeads - CONFIG.condenserOverageAllowance;
                const largest = CONFIG.multiZone.condensers[CONFIG.multiZone.condensers.length - 1];
                if (effective > largest.btu) {
                    warningEl.style.display = "block";
                    warningEl.innerHTML = `⚠️ <strong>Total load exceeds maximum condenser capacity</strong> (${Math.round(largest.btu / 1000)}k). Consider splitting into multiple systems.`;
                    return;
                }
            }

            warningEl.style.display = "none";
        }

        function recalcDraftCondenser() {
            if (draft.mode !== "multi") return;
            let sumHeads = 0;
            for (const room of draft.summaries) {
                if (room.chosen) sumHeads += room.chosen;
            }
            const effective = sumHeads - CONFIG.condenserOverageAllowance;
            let condenser = CONFIG.multiZone.condensers[CONFIG.multiZone.condensers.length - 1];
            for (const c of CONFIG.multiZone.condensers) {
                if (effective <= c.btu) {
                    condenser = c;
                    break;
                }
            }
            draft.condenser = condenser;
            draft.roomCount = draft.summaries.length;
        }

        function recalcDraftSingle() {
            if (draft.mode !== "single") return;
            const sz = CONFIG.singleZone[draft.series];
            if (!sz) return;
            const eff = effectiveSqft(draft.len, draft.wid, draft.height);
            if (!eff) return;

            if (eff > CONFIG.maxEffSqft) {
                draft.handle = null;
                draft.chosen = null;
                return;
            }

            const type = draft.type || "wall";
            const availSizes = type === "cassette" ? sz.cassetteSizes : sz.wallSizes;
            if (!availSizes.length) return;
            const suggested = suggestBtu(eff, CONFIG.singleBands, availSizes);
            if (!draft.chosen || !availSizes.includes(draft.chosen) || draft.chosen < suggested) {
                draft.chosen = suggested;
            }
            const availVoltages = getVoltagesForBtu(draft.series, draft.chosen, type);
            const voltage = availVoltages.includes(Number(draft.voltage)) ? Number(draft.voltage) : availVoltages[0];
            draft.voltage = voltage;
            const handleMap = type === "cassette" ? sz.cassetteBundleHandle : sz.bundleHandle;
            draft.handle = handleMap?.[draft.chosen]?.[voltage];
        }

        // ---- Parts list refresh ----
        async function refreshModalParts() {
            const partsEl = overlay.querySelector("#gbModalPartsList")
            if (!partsEl) return;

            partsEl.innerHTML = `<div class="gb-part-row"><span>Calculating…</span><span class="part-price">—</span></div>`;

            function imgTag(src, alt = "") {
                if (!src) return `<div style="width:36px;height:36px;border-radius:6px;background:#f0f0f0;flex-shrink:0;"></div>`;
                return `<img src="${src}" alt="${alt}" style="width:36px;height:36px;object-fit:cover;border-radius:6px;border:1px solid #e0e0e0;flex-shrink:0;">`;
            }

            function partRow(imgSrc, label, priceHTML, alt = "") {
                return `
        <div class="gb-part-row" style="align-items:center;gap:10px;">
          ${imgTag(imgSrc, alt)}
          <span style="flex:1;min-width:0;">${label}</span>
          <span class="part-price" style="flex-shrink:0;">${priceHTML}</span>
        </div>
      `;
            }

            function priceHTML(d) {
                if (!d) return "—";
                return `<span class="gb-price-original">${d.original}</span><span class="gb-price-discounted">${d.discounted}</span>`;
            }

            try {
                let total = 0;
                let rows = "";

                if (draft.mode === "single") {
                    // Fetch all needed products in parallel
                    const [bundleProduct, lineguardProduct, groundProduct, wallProduct, padProduct, disconnectProduct] = await Promise.all([
                        draft.handle ? fetchProduct(draft.handle).catch(() => null) : null,
                        draft.lineGuard ? fetchProduct(CONFIG.accessories.lineguard).catch(() => null) : null,
                        draft.mount === "ground" ? fetchProduct(CONFIG.accessories.groundStand).catch(() => null) : null,
                        draft.mount === "wall" ? fetchProduct(CONFIG.accessories.wallBracket).catch(() => null) : null,
                        draft.mount === "pad" ? fetchProduct(CONFIG.accessories.condenserPad).catch(() => null) : null,
                        draft.disconnect ? fetchProduct(CONFIG.accessories.disconnect).catch(() => null) : null,
                    ]);

                    const bundleImg = getProductFeaturedImage(bundleProduct);
                    const bundlePrice = bundleProduct?.variants?.[0]?.price ? parseInt(bundleProduct.variants[0].price, 10) : null;
                    const linePrice = Number(draft.lineLen) > 15 ? await getSzLinesetPriceCents(draft.lineLen) : 0;
                    const lineImg = await getSzLinesetProductImage(Number(draft.lineLen) || 15);
                    const bp = bundlePrice ? formatMoneyDiscounted(bundlePrice) : null;
                    const lp = linePrice ? formatMoneyDiscounted(linePrice) : null;

                    if (bp) total += bp.discountedCents;
                    if (lp) total += lp.discountedCents;

                    rows += partRow(bundleImg, `<strong>${Math.round(draft.chosen / 1000)}k</strong> ${draft.type === "cassette" ? "Cassette" : "High Wall"} Complete System`, priceHTML(bp), `${draft.seriesLabel} ${Math.round(draft.chosen / 1000)}k`);
                    rows += partRow(lineImg, Number(draft.lineLen) > 15 ? `${draft.lineLen}ft line set (upgrade)` : "15ft line set (included)", lp ? priceHTML(lp) : "Included", "Line set");
                    if (draft.lineGuard && lineguardProduct) {
                        const p = lineguardProduct.variants?.[0]?.price ? parseInt(lineguardProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) total += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(lineguardProduct), "Line Guard", priceHTML(d));
                    }

                    if (draft.mount === "ground" && groundProduct) {
                        const p = groundProduct.variants?.[0]?.price ? parseInt(groundProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) total += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(groundProduct), "Ground Stand Brackets", priceHTML(d));
                    }

                    if (draft.mount === "wall" && wallProduct) {
                        const p = wallProduct.variants?.[0]?.price ? parseInt(wallProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) total += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(wallProduct), "Wall Mount Bracket", priceHTML(d));
                    }

                    if (draft.mount === "pad" && padProduct) {
                        const p = padProduct.variants?.[0]?.price ? parseInt(padProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) total += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(padProduct), "Condenser Pad", priceHTML(d));
                    }

                    if (draft.disconnect && disconnectProduct) {
                        const p = disconnectProduct.variants?.[0]?.price ? parseInt(disconnectProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) total += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(disconnectProduct), "Disconnect Switch &amp; Whip", priceHTML(d));
                    }

                } else {
                    // Multi-zone — fetch condenser + shared accessories in parallel
                    const acc = draft.mzAccessories || {};
                    const mzMountHandle = acc.mount === "wall" ? CONFIG.accessories.wallBracket :
                        acc.mount === "ground" ? CONFIG.accessories.groundStand :
                        acc.mount === "pad" ? CONFIG.accessories.condenserPad :
                        null;

                    const [condProduct, mzMountProduct, mzPadProduct, mzDisconnectProduct] = await Promise.all([
                        fetchProduct(draft.condenser.handle).catch(() => null),
                        mzMountHandle ? fetchProduct(mzMountHandle).catch(() => null) : null,
                        acc.condenserPad ? fetchProduct(CONFIG.accessories.condenserPad).catch(() => null) : null,
                        acc.disconnect ? fetchProduct(CONFIG.accessories.disconnect).catch(() => null) : null,
                    ]);

                    const condImg = getProductFeaturedImage(condProduct);
                    const condPrice = condProduct?.variants?.[0]?.price ? parseInt(condProduct.variants[0].price, 10) : null;
                    const condD = condPrice ? formatMoneyDiscounted(condPrice) : null;
                    if (condD) total += condD.discountedCents;
                    rows += partRow(condImg, `<strong>${Math.round(draft.condenser.btu / 1000)}k</strong> Condenser`, priceHTML(condD), `${Math.round(draft.condenser.btu / 1000)}k condenser`);

                    const mzSeries = CONFIG.multiZone.series[draft.series];
                    const lineguardProduct = await fetchProduct(CONFIG.accessories.lineguard).catch(() => null);
                    const lineguardImg = getProductFeaturedImage(lineguardProduct);

                    for (const room of draft.summaries) {
                        const ahuHandle = getMultiZoneAhuHandle(mzSeries, room);
                        let ahuImg = "";

                        if (ahuHandle) {
                            const ahuProduct = await fetchProduct(ahuHandle).catch(() => null);
                            ahuImg = getProductFeaturedImage(ahuProduct);

                            const ahuPrice = await getVariantPriceCents(ahuHandle, p => {
                                const usesIndividual = (room.type === "cassette" && mzSeries.cassetteHandleByBtu) ||
                                    (room.type !== "cassette" && mzSeries.wallHandleByBtu);
                                return usesIndividual ? p?.variants?.[0] : resolveVariantByBtuAndSeries(p, room.chosen, draft.seriesLabel);
                            });
                            const d = ahuPrice ? formatMoneyDiscounted(ahuPrice) : null;
                            if (d) total += d.discountedCents;
                            rows += partRow(ahuImg, `<strong>${room.label}</strong> — ${Math.round(room.chosen / 1000)}k ${room.type === "cassette" ? "Cassette" : "High Wall"}`, priceHTML(d));
                        }

                        const linePrice = await getLinesetPriceCents(room.chosen, room.lineLen) || 0;
                        const lineD = linePrice ? formatMoneyDiscounted(linePrice) : null;
                        const lineImg = await getLinesetProductImage(room.chosen, room.lineLen);

                        if (lineD) total += lineD.discountedCents;

                        rows += partRow(lineImg, `${room.label}: ${room.lineLen}ft line set${room.lineLen >= 65 ? " w/ coupler" : ""}`, priceHTML(lineD));

                        if (room.lineGuard) {
                            const p = lineguardProduct?.variants?.[0]?.price ? parseInt(lineguardProduct.variants[0].price, 10) : null;
                            const d = p ? formatMoneyDiscounted(p) : null;
                            if (d) total += d.discountedCents;
                            rows += partRow(lineguardImg, `${room.label}: Line Guard`, priceHTML(d));
                        }
                    }

                    if (mzMountHandle && mzMountProduct) {
                        const p = mzMountProduct.variants?.[0]?.price ? parseInt(mzMountProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) total += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(mzMountProduct), acc.mount === "wall" ? "Wall Bracket" : "Ground Stand", priceHTML(d));
                    }

                    if (acc.disconnect && mzDisconnectProduct) {
                        const p = mzDisconnectProduct.variants?.[0]?.price ? parseInt(mzDisconnectProduct.variants[0].price, 10) : null;
                        const d = p ? formatMoneyDiscounted(p) : null;
                        if (d) total += d.discountedCents;
                        rows += partRow(getProductFeaturedImage(mzDisconnectProduct), "Disconnect Switch &amp; Whip", priceHTML(d));
                    }
                }

                if (!overlay.querySelector("#gbModalPartsList")) return;

                partsEl.innerHTML = rows + (total > 0 ? `
        <div class="gb-part-row part-total">
          <span>Estimated total (with discount)</span>
          <span class="part-price" style="color:var(--c-brand);">${formatMoneyFromCents(total)}</span>
        </div>` : "");

            } catch (e) {
                console.error("Modal parts refresh failed:", e);
                const el = overlay.querySelector("#gbModalPartsList");
                if (el) el.innerHTML = `<div style="color:#b91c1c;font-size:13px;">Could not load pricing.</div>`;
            }
        }
        updateModalWarning();
        // Initial parts load
        refreshModalParts();
    }

    function render() {
        saveState();
        renderModeToggle();
        renderSeriesGrid();

        if (state.mode === "single") {
            renderSingleSizeSelect();
            renderVoltage();
        } else {
            renderRooms();
        }

        renderResults();
        renderSavedSystems();
        bindRoomEvents();
    }

    function bindRoomEvents() {
        if (state.mode !== "multi") return;

        let tabTarget = null;

        const getRoomFieldSelector = (idx, key) => `[data-room="${idx}"][data-k="${key}"]`;

        function getNextRoomField(idx, key, backwards = false) {
            const order = ["len", "wid", "height", "type", "size", "lineLen", "lineGuard"];
            const currentIndex = order.indexOf(key);

            if (currentIndex === -1) return null;

            if (backwards) {
                const prevKey = order[currentIndex - 1];

                if (prevKey) {
                    return {
                        idx,
                        key: prevKey
                    };
                }

                if (idx > 0) {
                    return {
                        idx: idx - 1,
                        key: "lineGuard"
                    };
                }

                return null;
            }

            const nextKey = order[currentIndex + 1];

            if (nextKey) {
                return {
                    idx,
                    key: nextKey
                };
            }

            if (state.rooms[idx + 1]) {
                return {
                    idx: idx + 1,
                    key: "len"
                };
            }

            return null;
        }

        document.querySelectorAll("[data-remove]").forEach(btn => {
            btn.addEventListener("click", () => {
                state.rooms.splice(Number(btn.dataset.remove), 1);
                state.rooms.forEach((r, i) => r.label = `Room ${i + 1}`);
                saveState();
                render();
            });
        });

        document.querySelectorAll("[data-room][data-k]").forEach(inp => {
            inp.addEventListener("keydown", e => {
                if (e.key !== "Tab") return;

                const idx = Number(inp.dataset.room);
                const k = inp.dataset.k;
                tabTarget = getNextRoomField(idx, k, e.shiftKey);
            });

            inp.addEventListener("input", () => {
                const idx = Number(inp.dataset.room);
                const k = inp.dataset.k;

                if (!state.rooms[idx]) return;

                if (["len", "wid", "height"].includes(k)) {
                    state.rooms[idx][k] = inp.value === "" ? "" : Number(inp.value);
                    state.rooms[idx].size = null;

                    saveState();

                    // Do not render while typing dimensions.
                    return;
                }

                if (["lineLen", "size"].includes(k)) {
                    state.rooms[idx][k] = Number(inp.value);
                    saveState();
                    renderResults();
                    return;
                }

                state.rooms[idx][k] = inp.value;

                if (k === "type") {
                    state.rooms[idx].size = null;
                    saveState();
                    render();
                    return;
                }

                saveState();
                renderResults();
            });
        });

        document
            .querySelectorAll('[data-room][data-k="len"], [data-room][data-k="wid"], [data-room][data-k="height"]')
            .forEach(inp => {
                inp.addEventListener("blur", () => {
                    const idx = Number(inp.dataset.room);
                    const k = inp.dataset.k;

                    if (!state.rooms[idx]) return;

                    state.rooms[idx][k] = inp.value === "" ? 0 : Number(inp.value);
                    state.rooms[idx].size = null;

                    saveState();

                    const nextFocus = tabTarget;
                    tabTarget = null;

                    render();

                    if (nextFocus) {
                        requestAnimationFrame(() => {
                            const nextEl = document.querySelector(
                                getRoomFieldSelector(nextFocus.idx, nextFocus.key)
                            );

                            if (nextEl) {
                                nextEl.focus();

                                if (typeof nextEl.select === "function") {
                                    nextEl.select();
                                }
                            }
                        });
                    }
                });
            });
    }

    // ============================================================
    // CART ACTIONS
    // ============================================================
    async function addSingleToCart() {
        const btn = document.getElementById("gbAddToCart");
        if (btn.disabled) return;
        const msgEl = document.getElementById("gbCartMsg");
        msgEl.textContent = "Adding to cart…";
        btn.disabled = true;
        try {
            const sz = computeSingle();
            if (!sz || sz.overLimit || !sz.handle) throw new Error("Invalid configuration.");

            const builderProps = {
                "_source": "GWIN Builder",
                "_series": CONFIG.singleZone[state.series].label
            };
            const items = [];

            // 1. Bundle product (includes 15ft line set)
            const product = await fetchProduct(sz.handle);
            // Try to match by voltage+btu variant, fall back to first variant
            const variant = resolveVariantByBtuVoltage(product, sz.chosen, sz.voltage) || product.variants?.[0];
            if (!variant) throw new Error("Could not find product variant.");
            items.push({
                id: variant.id,
                quantity: 1,
                properties: builderProps
            });

            // 2. If line length > 15ft, add upgrade line set
            if (sz.lineLen > 15) {
                const lineVariant = await resolveLinesetVariant(sz.chosen, sz.lineLen);
                items.push({
                    id: lineVariant.id,
                    quantity: 1,
                    properties: builderProps
                });
            }
            // Line guard
            if (state.single.lineGuard) {
                const lg = await fetchProduct(CONFIG.accessories.lineguard);
                if (lg?.variants?.[0]) items.push({
                    id: lg.variants[0].id,
                    quantity: 1,
                    properties: builderProps
                });
            }

            // Mount
            const mountHandle =
                state.single.mount === "wall" ? CONFIG.accessories.wallBracket :
                state.single.mount === "ground" ? CONFIG.accessories.groundStand :
                null;

            if (mountHandle) {
                const mountVariant = await getFirstVariantForHandle(mountHandle);

                if (mountVariant) {
                    items.push({
                        id: mountVariant.id,
                        quantity: 1,
                        properties: builderProps,
                    });
                }
            }

            // Condenser pad
            if (state.single.mount === "pad") {
                const padVariant = await getFirstVariantForHandle(CONFIG.accessories.condenserPad);

                if (padVariant) {
                    items.push({
                        id: padVariant.id,
                        quantity: 1,
                        properties: builderProps,
                    });
                }
            }

            // Disconnect
            if (state.single.disconnect) {
                const dc = await fetchProduct(CONFIG.accessories.disconnect);
                if (dc?.variants?.[0]) items.push({
                    id: dc.variants[0].id,
                    quantity: 1,
                    properties: builderProps
                });
            }

            await addToCart(items);

            state.single = getFreshSingleState();
            clearSingleFormDomValues();
            saveState();
            render();

            setTimeout(() => {
                const freshMsg = document.getElementById("gbCartMsg");
                if (freshMsg) {
                    freshMsg.innerHTML = `Added to cart! <a href="/cart" style="color:var(--c-brand);font-weight:700;">View cart →</a>`;
                }
            }, 0);
        } catch (e) {
            console.error(e);
            msgEl.textContent = e.message || "Failed to add.";
        } finally {
            btn.disabled = false;
        }
    }

    function getMultiZoneAhuHandle(seriesConfig, room) {
        const chosen = Number(room.chosen);

        if (room.type === "cassette") {
            if (seriesConfig.cassetteHandleByBtu) {
                return seriesConfig.cassetteHandleByBtu[chosen];
            }

            return seriesConfig.cassetteHandle;
        }

        if (seriesConfig.wallHandleByBtu) {
            return seriesConfig.wallHandleByBtu[chosen];
        }

        return seriesConfig.wallHandle;
    }

    function getAhuTypeLabel(seriesKey, type, btu) {
        if (type !== "cassette") return "High Wall";
        const mzSeries = CONFIG.multiZone.series[seriesKey];
        if (!mzSeries) return "Cassette";
        // Coastal uses a single cassetteHandle (ceiling cassette), others use cassetteHandleByBtu (slim)
        if (mzSeries.cassetteHandle && !mzSeries.cassetteHandleByBtu) return "Ceiling Cassette";
        return "Slim Cassette";
    }

    async function addBundleToCart() {
        const msgEl = document.getElementById("gbBundleMsg");
        const btn = document.getElementById("gbAddBundle");

        msgEl.textContent = "Building bundle…";
        btn.disabled = true;

        try {
            const m = computeMulti();

            if (m.hasError) throw new Error("Fix room errors before adding to cart.");
            if (!m.condenser?.handle) throw new Error("No condenser selected.");

            const mzSeries = CONFIG.multiZone.series[state.series];

            const builderProps = {
                "_source": "GWIN Builder",
                "_series": mzSeries.label,
            };

            const items = [];

            // 1. Condenser
            const condenserProduct = await fetchProduct(m.condenser.handle);
            const condenserVariant = condenserProduct?.variants?.[0];

            if (!condenserVariant) {
                throw new Error(`No condenser variant found for ${m.condenser.handle}`);
            }

            items.push({
                id: condenserVariant.id,
                quantity: 1,
                properties: {
                    ...builderProps,
                    "_item": `${Math.round(m.condenser.btu / 1000)}k condenser`,
                },
            });

            // 2. Rooms: air handler + line set + optional line guard
            for (const room of m.summaries) {
                if (room.empty || room.overLimit || !room.chosen) continue;

                const ahuHandle = getMultiZoneAhuHandle(mzSeries, room);

                if (!ahuHandle) {
                    throw new Error(`No AHU handle found for ${room.chosen} BTU ${room.type}`);
                }

                const ahuProduct = await fetchProduct(ahuHandle);

                const usesIndividualAhuProduct =
                    (room.type === "cassette" && mzSeries.cassetteHandleByBtu) ||
                    (room.type !== "cassette" && mzSeries.wallHandleByBtu);

                const ahuVariant = usesIndividualAhuProduct ?
                    ahuProduct?.variants?.[0] :
                    resolveVariantByBtuAndSeries(
                        ahuProduct,
                        room.chosen,
                        mzSeries.label || state.series
                    );

                if (!ahuVariant) {
                    throw new Error(`No AHU variant found for ${room.label} ${room.chosen} BTU`);
                }

                items.push({
                    id: ahuVariant.id,
                    quantity: 1,
                    properties: {
                        ...builderProps,
                        "_room": room.label || "",
                        "_item": `${Math.round(room.chosen / 1000)}k ${getAhuTypeLabel(state.series, room.type, room.chosen)}`,
                    },
                });
                const roomLineLen = Number(room.lineLen || CONFIG.defaultLineLen);

                const lineVariant = await resolveLinesetVariant(room.chosen, room.lineLen);

                if (!lineVariant) {
                    throw new Error(`No line set variant found for ${room.chosen} BTU / ${room.lineLen}ft`);
                }

                items.push({
                    id: lineVariant.id,
                    quantity: 1,
                    properties: {
                        ...builderProps,
                        "_room": room.label || "",
                        "_item": `${room.lineLen}ft`,
                    },
                });

                if (room.lineGuard === "yes" || room.lineGuard === true) {
                    const guardVariant = await getFirstVariantForHandle(CONFIG.accessories.lineguard);

                    if (guardVariant) {
                        items.push({
                            id: guardVariant.id,
                            quantity: 1,
                            properties: {
                                ...builderProps,
                                "_room": room.label || "",
                                "_item": "Line Guard",
                            },
                        });
                    }
                }
            }

            // 3. Shared condenser accessories
            const mzMountHandle =
                state.mzAccessories?.mount === "wall" ? CONFIG.accessories.wallBracket :
                state.mzAccessories?.mount === "ground" ? CONFIG.accessories.groundStand :
                state.mzAccessories?.mount === "pad" ? CONFIG.accessories.condenserPad :
                null;

            const condenserAccessoryProps = {
                ...builderProps,
                "_condenser": `${Math.round(m.condenser.btu / 1000)}k ${m.condenser.zonesLabel}`,
            };

            if (mzMountHandle) {
                const mountVariant = await getFirstVariantForHandle(mzMountHandle);

                if (mountVariant) {
                    items.push({
                        id: mountVariant.id,
                        quantity: 1,
                        properties: {
                            ...condenserAccessoryProps,
                            "_item": state.mzAccessories.mount === "wall" ?
                                "Condenser Wall Bracket" : "Condenser Ground Stand",
                        },
                    });
                }
            }


            if (state.mzAccessories.disconnect === "yes" || state.mzAccessories.disconnect === true) {
                const disconnectVariant = await getFirstVariantForHandle(CONFIG.accessories.disconnect);

                if (disconnectVariant) {
                    items.push({
                        id: disconnectVariant.id,
                        quantity: 1,
                        properties: {
                            ...condenserAccessoryProps,
                            "_item": "Disconnect Switch & Whip",
                        },
                    });
                }
            }

            if (!items.length) throw new Error("No items to add.");

            await addToCart(items);

            // Clear the live multi-zone configuration after successful cart add.
            state.rooms = [{
                    label: "Room 1",
                    len: 0,
                    wid: 0,
                    height: 0,
                    type: null,
                    size: null,
                    lineLen: CONFIG.defaultLineLen,
                    lineGuard: ""
                },
                {
                    label: "Room 2",
                    len: 0,
                    wid: 0,
                    height: 0,
                    type: null,
                    size: null,
                    lineLen: CONFIG.defaultLineLen,
                    lineGuard: ""
                },
            ];

            state.mzAccessories = {
                mount: "",
                condenserPad: false,
                disconnect: false,
            };

            saveState();
            render();

            const freshMsgEl = document.getElementById("gbBundleMsg");
            if (freshMsgEl) {
                freshMsgEl.innerHTML = `Bundle added! <a href="/cart" style="color:var(--c-brand);font-weight:700;">View cart →</a>`;
            }
        } catch (e) {
            console.error(e);
            msgEl.textContent = e.message || "Failed to add bundle.";
        } finally {
            btn.disabled = false;
        }
    }

    // ============================================================
    // INIT
    // ============================================================
    document.getElementById("gbModeSingle").addEventListener("click", () => {
        state.mode = "single";

        const bundleMsg = document.getElementById("gbBundleMsg");
        if (bundleMsg) bundleMsg.textContent = "";

        render();
    });

    document.getElementById("gbModeMulti").addEventListener("click", () => {
        state.mode = "multi";

        const cartMsg = document.getElementById("gbCartMsg");
        if (cartMsg) cartMsg.textContent = "";

        render();
    });

    // Single zone inputs
    ["szLen", "szWid", "szHei"].forEach((id, i) => {
        const keys = ["len", "wid", "height"];
        document.getElementById(id).addEventListener("input", e => {
            state.single[keys[i]] = Number(e.target.value);
            state.single.size = null;
            saveState();
            renderSingleSizeSelect();
            renderVoltage();
            renderResults();
        });
    });

    document.getElementById("szType").addEventListener("change", e => {
        state.single.type = e.target.value;
        state.single.size = null;
        saveState();

        renderSingleSizeSelect();
        renderVoltage();
        renderResults();
    });


    document.getElementById("szLineGuard").addEventListener("change", e => {
        if (e.target.disabled) return;

        const sz = computeSingle();
        if (sz?.overLimit) {
            e.target.value = "";
            state.single.lineGuard = false;
            saveState();
            return;
        }

        state.single.lineGuard = e.target.value === "yes";
        saveState();
        renderResults();
    });
    document.getElementById("szLineLen").addEventListener("change", e => {
        state.single.lineLen = Number(e.target.value) || 15;
        saveState();
        renderResults();
    });

    document.getElementById("gbAddRoom").addEventListener("click", () => {
        if (state.rooms.length >= 5) return;
        state.rooms.push({
            label: `Room ${state.rooms.length + 1}`,
            len: 0,
            wid: 0,
            height: 0,
            type: null,
            size: null,
            lineLen: CONFIG.defaultLineLen,
            lineGuard: "",
        });
        render();
    });

    document.getElementById("gbReset").addEventListener("click", () => {
        state.rooms = [{
                label: "Room 1",
                len: 0,
                wid: 0,
                height: 0,
                type: null,
                size: null,
                lineLen: CONFIG.defaultLineLen
            },
            {
                label: "Room 2",
                len: 0,
                wid: 0,
                height: 0,
                type: null,
                size: null,
                lineLen: CONFIG.defaultLineLen
            },
        ];
        render();
    });

    document.getElementById("gbAddToCart").addEventListener("click", addSingleToCart);
    document.getElementById("gbAddBundle").addEventListener("click", addBundleToCart);

    // Apply GWIN15 discount to session silently
    fetch(`/discount/${DISCOUNT_CODE}`).catch(() => {});

    installCartDrawerDelegates();

    loadState();

    function getFreshSingleState() {
        return {
            len: 0,
            wid: 0,
            height: 0,
            type: null,
            size: null,
            lineLen: 15,
            lineGuard: "",
            mount: "",
            condenserPad: false,
            disconnect: false,
        };
    }

    function getFreshRoomsState() {
        return [{
                label: "Room 1",
                len: 0,
                wid: 0,
                height: 0,
                type: null,
                size: null,
                lineLen: CONFIG.defaultLineLen,
                lineGuard: "",
            },
            {
                label: "Room 2",
                len: 0,
                wid: 0,
                height: 0,
                type: null,
                size: null,
                lineLen: CONFIG.defaultLineLen,
                lineGuard: "",
            },
        ];
    }

    function getFreshMzAccessoriesState() {
        return {
            mount: "",
            condenserPad: false,
            disconnect: false,
        };
    }

    function setSingleLineGuardDisabled(disabled) {
        const lineGuardSel = document.getElementById("szLineGuard");
        if (!lineGuardSel) return;

        lineGuardSel.disabled = disabled;

        if (disabled) {
            lineGuardSel.value = "";
            state.single.lineGuard = false;
            lineGuardSel.title = "Line Guard is configured per system for oversized recommendations.";
        } else {
            lineGuardSel.title = "";
        }
    }

    function clearSingleFormDomValues() {
        const szLen = document.getElementById("szLen");
        const szWid = document.getElementById("szWid");
        const szHei = document.getElementById("szHei");
        const szLineLen = document.getElementById("szLineLen");
        const szLineGuard = document.getElementById("szLineGuard");

        if (szLen) szLen.value = "";
        if (szWid) szWid.value = "";
        if (szHei) szHei.value = "";
        if (szLineLen) szLineLen.value = "15";
        if (szLineGuard) szLineGuard.value = "";

        document.querySelectorAll("#gbSzMountOptions .gb-acc-option").forEach(el => {
            el.classList.remove("active");
        });

        document.getElementById("szDisconnectToggle")?.classList.remove("active");
    }

    if (state.single.type === "wall") state.single.type = null;
    state.rooms.forEach(r => {
        if (r.type === "wall") r.type = null;
        if (!r.len || !r.wid || !r.height || !r.type) r.size = null;
    });
    state.rooms.forEach(r => {
        if (r.type === "wall") r.type = null;
    });
    document.getElementById("szLen").value = state.single.len || "";
    document.getElementById("szWid").value = state.single.wid || "";
    document.getElementById("szHei").value = state.single.height || "";
    document.getElementById("szLineLen").value = String(state.single.lineLen || 15);
    render();
})();